export const TimeZoneCoutries: { value: number; prefix: string; en: string; ko: string; zh: string; es: string; ru: string; ja: string; fr: string; de: string; it: string; th: string; id: string; vi: string; nl: string; pl: string; nb: string; fi: string; ar: string; }[] = [
    {
        "value": -1100,
        "prefix": "(GMT-11:00)",
        "en": "American Samoa",
        "ko": "아메리칸 사모아",
        "sc": "美属萨摩亚",
        "es": "Samoa Americana",
        "ru": "Американское Самоа",
        "ja": "アメリカ領サモア",
        "fr": "Samoa américaines",
        "de": "Amerikanischen Samoa-Inseln",
        "it": "Samoa americane",
        "th": "อเมริกันซามัว",
        "id": "Samoa Amerika",
        "vi": "Samoa thuộc Mỹ",
        "nl": "Amerikaans Samoa",
        "pl": "Samoa Amerykańskie",
        "nb": "Amerikansk Samoa",
        "fi": "Amerikan Samoa",
        "ar": "ساموا الأمريكية"
    },
    {
        "value": -1100,
        "prefix": "(GMT-11:00)",
        "en": "Niue",
        "ko": "니우에",
        "sc": "纽埃",
        "es": "Niue",
        "ru": "Ниуэ",
        "ja": "ニウエ",
        "fr": "Niué",
        "de": "Niue",
        "it": "Niue",
        "th": "นีอูเอ",
        "id": "Niue",
        "vi": "Niue",
        "nl": "Niue",
        "pl": "Niue",
        "nb": "Niue",
        "fi": "Niue",
        "ar": "نيوي"
    },
    {
        "value": -1000,
        "prefix": "(GMT-10:00)",
        "en": "Alaska (Adak, Unalaska), USA",
        "ko": "알래스카(아닥, 어날래스카), 미국",
        "sc": "阿拉斯加（阿达克、乌纳拉斯加）、美国",
        "es": "Alaska (Adak, Unalaska), EE. UU.",
        "ru": "Аляска (Адак, Уналаска), США",
        "ja": "アラスカ（アダック、ウナラスカ）、米国",
        "fr": "Alaska (Adak, Unalaska), États-Unis",
        "de": "Alaska (Adak, Unalaska), USA",
        "it": "Alaska (Adak, Unalaska), Stati Uniti",
        "th": "อลาสก้า (Adak, Unalaska), สหรัฐอเมริกา",
        "id": "Alaska (Adak, Unalaska), AS",
        "vi": "Alaska (Adak, Unalaska), Hoa Kỳ",
        "nl": "Alaska (Adak, Unalaska), VS",
        "pl": "Alaska (Adak, Unalaska), USA",
        "nb": "Alaska (Adak, Unalaska), USA",
        "fi": "Alaska (Adak, Unalaska), Yhdysvallat",
        "ar": "ألاسكا (أداك ، أونالاسكا) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -1000,
        "prefix": "(GMT-10:00)",
        "en": "Cook Islands ",
        "ko": "쿡 제도",
        "sc": "库克群岛",
        "es": "Islas Cook",
        "ru": "Острова Кука",
        "ja": "クック諸島",
        "fr": "les Îles Cook",
        "de": "Cookinseln",
        "it": "Isole Cook",
        "th": "หมู่เกาะคุก",
        "id": "Kepulauan Cook",
        "vi": "Quần đảo Cook",
        "nl": "Cook Eilanden",
        "pl": "Wyspy Cooka",
        "nb": "Cook-øyene",
        "fi": "Cook saaret",
        "ar": "جزر كوك"
    },
    {
        "value": -1000,
        "prefix": "(GMT-10:00)",
        "en": "Hawaii, USA",
        "ko": "하와이, 미국",
        "sc": "美国夏威夷",
        "es": "Hawái, EE. UU.",
        "ru": "Гавайи, США",
        "ja": "ハワイ、アメリカ",
        "fr": "Hawaï, États-Unis",
        "de": "Hawaii, USA",
        "it": "Hawaii, Stati Uniti",
        "th": "ฮาวาย สหรัฐอเมริกา",
        "id": "Hawaii, Amerika Serikat",
        "vi": "Hawaii, Hoa Kỳ",
        "nl": "Hawaï, VS",
        "pl": "Hawaje, USA",
        "nb": "Hawaii, USA",
        "fi": "Havaiji, Yhdysvallat",
        "ar": "هاواي ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -1000,
        "prefix": "(GMT-10:00)",
        "en": "French Polynesia, Tahiti Island",
        "ko": "프랑스령 폴리네시아, 타히티 섬",
        "sc": "法属波利尼西亚、大溪地",
        "es": "Polinesia Francesa, Isla Tahití",
        "ru": "Французская Полинезия, остров Таити",
        "ja": "フランス領ポリネシア、タヒチ島",
        "fr": "Polynésie française, île de Tahiti",
        "de": "Französisch-Polynesien, Insel Tahiti",
        "it": "Polinesia francese, isola di Tahiti",
        "th": "เฟรนช์โปลินีเซีย, เกาะตาฮิติ",
        "id": "Polinesia Prancis, Pulau Tahiti",
        "vi": "Polynesia thuộc Pháp, Đảo Tahiti",
        "nl": "Frans-Polynesië, Tahiti-eiland",
        "pl": "Polinezja Francuska, wyspa Tahiti",
        "nb": "Fransk Polynesia, Tahiti Island",
        "fi": "Ranskan Polynesia, Tahitin saari",
        "ar": "بولينيزيا الفرنسية ، جزيرة تاهيتي"
    },
    {
        "value": -930,
        "prefix": "(GMT-09:30)",
        "en": "French Polynesia, Marquesas Islands",
        "ko": "프랑스령 폴리네시아, 마르키즈 제도",
        "sc": "法属波利尼西亚、马克萨斯群岛",
        "es": "Polinesia Francesa, Islas Marquesas",
        "ru": "Французская Полинезия, Маркизские острова",
        "ja": "フランス領ポリネシア、マルケサス諸島",
        "fr": "Polynésie française, Îles Marquises",
        "de": "Französisch-Polynesien, Marquesas-Inseln",
        "it": "Polinesia francese, Isole Marchesi",
        "th": "เฟรนช์โปลินีเซีย, หมู่เกาะมาร์เคซัส",
        "id": "Polinesia Prancis, Kepulauan Marquesas",
        "vi": "Polynesia thuộc Pháp, Quần đảo Marquesas",
        "nl": "Frans-Polynesië, Marquesas-eilanden",
        "pl": "Polinezja Francuska, Markizy",
        "nb": "Fransk Polynesia, Marquesas-øyene",
        "fi": "Ranskan Polynesia, Marquesassaaret",
        "ar": "بولينيزيا الفرنسية ، جزر ماركيساس"
    },
    {
        "value": -900,
        "prefix": "(GMT-09:00)",
        "en": "Alaska (Juneau), USA",
        "ko": "알래스카(주노), 미국",
        "sc": "阿拉斯加（朱诺），美国",
        "es": "Alaska (Juneau), EE. UU.",
        "ru": "Аляска (Джуно), США",
        "ja": "アラスカ（ジュノー）、米国",
        "fr": "Alaska (Juneau), États-Unis",
        "de": "Alaska (Juneau), USA",
        "it": "Alaska (Juneau), Stati Uniti",
        "th": "อลาสก้า (จูโน), สหรัฐอเมริกา",
        "id": "Alaska (Juneau), AS",
        "vi": "Alaska (Juneau), Hoa Kỳ",
        "nl": "Alaska (Juneau), VS",
        "pl": "Alaska (Juneau), USA",
        "nb": "Alaska (Juneau), USA",
        "fi": "Alaska (Juneau), Yhdysvallat",
        "ar": "ألاسكا (جونو) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -900,
        "prefix": "(GMT-09:00)",
        "en": "French Polynesia, Gambier Islands",
        "ko": "프랑스령 폴리네시아, 갬비어 제도",
        "sc": "法属波利尼西亚、甘比尔群岛",
        "es": "Polinesia Francesa, Islas Gambier",
        "ru": "Французская Полинезия, острова Гамбье",
        "ja": "フランス領ポリネシア、ガンビエ諸島",
        "fr": "Polynésie française, îles Gambier",
        "de": "Französisch-Polynesien, Gambier-Inseln",
        "it": "Polinesia francese, Isole Gambier",
        "th": "เฟรนช์โปลินีเซีย, หมู่เกาะแกมเบียร์",
        "id": "Polinesia Prancis, Kepulauan Gambier",
        "vi": "Polynesia thuộc Pháp, Quần đảo Gambier",
        "nl": "Frans-Polynesië, Gambiereilanden",
        "pl": "Polinezja Francuska, Wyspy Gambier",
        "nb": "Fransk Polynesia, Gambierøyene",
        "fi": "Ranskan Polynesia, Gambier-saaret",
        "ar": "بولينيزيا الفرنسية ، جزر غامبير"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "Alaska (Metlakatla Indian Community), USA",
        "ko": "알래스카(메틀라카틀라 인디언 커뮤니티), 미국",
        "sc": "阿拉斯加（梅特拉卡特拉印第安社区），美国",
        "es": "Alaska (Comunidad indígena de Metlakatla), EE. UU.",
        "ru": "Аляска (индейская община Метлакатла), США",
        "ja": "アラスカ（メトラカットラインディアンコミュニティ）、アメリカ",
        "fr": "Alaska (Communauté indienne Metlakatla), États-Unis",
        "de": "Alaska (Indianergemeinde Metlakatla), USA",
        "it": "Alaska (Comunità indiana Metlakatla), Stati Uniti",
        "th": "อลาสก้า (ชุมชนอินเดียเมตลาคัทลา), สหรัฐอเมริกา",
        "id": "Alaska (Komunitas India Metlakatla), AS",
        "vi": "Alaska (Cộng đồng người da đỏ Metlakatla), Hoa Kỳ",
        "nl": "Alaska (Indische Gemeenschap Metlakatla), VS",
        "pl": "Alaska (Wspólnota Indian Metlakatla), USA",
        "nb": "Alaska (Metlakatla Indian Community), USA",
        "fi": "Alaska (Metlakatlan intiaaniyhteisö), USA",
        "ar": "ألاسكا (مجتمع ميتلاكاتلا الهندي) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "British Columbia (Victoria), Canada",
        "ko": "브리티시 컬럼비아(빅토리아), 캐나다",
        "sc": "加拿大不列颠哥伦比亚省（维多利亚）",
        "es": "Columbia Británica (Victoria), Canadá",
        "ru": "Британская Колумбия (Виктория), Канада",
        "ja": "ブリティッシュコロンビア（ビクトリア）、カナダ",
        "fr": "Colombie-Britannique (Victoria), Canada",
        "de": "British Columbia (Victoria), Kanada",
        "it": "Columbia Britannica (Vittoria), Canada",
        "th": "บริติชโคลัมเบีย (วิกตอเรีย), แคนาดา",
        "id": "British Columbia (Victoria), Kanada",
        "vi": "British Columbia (Victoria), Canada",
        "nl": "Brits-Columbia (Victoria), Canada",
        "pl": "Kolumbia Brytyjska (Victoria), Kanada",
        "nb": "Britisk Columbia (Victoria), Canada",
        "fi": "Brittiläinen Kolumbia (Victoria), Kanada",
        "ar": "كولومبيا البريطانية (فيكتوريا) ، كندا"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "California, USA",
        "ko": "캘리포니아, 미국",
        "sc": "美国加利福尼亚州",
        "es": "California, EE.UU",
        "ru": "Калифорния, США",
        "ja": "米国カリフォルニア州",
        "fr": "Californie, États-Unis",
        "de": "Kalifornien, USA",
        "it": "California, Stati Uniti",
        "th": "แคลิฟอร์เนีย สหรัฐอเมริกา",
        "id": "California, AS",
        "vi": "California, Hoa Kỳ",
        "nl": "Californië, VS",
        "pl": "Kalifornia, USA",
        "nb": "California, USA",
        "fi": "Kalifornia, Yhdysvallat",
        "ar": "كاليفورنيا، الولايات المتحدة الأمريكية"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "Idaho(Coeur d'Alene), USA",
        "ko": "아이다호(코어 드얼린), 미국 ",
        "sc": "美国爱达荷州（科达伦）",
        "es": "Idaho (Coeur d'Alene), EE. UU.",
        "ru": "Айдахо (Кёр д'Ален), США",
        "ja": "アイダホ（コーダレーン）、アメリカ",
        "fr": "Idaho (Coeur d'Alene), États-Unis",
        "de": "Idaho (Coeur d’Alene), USA",
        "it": "Idaho (Coeur d'Alene), Stati Uniti",
        "th": "ไอดาโฮ(Coeur d'Alene), สหรัฐอเมริกา",
        "id": "Idaho (Coeur d'Alene), AS",
        "vi": "Idaho (Coeur d'Alene), Hoa Kỳ",
        "nl": "Idaho (Coeur d'Alene), VS",
        "pl": "Idaho (Coeur d'Alene), USA",
        "nb": "Idaho (Coeur d'Alene), USA",
        "fi": "Idaho (Coeur d'Alene), Yhdysvallat",
        "ar": "أيداهو (Coeur d'Alene) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "State of Baja California, Mexico",
        "ko": "바하칼리포르니아주, 멕시코",
        "sc": "墨西哥下加利福尼亚州",
        "es": "Estado de Baja California, México",
        "ru": "Штат Нижняя Калифорния, Мексика",
        "ja": "メキシコ、バハカリフォルニア州",
        "fr": "État de Basse-Californie, Mexique",
        "de": "Bundesstaat Baja California, Mexiko",
        "it": "Stato della Bassa California, Messico",
        "th": "รัฐบาฮากาลิฟอร์เนีย เม็กซิโก",
        "id": "Negara Bagian Baja California, Meksiko",
        "vi": "Bang Baja California, México",
        "nl": "Staat Baja California, Mexico",
        "pl": "Stan Kalifornia Dolna, Meksyk",
        "nb": "Delstaten Baja California, Mexico",
        "fi": "Baja Californian osavaltio, Meksiko",
        "ar": "ولاية باجا كاليفورنيا ، المكسيك"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "Pitcairn Islands",
        "ko": "핏케언 제도",
        "sc": "皮特凯恩群岛",
        "es": "Islas Pitcairn",
        "ru": "Острова Питкэрн",
        "ja": "ピトケアン諸島",
        "fr": "Îles Pitcairn",
        "de": "Pitcairn-Inseln",
        "it": "Isole Pitcairn",
        "th": "หมู่เกาะพิตแคร์น",
        "id": "Kepulauan Pitcairn",
        "vi": "Quần đảo Pitcairn",
        "nl": "Pitcairneilanden",
        "pl": "Wyspy Pitcairn",
        "nb": "Pitcairnøyene",
        "fi": "Pitcairnin saaret",
        "ar": "جزر بيتكيرن"
    },
    {
        "value": -800,
        "prefix": "(GMT-08:00)",
        "en": "Washington, USA",
        "ko": "워싱턴, 미국",
        "sc": "华盛顿州",
        "es": "Washington (estado)",
        "ru": "Вашингтон (штат)",
        "ja": "米国ワシントン州",
        "fr": "Washington, États-Unis",
        "de": "Washington, USA",
        "it": "Washington, Stati Uniti",
        "th": "วอชิงตัน สหรัฐอเมริกา",
        "id": "Washington, AS",
        "vi": "Washington, Hoa Kỳ",
        "nl": "Washington, VS",
        "pl": "Waszyngton, USA",
        "nb": "Washington, USA",
        "fi": "Washington, Yhdysvallat",
        "ar": "واشنطن ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Alberta, Canada",
        "ko": "앨버타, 캐나다 ",
        "sc": "加拿大艾伯塔省",
        "es": "Alberta, Canadá",
        "ru": "Альберта, Канада",
        "ja": "カナダ、アルバータ州",
        "fr": "Alberta, Canada",
        "de": "Alberta, Kanada",
        "it": "Alberta, Canada",
        "th": "อัลเบอร์ตา แคนาดา",
        "id": "Alberta, Kanada",
        "vi": "Alberta Canada",
        "nl": "Alberta, Canada",
        "pl": "Alberta, Kanada",
        "nb": "Alberta, Canada",
        "fi": "Alberta, Kanada",
        "ar": "ألبرتا ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Arizona (Phoenix), USA",
        "ko": "애리조나(피닉스), 미국",
        "sc": "美国亚利桑那州（凤凰城）",
        "es": "Arizona (Phoenix), EE. UU.",
        "ru": "Аризона (Феникс), США",
        "ja": "アリゾナ（フェニックス）、米国",
        "fr": "Arizona (Phœnix), États-Unis",
        "de": "Arizona (Phönix), USA",
        "it": "Arizona (Fenice), Stati Uniti",
        "th": "แอริโซนา (ฟีนิกซ์) สหรัฐอเมริกา",
        "id": "Arizona (Phoenix), AS",
        "vi": "Arizona (Phoenix), Hoa Kỳ",
        "nl": "Arizona (Phoenix), VS",
        "pl": "Arizona (Feniks), USA",
        "nb": "Arizona (Phoenix), USA",
        "fi": "Arizona (Phoenix), Yhdysvallat",
        "ar": "أريزونا (فينيكس) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "British Columbia (Peace River District), Canada",
        "ko": "브리티시 컬럼비아(피스 리버 지구), 캐나다 ",
        "sc": "加拿大不列颠哥伦比亚省（和平河区）",
        "es": "Columbia Británica (Distrito de Peace River), Canadá",
        "ru": "Британская Колумбия (район Пис-Ривер), Канада",
        "ja": "ブリティッシュコロンビア（ピースリバー地区）、カナダ",
        "fr": "Colombie-Britannique (District de Peace River), Canada",
        "de": "British Columbia (Peace River District), Kanada",
        "it": "Columbia Britannica (distretto del fiume Peace), Canada",
        "th": "บริติชโคลัมเบีย (เขตพีซริเวอร์), แคนาดา",
        "id": "British Columbia (Distrik Sungai Perdamaian), Kanada",
        "vi": "British Columbia (Quận sông Hòa bình), Canada",
        "nl": "Brits-Columbia (Peace River District), Canada",
        "pl": "Kolumbia Brytyjska (Peace River District), Kanada",
        "nb": "British Columbia (Peace River District), Canada",
        "fi": "Brittiläinen Kolumbia (Peace River District), Kanada",
        "ar": "كولومبيا البريطانية (منطقة نهر السلام) ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "British Columbia (Central Kootenay District), Canada",
        "ko": "브리티시 컬럼비아(중앙 쿠트니 지구), 캐나다",
        "sc": "加拿大不列颠哥伦比亚省（中央库特尼区）",
        "es": "Columbia Británica (Distrito Central de Kootenay), Canadá",
        "ru": "Британская Колумбия (Центральный округ Кутеней), Канада",
        "ja": "ブリティッシュコロンビア（セントラルクートニー地区）、カナダ",
        "fr": "Colombie-Britannique (district central de Kootenay), Canada",
        "de": "British Columbia (Central Kootenay District), Kanada",
        "it": "Columbia Britannica (Distretto centrale di Kootenay), Canada",
        "th": "บริติชโคลัมเบีย (เขตเซ็นทรัลคูทเนย์), แคนาดา",
        "id": "British Columbia (Distrik Kootenay Tengah), Kanada",
        "vi": "British Columbia (Quận Trung tâm Kootenay), Canada",
        "nl": "Brits-Columbia (Central Kootenay District), Canada",
        "pl": "Kolumbia Brytyjska (Central Kootenay District), Kanada",
        "nb": "British Columbia (Central Kootenay District), Canada",
        "fi": "Brittiläinen Kolumbia (Central Kootenay District), Kanada",
        "ar": "كولومبيا البريطانية (منطقة كوتيناي الوسطى) ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "British Columbia (East Kootenay District and Columbia Valley), Canada",
        "ko": "브리티시 컬럼비아(이스트 쿠트니 지구 및 컬럼비아 밸리), 캐나다",
        "sc": "加拿大不列颠哥伦比亚省（东库特尼区和哥伦比亚谷）",
        "es": "Columbia Británica (Distrito de East Kootenay y Valle de Columbia), Canadá",
        "ru": "Британская Колумбия (Восточный округ Кутеней и долина Колумбия), Канада",
        "ja": "ブリティッシュコロンビア（イーストクートニー地区とコロンビアバレー）、カナダ",
        "fr": "Colombie-Britannique (district d'East Kootenay et vallée du Columbia), Canada",
        "de": "British Columbia (East Kootenay District und Columbia Valley), Kanada",
        "it": "Columbia Britannica (distretto di Kootenay orientale e Columbia Valley), Canada",
        "th": "บริติชโคลัมเบีย (เขต East Kootenay และ Columbia Valley), แคนาดา",
        "id": "British Columbia (Distrik Kootenay Timur dan Lembah Columbia), Kanada",
        "vi": "British Columbia (Quận Đông Kootenay và Thung lũng Columbia), Canada",
        "nl": "British Columbia (East Kootenay District en Columbia Valley), Canada",
        "pl": "Kolumbia Brytyjska (East Kootenay District i Columbia Valley), Kanada",
        "nb": "British Columbia (East Kootenay District og Columbia Valley), Canada",
        "fi": "Brittiläinen Kolumbia (East Kootenay District ja Columbia Valley), Kanada",
        "ar": "كولومبيا البريطانية (مقاطعة إيست كوتيناي ووادي كولومبيا) ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Colorado, USA",
        "ko": "콜로라도, 미국 ",
        "sc": "美国科罗拉多州",
        "es": "Colorado, EE. UU.",
        "ru": "Колорадо, США",
        "ja": "米国コロラド州",
        "fr": "Colorado, États-Unis",
        "de": "Colorado, USA",
        "it": "Colorado, Stati Uniti",
        "th": "โคโลราโด สหรัฐอเมริกา",
        "id": "Colorado, Amerika Serikat",
        "vi": "Colorado, Hoa Kỳ",
        "nl": "Colorado, VS",
        "pl": "Kolorado, USA",
        "nb": "Colorado, USA",
        "fi": "Colorado, USA",
        "ar": "كولورادو ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Idaho (Boise), USA",
        "ko": "아이다호(보이시), 미국 ",
        "sc": "美国爱达荷州（博伊西）",
        "es": "Idaho (Boise), EE. UU.",
        "ru": "Айдахо (Бойсе), США",
        "ja": "アイダホ（ボイジー）、アメリカ",
        "fr": "Idaho (Boise), États-Unis",
        "de": "Idaho (Boise), USA",
        "it": "Idaho (Boise), Stati Uniti",
        "th": "ไอดาโฮ (บอยซี), สหรัฐอเมริกา",
        "id": "Idaho (Boise), AS",
        "vi": "Idaho (Boise), Hoa Kỳ",
        "nl": "Idaho (Boise), VS",
        "pl": "Idaho (Boise), USA",
        "nb": "Idaho (Boise), USA",
        "fi": "Idaho (Boise), Yhdysvallat",
        "ar": "ايداهو (بويز) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Kansas (Goodland), USA",
        "ko": "캔자스(굿랜드), 미국",
        "sc": "美国堪萨斯州（古德兰）",
        "es": "Kansas (Goodland), EE. UU.",
        "ru": "Канзас (Гудленд), США",
        "ja": "カンザス（グッドランド）、米国",
        "fr": "Kansas (Goodland), États-Unis",
        "de": "Kansas (Goodland), USA",
        "it": "Kansas (Goodland), Stati Uniti",
        "th": "แคนซัส (กู๊ดแลนด์), สหรัฐอเมริกา",
        "id": "Kansas (Goodland), AS",
        "vi": "Kansas (Goodland), Hoa Kỳ",
        "nl": "Kansas (Goodland), VS",
        "pl": "Kansas (Goodland), USA",
        "nb": "Kansas (Goodland), USA",
        "fi": "Kansas (Goodland), Yhdysvallat",
        "ar": "كانساس (جودلاند) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Chihuahua, Mexico",
        "ko": "치와와, 멕시코 ",
        "sc": "墨西哥奇瓦瓦",
        "es": "Chihuahua, México",
        "ru": "Чиуауа, Мексика",
        "ja": "メキシコ、チワワ",
        "fr": "Chihuahua, Mexique",
        "de": "Chihuahua, Mexiko",
        "it": "Chihuahua, Messico",
        "th": "ชีวาวา, เม็กซิโก",
        "id": "Chihuahua, Meksiko",
        "vi": "Chihuahua, México",
        "nl": "Chihuahua, Mexico",
        "pl": "Chihuahua, Meksyk",
        "nb": "Chihuahua, Mexico",
        "fi": "Chihuahua, Meksiko",
        "ar": "شيواوا ، المكسيك"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Nayarit, Mexico",
        "ko": "나야리트, 멕시코 ",
        "sc": "墨西哥纳亚里特",
        "es": "Nayarit, México",
        "ru": "Наярит, Мексика",
        "ja": "メキシコ、ナヤリト",
        "fr": "Nayarit, Mexique",
        "de": "Nayarit, Mexiko",
        "it": "Nayarit, Messico",
        "th": "นายาริต, เม็กซิโก",
        "id": "Nayarit, Meksiko",
        "vi": "Nayarit, México",
        "nl": "Nayarit, Mexico",
        "pl": "Nayarit, Meksyk",
        "nb": "Nayarit, Mexico",
        "fi": "Nayarit, Meksiko",
        "ar": "ناياريت ، المكسيك"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Sinaloa, Mexico",
        "ko": "시날로아, 멕시코 ",
        "sc": "墨西哥锡那罗亚",
        "es": "Sinaloa, México",
        "ru": "Синалоа, Мексика",
        "ja": "メキシコ、シナロア州",
        "fr": "Sinaloa, Mexique",
        "de": "Sinaloa, Mexiko",
        "it": "Sinaloa, Messico",
        "th": "ซีนาโลอา, เม็กซิโก",
        "id": "Sinaloa, Meksiko",
        "vi": "Sinaloa, México",
        "nl": "Sinaloa, Mexico",
        "pl": "Sinaloa, Meksyk",
        "nb": "Sinaloa, Mexico",
        "fi": "Sinaloa, Meksiko",
        "ar": "سينالوا ، المكسيك"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "States of Baja California Sur, Mexico",
        "ko": "바하칼리포르니아수르주, 멕시코 ",
        "sc": "墨西哥南下加利福尼亚州",
        "es": "Estados de Baja California Sur, México",
        "ru": "Штаты Южная Нижняя Калифорния, Мексика",
        "ja": "メキシコ、バハカリフォルニアスル州",
        "fr": "États de Basse-Californie du Sud, Mexique",
        "de": "Staaten von Baja California Sur, Mexiko",
        "it": "Stati della Bassa California Sur, Messico",
        "th": "รัฐบาฮากาลิฟอร์เนียซูร์ ประเทศเม็กซิโก",
        "id": "Negara Bagian Baja California Sur, Meksiko",
        "vi": "Bang Baja California Sur, México",
        "nl": "Staten van Baja California Sur, Mexico",
        "pl": "Stany Baja California Sur, Meksyk",
        "nb": "Delstatene Baja California Sur, Mexico",
        "fi": "Baja California Surin osavaltiot, Meksiko",
        "ar": "ولايات باجا كاليفورنيا سور ، المكسيك"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "State of Sonora, Mexico",
        "ko": "소노라 주, 멕시코 ",
        "sc": "墨西哥索诺拉州",
        "es": "Estado de Sonora, México",
        "ru": "Штат Сонора, Мексика",
        "ja": "メキシコ、ソノラ州",
        "fr": "État de Sonora, Mexique",
        "de": "Bundesstaat Sonora, Mexiko",
        "it": "Stato di Sonora, Messico",
        "th": "รัฐโซโนรา ประเทศเม็กซิโก",
        "id": "Negara Bagian Sonora, Meksiko",
        "vi": "Bang Sonora, México",
        "nl": "Staat Sonora, Mexico",
        "pl": "Stan Sonora, Meksyk",
        "nb": "Delstaten Sonora, Mexico",
        "fi": "Sonoran osavaltio, Meksiko",
        "ar": "ولاية سونورا ، المكسيك"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Montana, USA",
        "ko": "몬태나, 미국 ",
        "sc": "美国蒙大拿州",
        "es": "Montana, EE. UU.",
        "ru": "Монтана, США",
        "ja": "米国モンタナ州",
        "fr": "Montana, États-Unis",
        "de": "Montana, USA",
        "it": "Montana, Stati Uniti",
        "th": "มอนแทนา สหรัฐอเมริกา",
        "id": "Montana, AS",
        "vi": "Montana, Hoa Kỳ",
        "nl": "Montana, VS",
        "pl": "Montana, USA",
        "nb": "Montana, USA",
        "fi": "Montana, Yhdysvallat",
        "ar": "مونتانا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Nebraska (Scottsbluff), USA",
        "ko": "네브래스카(스코츠블러프), 미국 ",
        "sc": "美国内布拉斯加州（斯科茨布拉夫）",
        "es": "Nebraska (Scottsbluff), EE. UU.",
        "ru": "Небраска (Скоттсблафф), США",
        "ja": "ネブラスカ（スコッツブラフ）、米国",
        "fr": "Nebraska (Scottsbluff), États-Unis",
        "de": "Nebraska (Scottsbluff), USA",
        "it": "Nebraska (Scottsbluff), Stati Uniti",
        "th": "เนบราสก้า (สกอตส์บลัฟฟ์), สหรัฐอเมริกา",
        "id": "Nebraska (Scottsbluff), AS",
        "vi": "Nebraska (Scottsbluff), Hoa Kỳ",
        "nl": "Nebraska (Scottsbluff), VS",
        "pl": "Nebraska (Scottsbluff), USA",
        "nb": "Nebraska (Scottsbluff), USA",
        "fi": "Nebraska (Scottsbluff), Yhdysvallat",
        "ar": "نبراسكا (سكوتسبلوف) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Nevada (West Wendover), USA",
        "ko": "네바다주(웨스트 웬도버), 미국 ",
        "sc": "美国内华达州（西温多弗）",
        "es": "Nevada (West Wendover), EE. UU.",
        "ru": "Невада (Западный Вендовер), США",
        "ja": "ネバダ州（ウェストウェンドーバー）、米国",
        "fr": "Nevada (West Wendover), États-Unis",
        "de": "Nevada (West-Wendover), USA",
        "it": "Nevada (West Wendover), Stati Uniti",
        "th": "เนวาดา (เวสต์เวนโดเวอร์), สหรัฐอเมริกา",
        "id": "Nevada (Wendover Barat), AS",
        "vi": "Nevada (West Wendover), Hoa Kỳ",
        "nl": "Nevada (West Wendover), VS",
        "pl": "Nevada (West Wendover), USA",
        "nb": "Nevada (West Wendover), USA",
        "fi": "Nevada (West Wendover), Yhdysvallat",
        "ar": "نيفادا (ويست ويندوفر) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "New Mexico, USA",
        "ko": "뉴멕시코, 미국 ",
        "sc": "美国新墨西哥州",
        "es": "Nuevo México, EE. UU.",
        "ru": "Нью-Мексико, США",
        "ja": "ニューメキシコ、米国",
        "fr": "Nouveau-Mexique, États-Unis",
        "de": "New Mexiko, USA",
        "it": "Nuovo Messico, Stati Uniti",
        "th": "นิวเม็กซิโก สหรัฐอเมริกา",
        "id": "New Mexico, AS",
        "vi": "New Mexico, Hoa Kỳ",
        "nl": "New Mexico, VS",
        "pl": "Nowy Meksyk, USA",
        "nb": "New Mexico, USA",
        "fi": "New Mexico, Yhdysvallat",
        "ar": "نيو مكسيكو ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "North Dakota (Dickinson), USA",
        "ko": "노스다코타(디킨슨), 미국 ",
        "sc": "美国北达科他州（迪金森）",
        "es": "Dakota del Norte (Dickinson), EE. UU.",
        "ru": "Северная Дакота (Дикинсон), США",
        "ja": "ノースダコタ州（ディキンソン）、米国",
        "fr": "Dakota du Nord (Dickinson), États-Unis",
        "de": "North Dakota (Dickinson), USA",
        "it": "Dakota del Nord (Dickinson), Stati Uniti",
        "th": "นอร์ทดาโคตา (ดิกคินสัน), สหรัฐอเมริกา",
        "id": "Dakota Utara (Dickinson), AS",
        "vi": "North Dakota (Dickinson), Hoa Kỳ",
        "nl": "North Dakota (Dickinson), VS",
        "pl": "Dakota Północna (Dickinson), USA",
        "nb": "North Dakota (Dickinson), USA",
        "fi": "Pohjois-Dakota (Dickinson), Yhdysvallat",
        "ar": "داكوتا الشمالية (ديكنسون) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Northwest Territories, Canada",
        "ko": "노스웨스트 준주, 캐나다 ",
        "sc": "加拿大西北地区",
        "es": "Territorios del Noroeste, Canadá",
        "ru": "Северо-Западные территории, Канада",
        "ja": "カナダ、ノースウェスト準州",
        "fr": "Territoires du Nord-Ouest, Canada",
        "de": "Nordwest-Territorien, Kanada",
        "it": "Territori del Nordovest, Canada",
        "th": "นอร์ทเวสต์เทร์ริทอรีส์ แคนาดา",
        "id": "Wilayah Barat Laut, Kanada",
        "vi": "Lãnh thổ Tây Bắc, Canada",
        "nl": "Northwest Territories, Canada",
        "pl": "Terytoria Północno-Zachodnie, Kanada",
        "nb": "Northwest Territories, Canada",
        "fi": "Northwest Territories, Kanada",
        "ar": "الأقاليم الشمالية الغربية ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Nunavut (Cambridge Bay), Canada",
        "ko": "누나부트(캠브리지 베이), 캐나다",
        "sc": "加拿大努纳武特（剑桥湾）",
        "es": "Nunavut (Bahía de Cambridge), Canadá",
        "ru": "Нунавут (Кембриджский залив), Канада",
        "ja": "ヌナブト準州（ケンブリッジベイ）、カナダ",
        "fr": "Nunavut (Cambridge Bay), Canada",
        "de": "Nunavut (Cambridge Bay), Kanada",
        "it": "Nunavut (Baia di Cambridge), Canada",
        "th": "นูนาวุต (เคมบริดจ์เบย์), แคนาดา",
        "id": "Nunavut (Teluk Cambridge), Kanada",
        "vi": "Nunavut (Vịnh Cambridge), Canada",
        "nl": "Nunavut (Cambridge Bay), Canada",
        "pl": "Nunavut (Cambridge Bay), Kanada",
        "nb": "Nunavut (Cambridge Bay), Canada",
        "fi": "Nunavut (Cambridge Bay), Kanada",
        "ar": "نونافوت (كامبردج باي) ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Oregon (Ontario), USA",
        "ko": "오리건(온타리오), 미국 ",
        "sc": "美国俄勒冈州（安大略省）",
        "es": "Oregón (Ontario), EE. UU.",
        "ru": "Орегон (Онтарио), США",
        "ja": "オレゴン（オンタリオ州）、米国",
        "fr": "Oregon (Ontario), États-Unis",
        "de": "Oregon (Ontario), USA",
        "it": "Oregon (Ontario), Stati Uniti",
        "th": "โอเรกอน (ออนแทรีโอ), สหรัฐอเมริกา",
        "id": "Oregon (Ontario), AS",
        "vi": "Oregon (Ontario), Hoa Kỳ",
        "nl": "Oregon (Ontario), VS",
        "pl": "Oregon (Ontario), USA",
        "nb": "Oregon (Ontario), USA",
        "fi": "Oregon (Ontario), Yhdysvallat",
        "ar": "أوريغون (أونتاريو) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Saskatchewan (Lloydminster), Canada",
        "ko": "서스캐처원(로이드민스터), 캐나다",
        "sc": "加拿大萨斯喀彻温省（劳埃德明斯特）",
        "es": "Saskatchewan (Lloydminster), Canadá",
        "ru": "Саскачеван (Ллойдминстер), Канада",
        "ja": "サスカチュワン（ロイドミンスター）、カナダ",
        "fr": "Saskatchewan (Lloydminster), Canada",
        "de": "Saskatchewan (Lloydminster), Kanada",
        "it": "Saskatchewan (Lloydminster), Canada",
        "th": "ซัสแคตเชวัน (ลอยด์มินสเตอร์), แคนาดา",
        "id": "Saskatchewan (Lloydminster), Kanada",
        "vi": "Saskatchewan (Lloydminster), Canada",
        "nl": "Saskatchewan (Lloydminster), Canada",
        "pl": "Saskatchewan (Lloydminster), Kanada",
        "nb": "Saskatchewan (Lloydminster), Canada",
        "fi": "Saskatchewan (Lloydminster), Kanada",
        "ar": "ساسكاتشوان (لويدمينستر) ، كندا"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "South Dakota (Rapid City), USA",
        "ko": "미국 사우스다코타주(래피드시티)",
        "sc": "美国南达科他州（拉皮德城）",
        "es": "Dakota del Sur (Rapid City), EE. UU.",
        "ru": "Южная Дакота (Рапид-Сити), США",
        "ja": "サウスダコタ州（ラピッドシティー）、アメリカ",
        "fr": "Dakota du Sud (Rapid City), États-Unis",
        "de": "South Dakota (Schnelle Stadt), USA",
        "it": "Dakota del Sud (Città Rapida), Stati Uniti",
        "th": "เซาท์ดาโคตา (แรพิดซิตี), สหรัฐอเมริกา",
        "id": "South Dakota (Kota Cepat), AS",
        "vi": "Nam Dakota (Thành phố Rapid), Hoa Kỳ",
        "nl": "South Dakota (Rapid City), VS",
        "pl": "Dakota Południowa (Rapid City), USA",
        "nb": "South Dakota (Rapid City), USA",
        "fi": "Etelä-Dakota (Rapid City), Yhdysvallat",
        "ar": "داكوتا الجنوبية (رابيد سيتي) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Texas (El Paso), USA",
        "ko": "텍사스(엘파소), 미국",
        "sc": "美国德克萨斯州（埃尔帕索）",
        "es": "Texas (El Paso), EE. UU.",
        "ru": "Техас (Эль-Пасо), США",
        "ja": "テキサス（エルパソ）、米国",
        "fr": "Texas (El Paso), États-Unis",
        "de": "Texas (El Paso), USA",
        "it": "Texas (El Paso), Stati Uniti",
        "th": "เท็กซัส (เอลพาโซ), สหรัฐอเมริกา",
        "id": "Texas (El Paso), AS",
        "vi": "Texas (El Paso), Hoa Kỳ",
        "nl": "Texas (El Paso), VS",
        "pl": "Teksas (El Paso), USA",
        "nb": "Texas (El Paso), USA",
        "fi": "Texas (El Paso), Yhdysvallat",
        "ar": "تكساس (الباسو) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Utah, USA",
        "ko": "유타, 미국",
        "sc": "美国犹他州",
        "es": "Utah, EE. UU.",
        "ru": "Юта, США",
        "ja": "米国ユタ州",
        "fr": "Utah, États-Unis",
        "de": "Utah, USA",
        "it": "Utah, Stati Uniti",
        "th": "ยูทาห์ สหรัฐอเมริกา",
        "id": "Utah, AS",
        "vi": "Utah, Hoa Kỳ",
        "nl": "Utah, VS",
        "pl": "Utah, USA",
        "nb": "Utah, USA",
        "fi": "Utah, Yhdysvallat",
        "ar": "يوتا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -700,
        "prefix": "(GMT-07:00)",
        "en": "Wyoming, USA",
        "ko": "와이오밍, 미국 ",
        "sc": "美国怀俄明州",
        "es": "Wyoming, EE. UU.",
        "ru": "Вайоминг, США",
        "ja": "米国ワイオミング州",
        "fr": "Wyoming, États-Unis",
        "de": "Wyoming, USA",
        "it": "Wyoming, Stati Uniti",
        "th": "ไวโอมิง สหรัฐอเมริกา",
        "id": "Wyoming, AS",
        "vi": "Wyoming, Hoa Kỳ",
        "nl": "Wyoming, VS",
        "pl": "Wyoming, USA",
        "nb": "Wyoming, USA",
        "fi": "Wyoming, Yhdysvallat",
        "ar": "وايومنغ ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Alabama, USA",
        "ko": "앨라배마, 미국 ",
        "sc": "美国阿拉巴马州",
        "es": "Alabama, EE. UU.",
        "ru": "Алабама, США",
        "ja": "米国アラバマ州",
        "fr": "Alabama, États-Unis",
        "de": "Alabama, USA",
        "it": "Alabama, Stati Uniti",
        "th": "อลาบามา สหรัฐอเมริกา",
        "id": "Alabama, AS",
        "vi": "Alabama, Hoa Kỳ",
        "nl": "Alabama, VS",
        "pl": "Alabama, USA",
        "nb": "Alabama, USA",
        "fi": "Alabama, Yhdysvallat",
        "ar": "ألاباما ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Arkansas, USA",
        "ko": "아칸소주, 미국 ",
        "sc": "美国阿肯色州",
        "es": "Arkansas, EE. UU.",
        "ru": "Арканзас, США",
        "ja": "アーカンソー、米国",
        "fr": "Arkansas, États-Unis",
        "de": "Arkansas, USA",
        "it": "Arkansas, Stati Uniti",
        "th": "อาร์คันซอ สหรัฐอเมริกา",
        "id": "Arkansas, AS",
        "vi": "Arkansas, Hoa Kỳ",
        "nl": "Arkansas, VS",
        "pl": "Arkansas, USA",
        "nb": "Arkansas, USA",
        "fi": "Arkansas, Yhdysvallat",
        "ar": "أركنساس ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Belize",
        "ko": "벨리즈",
        "sc": "伯利兹",
        "es": "Belice",
        "ru": "Белиз",
        "ja": "ベリーズ",
        "fr": "Bélize",
        "de": "Belize",
        "it": "Belize",
        "th": "เบลีซ",
        "id": "Belize",
        "vi": "Belize",
        "nl": "Belize",
        "pl": "Belize",
        "nb": "Belize",
        "fi": "Belize",
        "ar": "بليز"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Chile, Easter Island",
        "ko": "칠레, 이스터 섬",
        "sc": "智利，复活节岛",
        "es": "Chile, Isla de Pascua",
        "ru": "Чили, остров Пасхи",
        "ja": "チリ、イースター島",
        "fr": "Chili, île de Pâques",
        "de": "Chile, Osterinsel",
        "it": "Cile, Isola di Pasqua",
        "th": "ชิลี เกาะอีสเตอร์",
        "id": "Chili, Pulau Paskah",
        "vi": "Chile, Đảo Phục sinh",
        "nl": "Chili, Paaseiland",
        "pl": "Chile, Wyspa Wielkanocna",
        "nb": "Chile, Påskeøya",
        "fi": "Chile, Pääsiäissaari",
        "ar": "شيلي ، جزيرة الفصح"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Costa Rica",
        "ko": "코스타리카",
        "sc": "哥斯达黎加",
        "es": "Costa Rica",
        "ru": "Коста-Рика",
        "ja": "コスタリカ",
        "fr": "Costa Rica",
        "de": "Costa Rica",
        "it": "Costa Rica",
        "th": "คอสตาริกา",
        "id": "Kosta Rika",
        "vi": "Costa Rica",
        "nl": "Costa Rica",
        "pl": "Kostaryka",
        "nb": "Costa Rica",
        "fi": "Costa Rica",
        "ar": "كوستا ريكا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Ecuador, Galapagos Province",
        "ko": "에콰도르, 갈라파고스 주",
        "sc": "厄瓜多尔，加拉帕戈斯省",
        "es": "Ecuador, Provincia de Galápagos",
        "ru": "Эквадор, Галапагосская провинция",
        "ja": "エクアドル、ガラパゴス州",
        "fr": "Equateur, Province des Galápagos",
        "de": "Ecuador, Provinz Galapagos",
        "it": "Ecuador, provincia delle Galapagos",
        "th": "เอกวาดอร์, จังหวัดกาลาปาโกส",
        "id": "Ekuador, Provinsi Galapagos",
        "vi": "Ecuador, tỉnh Galapagos",
        "nl": "Ecuador, Galapagos Provincie",
        "pl": "Ekwador, Prowincja Galapagos",
        "nb": "Ecuador, Galapagos-provinsen",
        "fi": "Ecuador, Galapagosin maakunta",
        "ar": "الإكوادور ، مقاطعة غالاباغوس"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "El Salvador",
        "ko": "엘살바도르",
        "sc": "萨尔瓦多",
        "es": "El Salvador",
        "ru": "Эль Сальвадор",
        "ja": "エルサルバドル",
        "fr": "Le Salvador",
        "de": "El Salvador",
        "it": "El Salvador",
        "th": "เอลซัลวาดอร์",
        "id": "El Salvador",
        "vi": "El Salvador",
        "nl": "El Salvador",
        "pl": "Salwador",
        "nb": "El Salvador",
        "fi": "El Salvador",
        "ar": "السلفادور"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Florida (Pensacola), USA",
        "ko": "플로리다(펜사콜라), 미국",
        "sc": "美国佛罗里达州（彭萨科拉）",
        "es": "Florida (Pensacola), EE. UU.",
        "ru": "Флорида (Пенсакола), США",
        "ja": "フロリダ（ペンサコーラ）、米国",
        "fr": "Floride (Pensacola), États-Unis",
        "de": "Florida (Pensacola), USA",
        "it": "Florida (Pensacola), Stati Uniti",
        "th": "ฟลอริดา (เพนซาโคลา) สหรัฐอเมริกา",
        "id": "Florida (Pensacola), AS",
        "vi": "Florida (Pensacola), Hoa Kỳ",
        "nl": "Florida (Pensacola), VS",
        "pl": "Floryda (Pensacola), USA",
        "nb": "Florida (Pensacola), USA",
        "fi": "Florida (Pensacola), Yhdysvallat",
        "ar": "فلوريدا (بينساكولا) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Guatemala",
        "ko": "과테말라",
        "sc": "危地马拉",
        "es": "Guatemala",
        "ru": "Гватемала",
        "ja": "グアテマラ",
        "fr": "Guatemala",
        "de": "Guatemala",
        "it": "Guatemala",
        "th": "กัวเตมาลา",
        "id": "Guatemala",
        "vi": "Guatemala",
        "nl": "Guatemala",
        "pl": "Gwatemala",
        "nb": "Guatemala",
        "fi": "Guatemala",
        "ar": "غواتيمالا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Honduras",
        "ko": "온두라스",
        "sc": "洪都拉斯",
        "es": "Honduras",
        "ru": "Гондурас",
        "ja": "ホンジュラス",
        "fr": "Honduras",
        "de": "Honduras",
        "it": "Honduras",
        "th": "ฮอนดูรัส",
        "id": "Honduras",
        "vi": "Honduras",
        "nl": "Honduras",
        "pl": "Honduras",
        "nb": "Honduras",
        "fi": "Honduras",
        "ar": "هندوراس"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Illinois, USA",
        "ko": "일리노이주, 미국 ",
        "sc": "美国伊利诺伊州",
        "es": "Illinois, EE. UU.",
        "ru": "Иллинойс, США",
        "ja": "イリノイ州、米国",
        "fr": "Illinois, États-Unis",
        "de": "Illinois, USA",
        "it": "Illinois, Stati Uniti",
        "th": "อิลลินอยส์ สหรัฐอเมริกา",
        "id": "Illinois, AS",
        "vi": "Illinois, Hoa Kỳ",
        "nl": "Illinois, VS",
        "pl": "Illinois, USA",
        "nb": "Illinois, USA",
        "fi": "Illinois, Yhdysvallat",
        "ar": "إلينوي ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Indiana (Evansville), USA",
        "ko": "인디애나(에반스빌), 미국",
        "sc": "美国印第安纳州（埃文斯维尔）",
        "es": "Indiana (Evansville), EE. UU.",
        "ru": "Индиана (Эвансвилл), США",
        "ja": "インディアナ（エバンズビル）、米国",
        "fr": "Indiana (Evansville), États-Unis",
        "de": "Indiana (Evansville), USA",
        "it": "Indiana (Evansville), Stati Uniti",
        "th": "อินดีแอนา (อีแวนส์วิลล์), สหรัฐอเมริกา",
        "id": "Indiana (Evansville), AS",
        "vi": "Indiana (Evansville), Hoa Kỳ",
        "nl": "Indiana (Evansville), VS",
        "pl": "Indiana (Evansville), USA",
        "nb": "Indiana (Evansville), USA",
        "fi": "Indiana (Evansville), Yhdysvallat",
        "ar": "إنديانا (إيفانسفيل) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Iowa, USA",
        "ko": "아이오와, 미국 ",
        "sc": "美国爱荷华州",
        "es": "Iowa, EE. UU.",
        "ru": "Айова, США",
        "ja": "米国アイオワ州",
        "fr": "Iowa, États-Unis",
        "de": "Iowa, USA",
        "it": "Iowa, Stati Uniti",
        "th": "ไอโอวา สหรัฐอเมริกา",
        "id": "Iowa, AS",
        "vi": "Iowa, Hoa Kỳ",
        "nl": "Iowa, VS",
        "pl": "Iowa, USA",
        "nb": "Iowa, USA",
        "fi": "Iowa, Yhdysvallat",
        "ar": "أيوا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Kansas (Topeka), USA",
        "ko": "캔자스(토피카), 미국",
        "sc": "美国堪萨斯州（托皮卡）",
        "es": "Kansas (Topeka), EE. UU.",
        "ru": "Канзас (Топека), США",
        "ja": "カンザス（トピーカ）、米国",
        "fr": "Kansas (Topeka), États-Unis",
        "de": "Kansas (Topeka), USA",
        "it": "Kansas (Topeka), Stati Uniti",
        "th": "แคนซัส (โทพีกา), สหรัฐอเมริกา",
        "id": "Kansas (Topeka), AS",
        "vi": "Kansas (Topeka), Hoa Kỳ",
        "nl": "Kansas (Topeka), VS",
        "pl": "Kansas (Topeka), USA",
        "nb": "Kansas (Topeka), USA",
        "fi": "Kansas (Topeka), Yhdysvallat",
        "ar": "كانساس (توبيكا) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Kentucky (Bowling Green), USA",
        "ko": "켄터키주(볼링 그린), 미국",
        "sc": "美国肯塔基州（鲍灵格林）",
        "es": "Kentucky (Bowling Green), EE. UU.",
        "ru": "Кентукки (Боулинг-Грин), США",
        "ja": "ケンタッキー（ボーリンググリーン）、アメリカ",
        "fr": "Kentucky (Bowling Green), États-Unis",
        "de": "Kentucky (Bowling Green), USA",
        "it": "Kentucky (Bowling Green), Stati Uniti",
        "th": "เคนตักกี้ (โบว์ลิ่งกรีน), สหรัฐอเมริกา",
        "id": "Kentucky (Bowling Green), AS",
        "vi": "Kentucky (Bowling Green), Hoa Kỳ",
        "nl": "Kentucky (Bowling Green), VS",
        "pl": "Kentucky (Bowling Green), USA",
        "nb": "Kentucky (Bowling Green), USA",
        "fi": "Kentucky (Bowling Green), Yhdysvallat",
        "ar": "كنتاكي (بولينج جرين) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Louisiana, USA",
        "ko": "루이지애나, 미국 ",
        "sc": "美国路易斯安那州",
        "es": "Luisiana, EE. UU.",
        "ru": "Луизиана, США",
        "ja": "ルイジアナ州、米国",
        "fr": "Louisiane, États-Unis",
        "de": "Louisiana, USA",
        "it": "Louisiana, Stati Uniti",
        "th": "หลุยเซียน่า สหรัฐอเมริกา",
        "id": "Louisiana, AS",
        "vi": "Louisiana, Hoa Kỳ",
        "nl": "Louisiana, VS",
        "pl": "Luizjana, USA",
        "nb": "Louisiana, USA",
        "fi": "Louisiana, Yhdysvallat",
        "ar": "لويزيانا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Manitoba, Canada",
        "ko": "매니토바, 캐나다",
        "sc": "加拿大马尼托巴",
        "es": "Manitoba, Canadá",
        "ru": "Манитоба, Канада",
        "ja": "カナダ、マニトバ州",
        "fr": "Manitoba, Canada",
        "de": "Manitoba, Kanada",
        "it": "Manitoba, Canada",
        "th": "แมนิโทบา แคนาดา",
        "id": "Manitoba, Kanada",
        "vi": "Manitoba, Canada",
        "nl": "Manitoba, Canada",
        "pl": "Manitoba, Kanada",
        "nb": "Manitoba, Canada",
        "fi": "Manitoba, Kanada",
        "ar": "مانيتوبا ، كندا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Mexico",
        "ko": "멕시코",
        "sc": "墨西哥",
        "es": "México",
        "ru": "Мексика",
        "ja": "メキシコ",
        "fr": "Mexique",
        "de": "Mexiko",
        "it": "Messico",
        "th": "เม็กซิโก",
        "id": "Meksiko",
        "vi": "México",
        "nl": "Mexico",
        "pl": "Meksyk",
        "nb": "Mexico",
        "fi": "Meksiko",
        "ar": "المكسيك"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Michigan (Iron Mountain), USA",
        "ko": "미시간(아이언 마운틴), 미국 ",
        "sc": "美国密歇根州（铁山）",
        "es": "Míchigan (Montaña de Hierro), EE. UU.",
        "ru": "Мичиган (Железная гора), США",
        "ja": "ミシガン州（アイアンマウンテン）、米国",
        "fr": "Michigan (Iron Mountain), États-Unis",
        "de": "Michigan (Eisenberg), USA",
        "it": "Michigan (Montagna di ferro), Stati Uniti",
        "th": "มิชิแกน (ภูเขาเหล็ก) สหรัฐอเมริกา",
        "id": "Michigan (Gunung Besi), AS",
        "vi": "Michigan (Núi Sắt), Hoa Kỳ",
        "nl": "Michigan (Iron Mountain), VS",
        "pl": "Michigan (Iron Mountain), USA",
        "nb": "Michigan (Iron Mountain), USA",
        "fi": "Michigan (Iron Mountain), Yhdysvallat",
        "ar": "ميشيغان (آيرون ماونتن) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Minnesota, USA",
        "ko": "미네소타, 미국 ",
        "sc": "美国明尼苏达州",
        "es": "Minnesota, EE. UU.",
        "ru": "Миннесота, США",
        "ja": "ミネソタ州、米国",
        "fr": "Minnesota, États-Unis",
        "de": "Minnesota, USA",
        "it": "Minnesota, Stati Uniti",
        "th": "มินนิโซตา สหรัฐอเมริกา",
        "id": "Minnesota, AS",
        "vi": "Minnesota, Hoa Kỳ",
        "nl": "Minnesota, VS",
        "pl": "Minnesota, USA",
        "nb": "Minnesota, USA",
        "fi": "Minnesota, Yhdysvallat",
        "ar": "مينيسوتا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Mississippi, USA",
        "ko": "미시시피, 미국 ",
        "sc": "美国密西西比州",
        "es": "Misisipi, EE. UU.",
        "ru": "Миссисипи, США",
        "ja": "ミシシッピ州、米国",
        "fr": "Mississippi, États-Unis",
        "de": "Mississippi, USA",
        "it": "Mississippi, Stati Uniti",
        "th": "มิสซิสซิปปี้ สหรัฐอเมริกา",
        "id": "Mississippi, AS",
        "vi": "Mississippi, Hoa Kỳ",
        "nl": "Mississippi, VS",
        "pl": "Missisipi, USA",
        "nb": "Mississippi, USA",
        "fi": "Mississippi, Yhdysvallat",
        "ar": "ميسيسيبي ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Missouri, USA",
        "ko": "미주리주, 미국 ",
        "sc": "美国密苏里州",
        "es": "Misuri, EE. UU.",
        "ru": "Миссури, США",
        "ja": "ミズーリ州、米国",
        "fr": "Missouri, États-Unis",
        "de": "Missouri, USA",
        "it": "Missouri, Stati Uniti",
        "th": "มิสซูรี สหรัฐอเมริกา",
        "id": "Missouri, AS",
        "vi": "Missouri, Hoa Kỳ",
        "nl": "Missouri, VS",
        "pl": "Missouri, USA",
        "nb": "Missouri, USA",
        "fi": "Missouri, Yhdysvallat",
        "ar": "ميسوري ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Nicaragua",
        "ko": "니카라과",
        "sc": "尼加拉瓜",
        "es": "Nicaragua",
        "ru": "Никарагуа",
        "ja": "ニカラグア",
        "fr": "Nicaragua",
        "de": "Nicaragua",
        "it": "Nicaragua",
        "th": "นิการากัว",
        "id": "Nikaragua",
        "vi": "Nicaragua",
        "nl": "Nicaragua",
        "pl": "Nikaragua",
        "nb": "Nicaragua",
        "fi": "Nicaragua",
        "ar": "نيكاراغوا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Nebraska (Lincoln), USA",
        "ko": "네브래스카(링컨), 미국 ",
        "sc": "美国内布拉斯加州（林肯）",
        "es": "Nebraska (Lincoln), EE. UU.",
        "ru": "Небраска (Линкольн), США",
        "ja": "ネブラスカ（リンカーン）、米国",
        "fr": "Nebraska (Lincoln), États-Unis",
        "de": "Nebraska (Lincoln), USA",
        "it": "Nebraska (Lincoln), Stati Uniti",
        "th": "เนบราสก้า (ลินคอล์น) สหรัฐอเมริกา",
        "id": "Nebraska (Lincoln), AS",
        "vi": "Nebraska (Lincoln), Hoa Kỳ",
        "nl": "Nebraska (Lincoln), VS",
        "pl": "Nebraska (Lincoln), USA",
        "nb": "Nebraska (Lincoln), USA",
        "fi": "Nebraska (Lincoln), Yhdysvallat",
        "ar": "نبراسكا (لينكولن) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "North Dakota (Bismarck), USA",
        "ko": "노스다코타(비스마르크), 미국 ",
        "sc": "美国北达科他州（俾斯麦）",
        "es": "Dakota del Norte (Bismarck), EE. UU.",
        "ru": "Северная Дакота (Бисмарк), США",
        "ja": "ノースダコタ州（ビスマルク）、米国",
        "fr": "Dakota du Nord (Bismarck), États-Unis",
        "de": "North Dakota (Bismarck), USA",
        "it": "Dakota del Nord (Bismarck), Stati Uniti",
        "th": "รัฐนอร์ทดาโคตา (บิสมาร์ก), สหรัฐอเมริกา",
        "id": "Dakota Utara (Bismarck), AS",
        "vi": "North Dakota (Bismarck), Hoa Kỳ",
        "nl": "North Dakota (Bismarck), VS",
        "pl": "Dakota Północna (Bismarck), USA",
        "nb": "North Dakota (Bismarck), USA",
        "fi": "Pohjois-Dakota (Bismarck), Yhdysvallat",
        "ar": "داكوتا الشمالية (بسمارك) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Nunavut (Baker Lake), Canada",
        "ko": "누나부트(베이커 호수), 캐나다",
        "sc": "加拿大努纳武特（贝克湖）",
        "es": "Nunavut (lago Baker), Canadá",
        "ru": "Нунавут (Бейкер-Лейк), Канада",
        "ja": "カナダ、ヌナブト準州（ベーカーレイク）",
        "fr": "Nunavut (Baker Lake), Canada",
        "de": "Nunavut (Baker Lake), Kanada",
        "it": "Nunavut (Lago Baker), Canada",
        "th": "นูนาวุต (เบเกอร์เลค), แคนาดา",
        "id": "Nunavut (Danau Baker), Kanada",
        "vi": "Nunavut (Hồ Baker), Canada",
        "nl": "Nunavut (Baker Lake), Canada",
        "pl": "Nunavut (Jezioro Baker), Kanada",
        "nb": "Nunavut (Baker Lake), Canada",
        "fi": "Nunavut (Baker Lake), Kanada",
        "ar": "نونافوت (بحيرة بيكر) ، كندا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Oklahoma, USA",
        "ko": "오클라호마, 미국 ",
        "sc": "美国俄克拉荷马州",
        "es": "Oklahoma, EE. UU.",
        "ru": "Оклахома, США",
        "ja": "米国オクラホマ州",
        "fr": "Oklahoma, États-Unis",
        "de": "Oklahoma, USA",
        "it": "Oklahoma, Stati Uniti",
        "th": "โอคลาโฮมา สหรัฐอเมริกา",
        "id": "Oklahoma, AS",
        "vi": "Oklahoma, Hoa Kỳ",
        "nl": "Oklahoma, VS",
        "pl": "Oklahoma, USA",
        "nb": "Oklahoma, USA",
        "fi": "Oklahoma, Yhdysvallat",
        "ar": "أوكلاهوما ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Ontario (western part of Northwestern Ontario), Canada",
        "ko": "온타리오주(온타리오주 북서부 서부), 캐나다",
        "sc": "安大略省（安大略省西北部的西部），加拿大",
        "es": "Ontario (parte occidental del noroeste de Ontario), Canadá",
        "ru": "Онтарио (западная часть Северо-Западного Онтарио), Канада",
        "ja": "オンタリオ州（北西オンタリオ州の西部）、カナダ",
        "fr": "Ontario (partie ouest du nord-ouest de l'Ontario), Canada",
        "de": "Ontario (westlicher Teil des Nordwestens von Ontario), Kanada",
        "it": "Ontario (parte occidentale dell'Ontario nordoccidentale), Canada",
        "th": "ออนแทรีโอ (ทางตะวันตกของออนแทรีโอตะวันตกเฉียงเหนือ), แคนาดา",
        "id": "Ontario (bagian barat Ontario Barat Laut), Kanada",
        "vi": "Ontario (phần phía tây của Tây Bắc Ontario), Canada",
        "nl": "Ontario (westelijk deel van Noordwest-Ontario), Canada",
        "pl": "Ontario (zachodnia część północno-zachodniego Ontario), Kanada",
        "nb": "Ontario (vestlige delen av Nordvestlige Ontario), Canada",
        "fi": "Ontario (Länsiosa Luoteis-Ontariosta), Kanada",
        "ar": "أونتاريو (الجزء الغربي من شمال غرب أونتاريو) ، كندا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Saskatchewan (Regina), Canada",
        "ko": "서스캐처원(레지나), 캐나다",
        "sc": "加拿大萨斯喀彻温省（里贾纳）",
        "es": "Saskatchewan (Regina), Canadá",
        "ru": "Саскачеван (Регина), Канада",
        "ja": "サスカチュワン（レジーナ）、カナダ",
        "fr": "Saskatchewan (Régina), Canada",
        "de": "Saskatchewan (Regina), Kanada",
        "it": "Saskatchewan (Regina), Canada",
        "th": "ซัสแคตเชวัน (Regina), แคนาดา",
        "id": "Saskatchewan (Regina), Kanada",
        "vi": "Saskatchewan (Regina), Canada",
        "nl": "Saskatchewan (Regina), Canada",
        "pl": "Saskatchewan (Regina), Kanada",
        "nb": "Saskatchewan (Regina), Canada",
        "fi": "Saskatchewan (Regina), Kanada",
        "ar": "ساسكاتشوان (ريجينا) ، كندا"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "South Dakota (Pierre), USA",
        "ko": "사우스다코타주(피에르), 미국 ",
        "sc": "美国南达科他州（皮埃尔）",
        "es": "Dakota del Sur (Pierre), EE. UU.",
        "ru": "Южная Дакота (Пьер), США",
        "ja": "サウスダコタ州（ピエール）、アメリカ",
        "fr": "Dakota du Sud (Pierre), États-Unis",
        "de": "South Dakota (Pierre), USA",
        "it": "Dakota del Sud (Pierre), Stati Uniti",
        "th": "เซาท์ดาโคตา (ปิแอร์), สหรัฐอเมริกา",
        "id": "South Dakota (Pierre), AS",
        "vi": "Nam Dakota (Pierre), Hoa Kỳ",
        "nl": "South Dakota (Pierre), VS",
        "pl": "Dakota Południowa (Pierre), USA",
        "nb": "South Dakota (Pierre), USA",
        "fi": "Etelä-Dakota (Pierre), Yhdysvallat",
        "ar": "داكوتا الجنوبية (بيير) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Tennessee (Nashville), USA",
        "ko": "테네시(내슈빌), 미국",
        "sc": "美国田纳西州（纳什维尔）",
        "es": "Tennessee (Nashville), EE. UU.",
        "ru": "Теннесси (Нэшвилл), США",
        "ja": "テネシー州（ナッシュビル）、米国",
        "fr": "Tennessee (Nashville), États-Unis",
        "de": "Tennessee (Nashville), USA",
        "it": "Tennessee (Nashville), Stati Uniti",
        "th": "เทนเนสซี (แนชวิลล์), สหรัฐอเมริกา",
        "id": "Tennessee (Nashville), AS",
        "vi": "Tennessee (Nashville), Hoa Kỳ",
        "nl": "Tennessee (Nashville), VS",
        "pl": "Tennessee (Nashville), USA",
        "nb": "Tennessee (Nashville), USA",
        "fi": "Tennessee (Nashville), Yhdysvallat",
        "ar": "تينيسي (ناشفيل) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Texas (Austin), USA",
        "ko": "텍사스(오스틴), 미국",
        "sc": "美国德克萨斯州（奥斯汀）",
        "es": "Texas (Austin), EE. UU.",
        "ru": "Техас (Остин), США",
        "ja": "テキサス（オースティン）、米国",
        "fr": "Texas (Austin), États-Unis",
        "de": "Texas (Austin), USA",
        "it": "Texas (Austin), Stati Uniti",
        "th": "เท็กซัส (ออสติน), สหรัฐอเมริกา",
        "id": "Texas (Austin), AS",
        "vi": "Texas (Austin), Hoa Kỳ",
        "nl": "Texas (Austin), VS",
        "pl": "Teksas (Austin), USA",
        "nb": "Texas (Austin), USA",
        "fi": "Texas (Austin), Yhdysvallat",
        "ar": "تكساس (أوستن) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -600,
        "prefix": "(GMT-06:00)",
        "en": "Wisconsin, USA",
        "ko": "위스콘신, 미국 ",
        "sc": "美国威斯康星州",
        "es": "Wisconsin, EE. UU.",
        "ru": "Висконсин, США",
        "ja": "米国ウィスコンシン州",
        "fr": "Wisconsin, États-Unis",
        "de": "Wisconsin, USA",
        "it": "Wisconsin, Stati Uniti",
        "th": "วิสคอนซิน สหรัฐอเมริกา",
        "id": "Wisconsin, Amerika Serikat",
        "vi": "Wisconsin, Hoa Kỳ",
        "nl": "Wisconsin, VS",
        "pl": "Wisconsin, USA",
        "nb": "Wisconsin, USA",
        "fi": "Wisconsin, Yhdysvallat",
        "ar": "ولاية ويسكونسن ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Acre, Brazil",
        "ko": "아크리, 브라질",
        "sc": "阿克里州巴西",
        "es": "Acre, Brasil",
        "ru": "Акри, Бразилия",
        "ja": "ブラジル、エーカー",
        "fr": "Acre, Brésil",
        "de": "Acre, Brasilien",
        "it": "Acri, Brasile",
        "th": "รัฐอาครี, บราซิล",
        "id": "Acre, Brasil",
        "vi": "Acre, Brazil",
        "nl": "Acre, Brazilië",
        "pl": "Akr, Brazylia",
        "nb": "Acre, Brasil",
        "fi": "Acre, Brasilia",
        "ar": "عكا ، البرازيل"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Bahamas",
        "ko": "바하마",
        "sc": "巴哈马",
        "es": "Bahamas",
        "ru": "Багамы",
        "ja": "バハマ",
        "fr": "Bahamas",
        "de": "Bahamas",
        "it": "Bahamas",
        "th": "บาฮามาส",
        "id": "Bahama",
        "vi": "Bahamas",
        "nl": "Bahamas",
        "pl": "Bahamy",
        "nb": "Bahamas",
        "fi": "Bahama",
        "ar": "جزر البهاما"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Cayman Islands",
        "ko": "케이맨 제도",
        "sc": "开曼群岛",
        "es": "Islas Caimán",
        "ru": "Каймановы острова",
        "ja": "ケイマン諸島",
        "fr": "Îles Caïmans",
        "de": "Cayman Inseln",
        "it": "Isole Cayman",
        "th": "หมู่เกาะเคย์แมน",
        "id": "Pulau cayman",
        "vi": "Quần đảo Cayman",
        "nl": "Kaaiman Eilanden",
        "pl": "Kajmany",
        "nb": "Caymanøyene",
        "fi": "Caymansaaret",
        "ar": "جزر كايمان"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Colombia",
        "ko": "콜롬비아",
        "sc": "哥伦比亚",
        "es": "Colombia",
        "ru": "Колумбия",
        "ja": "コロンビア",
        "fr": "Colombie",
        "de": "Kolumbien",
        "it": "Colombia",
        "th": "โคลอมเบีย",
        "id": "Kolumbia",
        "vi": "Colombia",
        "nl": "Colombia",
        "pl": "Kolumbia",
        "nb": "Colombia",
        "fi": "Kolumbia",
        "ar": "كولومبيا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Connecticut, USA",
        "ko": "코네티컷, 미국",
        "sc": "美国康涅狄格州",
        "es": "Connecticut, EE. UU.",
        "ru": "Коннектикут, США",
        "ja": "コネチカット、米国",
        "fr": "Connecticut, États-Unis",
        "de": "Connecticut, USA",
        "it": "Connecticut, Stati Uniti",
        "th": "คอนเนตทิคัต สหรัฐอเมริกา",
        "id": "Connecticut, AS",
        "vi": "Connecticut, Hoa Kỳ",
        "nl": "Connecticut, VS",
        "pl": "Connecticut, USA",
        "nb": "Connecticut, USA",
        "fi": "Connecticut, Yhdysvallat",
        "ar": "كونيتيكت ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Cuba",
        "ko": "쿠바",
        "sc": "古巴",
        "es": "Cuba",
        "ru": "Куба",
        "ja": "キューバ",
        "fr": "Cuba",
        "de": "Kuba",
        "it": "Cuba",
        "th": "คิวบา",
        "id": "Kuba",
        "vi": "Cuba",
        "nl": "Cuba",
        "pl": "Kuba",
        "nb": "Cuba",
        "fi": "Kuuba",
        "ar": "كوبا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Delaware, USA",
        "ko": "델라웨어, 미국",
        "sc": "美国特拉华州",
        "es": "Delaware, EE. UU.",
        "ru": "Делавэр, США",
        "ja": "デラウェア、米国",
        "fr": "Delaware, États-Unis",
        "de": "Delaware, USA",
        "it": "Delaware, Stati Uniti",
        "th": "เดลาแวร์ สหรัฐอเมริกา",
        "id": "Delaware, AS",
        "vi": "Delaware, Hoa Kỳ",
        "nl": "Delaware, VS",
        "pl": "Delaware, USA",
        "nb": "Delaware, USA",
        "fi": "Delaware, Yhdysvallat",
        "ar": "ديلاوير ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "District of Columbia(Washington D.C), USA",
        "ko": "컬럼비아 특별구(워싱턴 D.C), 미국",
        "sc": "美国华盛顿哥伦比亚特区",
        "es": "Distrito de Columbia (Washington D.C), EE. UU.",
        "ru": "Округ Колумбия (Вашингтон, округ Колумбия), США",
        "ja": "コロンビア特別区（ワシントンD.C）、米国",
        "fr": "District de Columbia (Washington DC), États-Unis",
        "de": "District of Columbia (Washington D.C.), USA",
        "it": "Distretto di Columbia (Washington DC), Stati Uniti",
        "th": "เขตโคลัมเบีย (วอชิงตัน ดี.ซี.), สหรัฐอเมริกา",
        "id": "Distrik Columbia (Washington D.C), AS",
        "vi": "Đặc khu Columbia (Washington D.C), Hoa Kỳ",
        "nl": "District of Columbia (Washington D.C.), VS",
        "pl": "Dystrykt Kolumbii (Waszyngton), USA",
        "nb": "District of Columbia (Washington D.C), USA",
        "fi": "District of Columbia (Washington D.C), Yhdysvallat",
        "ar": "مقاطعة كولومبيا (واشنطن العاصمة) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Ecuador",
        "ko": "에콰도르",
        "sc": "厄瓜多尔",
        "es": "Ecuador",
        "ru": "Эквадор",
        "ja": "エクアドル",
        "fr": "Equateur",
        "de": "Ecuador",
        "it": "Ecuador",
        "th": "เอกวาดอร์",
        "id": "Ekuador",
        "vi": "Ecuador",
        "nl": "Ecuador",
        "pl": "Ekwador",
        "nb": "Ecuador",
        "fi": "Ecuador",
        "ar": "الاكوادور"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Florida (Tallahassee), USA",
        "ko": "플로리다(탤러해시), 미국",
        "sc": "美国佛罗里达州（塔拉哈西）",
        "es": "Florida (Tallahassee), EE. UU.",
        "ru": "Флорида (Таллахасси), США",
        "ja": "フロリダ（タラハシー）、米国",
        "fr": "Floride (Tallahassee), États-Unis",
        "de": "Florida (Tallahassee), USA",
        "it": "Florida (Tallahassee), Stati Uniti",
        "th": "ฟลอริดา (แทลลาแฮสซี), สหรัฐอเมริกา",
        "id": "Florida (Tallahassee), AS",
        "vi": "Florida (Tallahassee), Hoa Kỳ",
        "nl": "Florida (Tallahassee), VS",
        "pl": "Floryda (Tallahassee), USA",
        "nb": "Florida (Tallahassee), USA",
        "fi": "Florida (Tallahassee), Yhdysvallat",
        "ar": "فلوريدا (تالاهاسي) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Georgia, USA",
        "ko": "조지아, 미국",
        "sc": "美国乔治亚州",
        "es": "georgia, EE. UU.",
        "ru": "Джорджия, США",
        "ja": "米国ジョージア州",
        "fr": "Géorgie, États-Unis",
        "de": "Georgien, USA",
        "it": "Georgia, Stati Uniti",
        "th": "จอร์เจีย สหรัฐอเมริกา",
        "id": "Georgia, AS",
        "vi": "Georgia, Hoa Kỳ",
        "nl": "Georgië, VS",
        "pl": "Gruzja, USA",
        "nb": "Georgia, USA",
        "fi": "Georgia, Yhdysvallat",
        "ar": "جورجيا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Haiti",
        "ko": "아이티",
        "sc": "海地",
        "es": "Haití",
        "ru": "Гаити",
        "ja": "ハイチ",
        "fr": "Haïti",
        "de": "Haiti",
        "it": "Haiti",
        "th": "เฮติ",
        "id": "Haiti",
        "vi": "Haiti",
        "nl": "Haïti",
        "pl": "Haiti",
        "nb": "Haiti",
        "fi": "Haiti",
        "ar": "هايتي"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Indiana (Indianapolis), USA",
        "ko": "인디애나(인디아나폴리스), 미국",
        "sc": "美国印第安纳州（印第安纳波利斯）",
        "es": "Indiana (Indianápolis), EE. UU.",
        "ru": "Индиана (Индианаполис), США",
        "ja": "インディアナ（インディアナポリス）、米国",
        "fr": "Indiana (Indianapolis), États-Unis",
        "de": "Indiana (Indianapolis), USA",
        "it": "Indiana (Indianapolis), Stati Uniti",
        "th": "อินดีแอนา (อินเดียแนโพลิส), สหรัฐอเมริกา",
        "id": "Indiana (Indianapolis), AS",
        "vi": "Indiana (Indianapolis), Hoa Kỳ",
        "nl": "Indiana (Indianapolis), VS",
        "pl": "Indiana (Indianapolis), USA",
        "nb": "Indiana (Indianapolis), USA",
        "fi": "Indiana (Indianapolis), Yhdysvallat",
        "ar": "إنديانا (إنديانابوليس) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Jamaica",
        "ko": "자메이카",
        "sc": "牙买加",
        "es": "Jamaica",
        "ru": "Ямайка",
        "ja": "ジャマイカ",
        "fr": "Jamaïque",
        "de": "Jamaika",
        "it": "Giamaica",
        "th": "จาไมก้า",
        "id": "Jamaika",
        "vi": "Jamaica",
        "nl": "Jamaica",
        "pl": "Jamajka",
        "nb": "Jamaica",
        "fi": "Jamaika",
        "ar": "جامايكا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Kentucky (Frankfort), USA",
        "ko": "켄터키(프랭크포트), 미국",
        "sc": "美国肯塔基州（法兰克福）",
        "es": "Kentucky (Fráncfort), EE. UU.",
        "ru": "Кентукки (Франкфорт), США",
        "ja": "ケンタッキー（フランクフォート）、米国",
        "fr": "Kentucky (Francfort), États-Unis",
        "de": "Kentucky (Frankfurt), USA",
        "it": "Kentucky (Francoforte), Stati Uniti",
        "th": "เคนตักกี้ (แฟรงก์เฟิร์ต) สหรัฐอเมริกา",
        "id": "Kentucky (Frankfort), AS",
        "vi": "Kentucky (Frankfort), Hoa Kỳ",
        "nl": "Kentucky (Frankfort), VS",
        "pl": "Kentucky (Frankfort), USA",
        "nb": "Kentucky (Frankfort), USA",
        "fi": "Kentucky (Frankfort), Yhdysvallat",
        "ar": "كنتاكي (فرانكفورت) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Maine, USA",
        "ko": "메인, 미국",
        "sc": "美国缅因州",
        "es": "Maine, EE. UU.",
        "ru": "Мэн, США",
        "ja": "米国メイン州",
        "fr": "Maine, États-Unis",
        "de": "Maine, USA",
        "it": "Maine, Stati Uniti",
        "th": "เมน สหรัฐอเมริกา",
        "id": "Maine, Amerika Serikat",
        "vi": "Maine, Hoa Kỳ",
        "nl": "Maine, VS",
        "pl": "Maine, USA",
        "nb": "Maine, USA",
        "fi": "Maine, Yhdysvallat",
        "ar": "مين ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Maryland, USA",
        "ko": "메릴랜드, 미국",
        "sc": "美国马里兰州",
        "es": "Maryland, EE. UU.",
        "ru": "Мэриленд, США",
        "ja": "米国メリーランド州",
        "fr": "Maryland, États-Unis",
        "de": "Maryland, USA",
        "it": "Maryland, Stati Uniti",
        "th": "แมริแลนด์ สหรัฐอเมริกา",
        "id": "Maryland, AS",
        "vi": "Maryland, Hoa Kỳ",
        "nl": "Maryland, VS",
        "pl": "Maryland, USA",
        "nb": "Maryland, USA",
        "fi": "Maryland, Yhdysvallat",
        "ar": "ماريلاند ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Massachusetts, USA",
        "ko": "매사추세츠, 미국",
        "sc": "美国马萨诸塞州",
        "es": "Massachusetts, EE. UU.",
        "ru": "Массачусетс, США",
        "ja": "米国マサチューセッツ州",
        "fr": "Massachusetts, États-Unis",
        "de": "Massachusetts, USA",
        "it": "Massachusetts, Stati Uniti",
        "th": "แมสซาชูเซตส์ สหรัฐอเมริกา",
        "id": "Massachusetts, AS",
        "vi": "Massachusetts, Hoa Kỳ",
        "nl": "Massachusetts, VS",
        "pl": "Massachusetts, USA",
        "nb": "Massachusetts, USA",
        "fi": "Massachusetts, Yhdysvallat",
        "ar": "ماساتشوستس ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Michigan (Lansing), USA",
        "ko": "미시간(랜싱), 미국",
        "sc": "美国密歇根州（兰辛）",
        "es": "Míchigan (Lansing), EE. UU.",
        "ru": "Мичиган (Лансинг), США",
        "ja": "ミシガン（ランシング）、米国",
        "fr": "Michigan (Lansing), États-Unis",
        "de": "Michigan (Lansing), USA",
        "it": "Michigan (Lansing), Stati Uniti",
        "th": "มิชิแกน (แลนซิง), สหรัฐอเมริกา",
        "id": "Michigan (Lansing), AS",
        "vi": "Michigan (Lansing), Hoa Kỳ",
        "nl": "Michigan (Lansing), VS",
        "pl": "Michigan (Lansing), USA",
        "nb": "Michigan (Lansing), USA",
        "fi": "Michigan (Lansing), Yhdysvallat",
        "ar": "ميشيغان (لانسينغ) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Mexico, state of Quintana Roo",
        "ko": "멕시코 킨타나로오주",
        "sc": "墨西哥，金塔纳罗奥州",
        "es": "México, estado de Quintana Roo",
        "ru": "Мексика, штат Кинтана-Роо",
        "ja": "メキシコ、キンタナロー州",
        "fr": "Mexique, État de Quintana Roo",
        "de": "Mexiko, Bundesstaat Quintana Roo",
        "it": "Messico, stato di Quintana Roo",
        "th": "เม็กซิโก รัฐกินตานาโร",
        "id": "Meksiko, negara bagian Quintana Roo",
        "vi": "México, bang Quintana Roo",
        "nl": "Mexico, staat Quintana Roo",
        "pl": "Meksyk, stan Quintana Roo",
        "nb": "Mexico, delstaten Quintana Roo",
        "fi": "Meksiko, Quintana Roon osavaltio",
        "ar": "المكسيك ، ولاية كوينتانا رو"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "New Hampshire, USA",
        "ko": "뉴햄프셔, 미국",
        "sc": "美国新罕布什尔州",
        "es": "Nuevo Hampshire, EE. UU.",
        "ru": "Нью-Гэмпшир, США",
        "ja": "ニューハンプシャー、米国",
        "fr": "New Hampshire, États-Unis",
        "de": "NewHampshire, USA",
        "it": "New Hampshire, Stati Uniti",
        "th": "นิวแฮมป์เชียร์ สหรัฐอเมริกา",
        "id": "New Hampshire, AS",
        "vi": "New Hampshire, Hoa Kỳ",
        "nl": "New Hampshire, VS",
        "pl": "New Hampshire, USA",
        "nb": "New Hampshire, USA",
        "fi": "New Hampshire, Yhdysvallat",
        "ar": "نيو هامبشاير ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "New Jersey, USA",
        "ko": "뉴저지, 미국",
        "sc": "美国新泽西州",
        "es": "Nueva Jersey, EE. UU.",
        "ru": "Нью-Джерси, США",
        "ja": "ニュージャージー、米国",
        "fr": "New Jersey, États-Unis",
        "de": "New-Jersey, USA",
        "it": "New Jersey, Stati Uniti",
        "th": "นิวเจอร์ซีย์ สหรัฐอเมริกา",
        "id": "New Jersey, AS",
        "vi": "New Jersey, Hoa Kỳ",
        "nl": "New Jersey, VS",
        "pl": "New Jersey, USA",
        "nb": "New Jersey, USA",
        "fi": "New Jersey, Yhdysvallat",
        "ar": "نيو جيرسي ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "New York, USA",
        "ko": "뉴욕, 미국",
        "sc": "美国纽约",
        "es": "Nueva York, EE. UU.",
        "ru": "Нью-Йорк, США",
        "ja": "ニューヨーク、アメリカ",
        "fr": "New York, États-Unis",
        "de": "New York, USA",
        "it": "New York, Stati Uniti",
        "th": "นิวยอร์ก สหรัฐอเมริกา",
        "id": "New York, AS",
        "vi": "New York, Hoa Kỳ",
        "nl": "New York, VS",
        "pl": "Nowy Jork, USA",
        "nb": "New York, USA",
        "fi": "New York, Yhdysvallat",
        "ar": "نيويورك ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Nunavut (Coral Harbour), Canada",
        "ko": "누나부트(코랄하버), 캐나다",
        "sc": "加拿大努纳武特（珊瑚港）",
        "es": "Nunavut (Puerto de Coral), Canadá",
        "ru": "Нунавут (Корал-Харбор), Канада",
        "ja": "ヌナブト準州（コーラルハーバー）、カナダ",
        "fr": "Nunavut (port de corail), Canada",
        "de": "Nunavut (Korallenhafen), Kanada",
        "it": "Nunavut (Porto di Corallo), Canada",
        "th": "นูนาวุต (คอรัล ฮาร์เบอร์), แคนาดา",
        "id": "Nunavut (Pelabuhan Karang), Kanada",
        "vi": "Nunavut (Cảng Coral), Canada",
        "nl": "Nunavut (Coral Harbour), Canada",
        "pl": "Nunavut (port koralowy), Kanada",
        "nb": "Nunavut (Coral Harbour), Canada",
        "fi": "Nunavut (Coral Harbour), Kanada",
        "ar": "نونافوت (كورال هاربور) ، كندا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Nunavut (Iqaluit), Canada",
        "ko": "누나부트(이칼루이트), 캐나다",
        "sc": "加拿大努纳武特（伊魁特）",
        "es": "Nunavut (Iqaluit), Canadá",
        "ru": "Нунавут (Икалуит), Канада",
        "ja": "ヌナブト準州（イカルイト）、カナダ",
        "fr": "Nunavut (Iqaluit), Canada",
        "de": "Nunavut (Iqaluit), Kanada",
        "it": "Nunavut (Iqaluit), Canada",
        "th": "นูนาวุต (อีคาลูอิต), แคนาดา",
        "id": "Nunavut (Iqaluit), Kanada",
        "vi": "Nunavut (Iqaluit), Canada",
        "nl": "Nunavut (Iqaluit), Canada",
        "pl": "Nunavut (Iqaluit), Kanada",
        "nb": "Nunavut (Iqaluit), Canada",
        "fi": "Nunavut (Iqaluit), Kanada",
        "ar": "نونافوت (إيكالويت) ، كندا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "North Carolina, USA",
        "ko": "노스캐롤라이나, 미국",
        "sc": "美国北卡罗来纳州",
        "es": "Carolina del Norte, EE. UU.",
        "ru": "Северная Каролина, США",
        "ja": "米国ノースカロライナ州",
        "fr": "Caroline du Nord, États-Unis",
        "de": "North Carolina, USA",
        "it": "Carolina del Nord, Stati Uniti",
        "th": "นอร์ทแคโรไลนา สหรัฐอเมริกา",
        "id": "Carolina Utara, AS",
        "vi": "Bắc Carolina, Hoa Kỳ",
        "nl": "Noord-Carolina, VS",
        "pl": "Karolina Północna, USA",
        "nb": "North Carolina, USA",
        "fi": "Pohjois-Carolina, Yhdysvallat",
        "ar": "كارولينا الشمالية ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Ohio, USA",
        "ko": "오하이오, 미국",
        "sc": "美国俄亥俄州",
        "es": "Ohio, EE. UU.",
        "ru": "Огайо, США",
        "ja": "米国オハイオ州",
        "fr": "Ohio, États-Unis",
        "de": "Ohio, USA",
        "it": "Ohio, Stati Uniti",
        "th": "โอไฮโอ สหรัฐอเมริกา",
        "id": "Ohio, Amerika Serikat",
        "vi": "Ohio, Hoa Kỳ",
        "nl": "Ohio, VS",
        "pl": "Ohio, USA",
        "nb": "Ohio, USA",
        "fi": "Ohio, Yhdysvallat",
        "ar": "أوهايو ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Ontario (Toronto, Ottawa), Canada",
        "ko": "온타리오(토론토, 오타와), 캐나다",
        "sc": "安大略省（多伦多，渥太华），加拿大",
        "es": "Ontario (Toronto, Ottawa), Canadá",
        "ru": "Онтарио (Торонто, Оттава), Канада",
        "ja": "オンタリオ州（トロント、オタワ）、カナダ",
        "fr": "Ontario (Toronto, Ottawa), Canada",
        "de": "Ontario (Toronto, Ottawa), Kanada",
        "it": "Ontario (Toronto, Ottawa), Canada",
        "th": "ออนแทรีโอ (โตรอนโต ออตตาวา) แคนาดา",
        "id": "Ontario (Toronto, Ottawa), Kanada",
        "vi": "Ontario (Toronto, Ottawa), Canada",
        "nl": "Ontario (Toronto, Ottawa), Canada",
        "pl": "Ontario (Toronto, Ottawa), Kanada",
        "nb": "Ontario (Toronto, Ottawa), Canada",
        "fi": "Ontario (Toronto, Ottawa), Kanada",
        "ar": "أونتاريو (تورنتو ، أوتاوا) ، كندا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Ontario (Quetico Provincial Park), Canada",
        "ko": "온타리오(퀘티코 주립공원), 캐나다",
        "sc": "加拿大安大略省（Quetico 省立公园）",
        "es": "Ontario (Parque Provincial de Quetico), Canadá",
        "ru": "Онтарио (провинциальный парк Кетико), Канада",
        "ja": "カナダ、オンタリオ州（ケティコ州立公園）",
        "fr": "Ontario (parc provincial Quetico), Canada",
        "de": "Ontario (Provinzpark Quetico), Kanada",
        "it": "Ontario (Parco Provinciale del Quetico), Canada",
        "th": "ออนแทรีโอ (อุทยานประจำจังหวัดเกติโก), แคนาดา",
        "id": "Ontario (Taman Provinsi Quetico), Kanada",
        "vi": "Ontario (Công viên tỉnh Quetico), Canada",
        "nl": "Ontario (Quetico Provincial Park), Canada",
        "pl": "Ontario (Quetico Provincial Park), Kanada",
        "nb": "Ontario (Quetico Provincial Park), Canada",
        "fi": "Ontario (Queticon maakuntapuisto), Kanada",
        "ar": "أونتاريو (Quetico Provincial Park) ، كندا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Panama",
        "ko": "파나마",
        "sc": "巴拿马",
        "es": "Panamá",
        "ru": "Панама",
        "ja": "パナマ",
        "fr": "Panama",
        "de": "Panama",
        "it": "Panama",
        "th": "ปานามา",
        "id": "Panama",
        "vi": "Panama",
        "nl": "Panama",
        "pl": "Panama",
        "nb": "Panama",
        "fi": "Panama",
        "ar": "بنما"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Pennsylvania, USA",
        "ko": "펜실베니아, 미국",
        "sc": "美国宾夕法尼亚州",
        "es": "Pensilvania, EE. UU.",
        "ru": "Пенсильвания, США",
        "ja": "米国ペンシルベニア州",
        "fr": "Pennsylvanie, États-Unis",
        "de": "Pennsylvanien, USA",
        "it": "Pennsylvania, Stati Uniti",
        "th": "เพนซิลเวเนีย สหรัฐอเมริกา",
        "id": "Pennsylvania, Amerika Serikat",
        "vi": "Pennsylvania, Hoa Kỳ",
        "nl": "Pennsylvania, VS",
        "pl": "Pensylwania, USA",
        "nb": "Pennsylvania, USA",
        "fi": "Pennsylvania, Yhdysvallat",
        "ar": "بنسلفانيا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Peru",
        "ko": "페루",
        "sc": "秘鲁",
        "es": "Perú",
        "ru": "Перу",
        "ja": "ペルー",
        "fr": "Pérou",
        "de": "Peru",
        "it": "Perù",
        "th": "เปรู",
        "id": "Peru",
        "vi": "Peru",
        "nl": "Peru",
        "pl": "Peru",
        "nb": "Peru",
        "fi": "Peru",
        "ar": "بيرو"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Rhode Island, USA",
        "ko": "로드 아일랜드, 미국",
        "sc": "美国罗德岛",
        "es": "Rhode Island, EE. UU.",
        "ru": "Род-Айленд, США",
        "ja": "ロードアイランド、米国",
        "fr": "Rhode Island, États-Unis",
        "de": "Rhode Island, USA",
        "it": "Rhode Island, Stati Uniti",
        "th": "โรดไอแลนด์ สหรัฐอเมริกา",
        "id": "Pulau Rhode, AS",
        "vi": "Đảo Rhode, Hoa Kỳ",
        "nl": "Rhode Island, VS",
        "pl": "Rhode Island, USA",
        "nb": "Rhode Island, USA",
        "fi": "Rhode Island, Yhdysvallat",
        "ar": "رود آيلاند ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Quebec (Quebec City), Canada",
        "ko": "퀘벡(퀘벡시티), 캐나다",
        "sc": "加拿大魁北克（魁北克市）",
        "es": "Quebec (Ciudad de Quebec), Canadá",
        "ru": "Квебек (город Квебек), Канада",
        "ja": "ケベック（ケベックシティ）、カナダ",
        "fr": "Québec (ville de Québec), Canada",
        "de": "Quebec (Quebec City), Kanada",
        "it": "Quebec (città del Quebec), Canada",
        "th": "ควิเบก (เมืองควิเบก), แคนาดา",
        "id": "Quebec (Kota Quebec), Kanada",
        "vi": "Quebec (Thành phố Quebec), Canada",
        "nl": "Quebec (Quebec City), Canada",
        "pl": "Quebec (Quebec City), Kanada",
        "nb": "Quebec (Quebec City), Canada",
        "fi": "Quebec (Quebec City), Kanada",
        "ar": "كيبيك (مدينة كيبيك) ، كندا"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "South Carolina, USA",
        "ko": "사우스캐롤라이나, 미국",
        "sc": "美国南卡罗来纳州",
        "es": "Carolina del Sur, EE. UU.",
        "ru": "Южная Каролина, США",
        "ja": "米国サウスカロライナ州",
        "fr": "Caroline du Sud, États-Unis",
        "de": "South Carolina, USA",
        "it": "Carolina del Sud, Stati Uniti",
        "th": "เซาท์แคโรไลนา สหรัฐอเมริกา",
        "id": "Carolina Selatan, AS",
        "vi": "Nam Carolina, Hoa Kỳ",
        "nl": "Zuid-Carolina, VS",
        "pl": "Karolina Południowa, USA",
        "nb": "Sør-Carolina, USA",
        "fi": "Etelä-Carolina, Yhdysvallat",
        "ar": "ساوث كارولينا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Southwest Amazonas, Brazil",
        "ko": "브라질 아마조나스 남서부",
        "sc": "巴西亚马孙西南部",
        "es": "Sudoeste de Amazonas, Brasil",
        "ru": "Юго-западная Амазонас, Бразилия",
        "ja": "アマゾナス南西部、ブラジル",
        "fr": "Sud-ouest de l'Amazonas, Brésil",
        "de": "Südwest Amazonas, Brasilien",
        "it": "Amazonas sudoccidentale, Brasile",
        "th": "อเมซอนตะวันตกเฉียงใต้ บราซิล",
        "id": "Amazonas Barat Daya, Brasil",
        "vi": "Tây nam Amazonas, Brazil",
        "nl": "Zuidwest-Amazonas, Brazilië",
        "pl": "Południowo-zachodnia Amazonia, Brazylia",
        "nb": "Sørvest-Amazonas, Brasil",
        "fi": "Lounais Amazonas, Brasilia",
        "ar": "جنوب غرب أمازوناس ، البرازيل"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Tennessee (Knoxville), USA",
        "ko": "테네시(녹스빌), 미국",
        "sc": "美国田纳西州（诺克斯维尔）",
        "es": "Tennessee (Knoxville), EE. UU.",
        "ru": "Теннесси (Ноксвилл), США",
        "ja": "テネシー州（ノックスビル）、米国",
        "fr": "Tennessee (Knoxville), États-Unis",
        "de": "Tennessee (Knoxville), USA",
        "it": "Tennessee (Knoxville), Stati Uniti",
        "th": "เทนเนสซี (นอกซ์วิลล์), สหรัฐอเมริกา",
        "id": "Tennessee (Knoxville), AS",
        "vi": "Tennessee (Knoxville), Hoa Kỳ",
        "nl": "Tennessee (Knoxville), VS",
        "pl": "Tennessee (Knoxville), USA",
        "nb": "Tennessee (Knoxville), USA",
        "fi": "Tennessee (Knoxville), Yhdysvallat",
        "ar": "تينيسي (نوكسفيل) ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Vermont, USA",
        "ko": "버몬트주, 미국",
        "sc": "美国佛蒙特州",
        "es": "Vermont, EE. UU.",
        "ru": "Вермонт, США",
        "ja": "バーモント州、米国",
        "fr": "Vermont, États-Unis",
        "de": "Vermont, USA",
        "it": "Vermont, Stati Uniti",
        "th": "เวอร์มอนต์ สหรัฐอเมริกา",
        "id": "Vermont, AS",
        "vi": "Vermont, Hoa Kỳ",
        "nl": "Vermont, VS",
        "pl": "Vermont, USA",
        "nb": "Vermont, USA",
        "fi": "Vermont, Yhdysvallat",
        "ar": "فيرمونت ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "Virginia, USA",
        "ko": "버지니아, 미국",
        "sc": "美国弗吉尼亚州",
        "es": "Virginia, EE. UU.",
        "ru": "Вирджиния, США",
        "ja": "米国バージニア州",
        "fr": "Virginie, États-Unis",
        "de": "Virginia, USA",
        "it": "Virginia, Stati Uniti",
        "th": "เวอร์จิเนีย สหรัฐอเมริกา",
        "id": "Virginia, Amerika Serikat",
        "vi": "Virginia, Hoa Kỳ",
        "nl": "Virginia, VS",
        "pl": "Wirginia, USA",
        "nb": "Virginia, USA",
        "fi": "Virginia, Yhdysvallat",
        "ar": "فيرجينيا ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -500,
        "prefix": "(GMT-05:00)",
        "en": "West Virginia, USA",
        "ko": "웨스트버지니아, 미국",
        "sc": "美国西弗吉尼亚州",
        "es": "Virginia Occidental, EE. UU.",
        "ru": "Западная Вирджиния, США",
        "ja": "米国ウェストバージニア州",
        "fr": "Virginie-Occidentale, États-Unis",
        "de": "West-Virginia, USA",
        "it": "Virginia Occidentale, Stati Uniti",
        "th": "เวสต์เวอร์จิเนีย สหรัฐอเมริกา",
        "id": "Virginia Barat, AS",
        "vi": "Tây Virginia, Hoa Kỳ",
        "nl": "West Virginia, VS",
        "pl": "Wirginia Zachodnia, USA",
        "nb": "West Virginia, USA",
        "fi": "Länsi-Virginia, Yhdysvallat",
        "ar": "فيرجينيا الغربية ، الولايات المتحدة الأمريكية"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Amazonas, Brazil",
        "ko": "아마조나스, 브라질",
        "sc": "巴西亚马孙州",
        "es": "Amazonas, Brasil",
        "ru": "Амасонас, Бразилия",
        "ja": "アマゾナス、ブラジル",
        "fr": "Amazonas, Brésil",
        "de": "Amazonas, Brasilien",
        "it": "Amazonas, Brasile",
        "th": "รัฐอามาโซนัช, บราซิล",
        "id": "Amazonas, Brasil",
        "vi": "Amazonas, Brazil",
        "nl": "Amazonas, Brazilië",
        "pl": "Amazonas, Brazylia",
        "nb": "Amazonas, Brasil",
        "fi": "Amazonas, Brasilia",
        "ar": "أمازوناس ، البرازيل"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Anguilla",
        "ko": "앵귈라",
        "sc": "安圭拉",
        "es": "Anguila",
        "ru": "Ангилья",
        "ja": "アンギラ",
        "fr": "Anguilla",
        "de": "Anguilla",
        "it": "Anguilla",
        "th": "แองกวิลลา",
        "id": "Anguila",
        "vi": "Anguilla",
        "nl": "Anguilla",
        "pl": "Anguilla",
        "nb": "Anguilla",
        "fi": "Anguilla",
        "ar": "أنغيلا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Antigua and Barbuda",
        "ko": "앤티가 바부다",
        "sc": "安提瓜和巴布达",
        "es": "Antigua y Barbuda",
        "ru": "Антигуа и Барбуда",
        "ja": "アンティグアバーブーダ",
        "fr": "Antigua-et-Barbuda",
        "de": "Antigua und Barbuda",
        "it": "Antigua e Barbuda",
        "th": "แอนติกาและบาร์บูดา",
        "id": "Antigua dan Barbuda",
        "vi": "Antigua và Barbuda",
        "nl": "Antigua en Barbuda",
        "pl": "Antigua i Barbuda",
        "nb": "Antigua og Barbuda",
        "fi": "Antigua ja Barbuda",
        "ar": "أنتيغوا وبربودا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Aruba",
        "ko": "아루바",
        "sc": "阿鲁巴岛",
        "es": "Aruba",
        "ru": "Аруба",
        "ja": "アルバ",
        "fr": "Aruba",
        "de": "Aruba",
        "it": "Aruba",
        "th": "อารูบา",
        "id": "Aruba",
        "vi": "Aruba",
        "nl": "Aruba",
        "pl": "Aruba",
        "nb": "Aruba",
        "fi": "Aruba",
        "ar": "أروبا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Barbados",
        "ko": "바베이도스",
        "sc": "巴巴多斯",
        "es": "barbados",
        "ru": "Барбадос",
        "ja": "バルバドス",
        "fr": "Barbade",
        "de": "Barbados",
        "it": "Barbados",
        "th": "บาร์เบโดส",
        "id": "Barbados",
        "vi": "Barbados",
        "nl": "Barbados",
        "pl": "Barbados",
        "nb": "Barbados",
        "fi": "Barbados",
        "ar": "بربادوس"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Bermuda",
        "ko": "버뮤다",
        "sc": "百慕大",
        "es": "islas Bermudas",
        "ru": "Бермуды",
        "ja": "バミューダ",
        "fr": "Bermudes",
        "de": "Bermudas",
        "it": "Bermuda",
        "th": "เบอร์มิวดา",
        "id": "Bermuda",
        "vi": "Bermuda",
        "nl": "Bermuda",
        "pl": "Bermudy",
        "nb": "Bermuda",
        "fi": "Bermuda",
        "ar": "برمودا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Bolivia",
        "ko": "볼리비아",
        "sc": "玻利维亚",
        "es": "Bolivia",
        "ru": "Боливия",
        "ja": "ボリビア",
        "fr": "Bolivie",
        "de": "Bolivien",
        "it": "Bolivia",
        "th": "โบลิเวีย",
        "id": "Bolivia",
        "vi": "Bolivia",
        "nl": "Bolivia",
        "pl": "Boliwia",
        "nb": "Bolivia",
        "fi": "Bolivia",
        "ar": "بوليفيا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Bonaire",
        "ko": "보네르",
        "sc": "博内尔岛",
        "es": "bonaire",
        "ru": "Бонайре",
        "ja": "ボネール",
        "fr": "Bonaire",
        "de": "Bonaire",
        "it": "Bonaire",
        "th": "โบแนร์",
        "id": "Bonaire",
        "vi": "Bonaire",
        "nl": "Bonaire",
        "pl": "Bonaire",
        "nb": "Bonaire",
        "fi": "Bonaire",
        "ar": "بونير"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "British Virgin Islands",
        "ko": "영국령 버진 아일랜드",
        "sc": "英属维尔京群岛",
        "es": "Islas Vírgenes Británicas",
        "ru": "Британские Виргинские острова",
        "ja": "イギリス領バージン諸島",
        "fr": "Îles Vierges britanniques",
        "de": "Britische Jungferninseln",
        "it": "Isole Vergini Britanniche",
        "th": "หมู่เกาะบริติชเวอร์จิน",
        "id": "Kepulauan Virgin Inggris",
        "vi": "Quần đảo British Virgin",
        "nl": "Britse Maagdeneilanden",
        "pl": "Brytyjskie Wyspy Dziewicze",
        "nb": "De britiske jomfruøyene",
        "fi": "Britannian Neitsytsaaret",
        "ar": "جزر فيرجن البريطانية"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Caribbean Netherlands",
        "ko": "카리브해 네덜란드",
        "sc": "加勒比海荷兰",
        "es": "Caribe neerlandés",
        "ru": "Карибские Нидерланды",
        "ja": "カリブ海オランダ",
        "fr": "Pays-Bas caribéens",
        "de": "Karibische Niederlande",
        "it": "Paesi Bassi caraibici",
        "th": "แคริบเบียนเนเธอร์แลนด์",
        "id": "Karibia Belanda",
        "vi": "Caribe Hà Lan",
        "nl": "Caribisch Nederland",
        "pl": "Karaiby Holandia",
        "nb": "Karibiske Nederland",
        "fi": "Karibian Alankomaat",
        "ar": "هولندا الكاريبية"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Chile",
        "ko": "칠레",
        "sc": "智利",
        "es": "Chile",
        "ru": "Чили",
        "ja": "チリ",
        "fr": "Chili",
        "de": "Chile",
        "it": "Chile",
        "th": "ชิลี",
        "id": "Chili",
        "vi": "Chile",
        "nl": "Chili",
        "pl": "Chile",
        "nb": "Chile",
        "fi": "Chile",
        "ar": "تشيلي"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Curacao",
        "ko": "큐라소",
        "sc": "库拉索",
        "es": "curazao",
        "ru": "Кюрасао",
        "ja": "キュラソー",
        "fr": "Curacao",
        "de": "Curacao",
        "it": "Curacao",
        "th": "คูราเซา",
        "id": "Curacao",
        "vi": "rượu cam bì",
        "nl": "Curacao",
        "pl": "Curaçao",
        "nb": "Curacao",
        "fi": "Curacao",
        "ar": "كوراكاو"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Dominica",
        "ko": "도미니카",
        "sc": "多米尼克",
        "es": "Dominica",
        "ru": "Доминика",
        "ja": "ドミニカ",
        "fr": "Dominique",
        "de": "Dominika",
        "it": "Dominica",
        "th": "โดมินิกา",
        "id": "Dominika",
        "vi": "Dominica",
        "nl": "Dominica",
        "pl": "Dominika",
        "nb": "Dominica",
        "fi": "Dominica",
        "ar": "دومينيكا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Dominican Republic",
        "ko": "도미니카 공화국",
        "sc": "多明尼加共和国",
        "es": "República Dominicana",
        "ru": "Доминиканская Респблика",
        "ja": "ドミニカ共和国",
        "fr": "République Dominicaine",
        "de": "Dominikanische Republik",
        "it": "Repubblica Dominicana",
        "th": "สาธารณรัฐโดมินิกัน",
        "id": "Republik Dominika",
        "vi": "Cộng hòa Dominica",
        "nl": "Dominicaanse Republiek",
        "pl": "Republika Dominikany",
        "nb": "den dominikanske republikk",
        "fi": "Dominikaaninen tasavalta",
        "ar": "جمهورية الدومينيكان"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Greenland, Thule Air Base",
        "ko": "그린란드 툴레 공군기지",
        "sc": "格陵兰，图勒空军基地",
        "es": "Groenlandia, base aérea de Thule",
        "ru": "Гренландия, авиабаза Туле",
        "ja": "グリーンランド、トゥーレ空軍基地",
        "fr": "Groenland, base aérienne de Thulé",
        "de": "Grönland, Thule Air Base",
        "it": "Groenlandia, base aerea di Thule",
        "th": "กรีนแลนด์ ฐานทัพอากาศทูเล่",
        "id": "Greenland, Pangkalan Udara Thule",
        "vi": "Căn cứ không quân Greenland, Thule",
        "nl": "Groenland, Thule Air Base",
        "pl": "Grenlandia, baza lotnicza Thule",
        "nb": "Grønland, Thule flybase",
        "fi": "Grönlanti, Thulen lentotukikohta",
        "ar": "جرينلاند ، قاعدة ثول الجوية"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Grenada",
        "ko": "그레나다",
        "sc": "格林纳达",
        "es": "Granada",
        "ru": "Гренада",
        "ja": "グレナダ",
        "fr": "Grenade",
        "de": "Grenada",
        "it": "Grenada",
        "th": "เกรเนดา",
        "id": "Grenada",
        "vi": "Grenada",
        "nl": "Grenada",
        "pl": "Grenada",
        "nb": "Grenada",
        "fi": "Grenada",
        "ar": "غرينادا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Guadeloupe",
        "ko": "과들루프",
        "sc": "瓜德罗普",
        "es": "Guadalupe",
        "ru": "Гваделупа",
        "ja": "グアドループ",
        "fr": "Guadeloupe",
        "de": "Guadeloupe",
        "it": "Guadalupa",
        "th": "กวาเดอลูป",
        "id": "Guadeloupe",
        "vi": "Guadeloupe",
        "nl": "Guadeloupe",
        "pl": "Gwadelupa",
        "nb": "Guadeloupe",
        "fi": "Guadeloupe",
        "ar": "جوادلوب"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Guyana",
        "ko": "가이아나",
        "sc": "圭亚那",
        "es": "Guayana",
        "ru": "Гайана",
        "ja": "ガイアナ",
        "fr": "Guyane",
        "de": "Guyana",
        "it": "Guyana",
        "th": "กายอานา",
        "id": "Guyana",
        "vi": "Guyana",
        "nl": "Guyana",
        "pl": "Gujana",
        "nb": "Guyana",
        "fi": "Guyana",
        "ar": "غيانا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Martinique",
        "ko": "마르티니크",
        "sc": "马提尼克岛",
        "es": "Martinica",
        "ru": "Мартиника",
        "ja": "マルティニーク",
        "fr": "Martinique",
        "de": "Martinique",
        "it": "Martinica",
        "th": "มาร์ตินีก",
        "id": "Martinik",
        "vi": "Martinique",
        "nl": "Martinique",
        "pl": "Martynika",
        "nb": "Martinique",
        "fi": "Martinique",
        "ar": "مارتينيك"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Mato Grosso do Sul, Brazil",
        "ko": "마투그로수두술, 브라질",
        "sc": "巴西南马托格罗索州",
        "es": "Mato Grosso do Sul, Brasil",
        "ru": "Мату-Гросу-ду-Сул, Бразилия",
        "ja": "マトグロッソドスル、ブラジル",
        "fr": "Mato Grosso do Sul, Brésil",
        "de": "Mato Grosso do Sul, Brasilien",
        "it": "Mato Grosso do Sul, Brasile",
        "th": "มาตู กรอสโซ ดู ซูล บราซิล",
        "id": "Mato Grosso do Sul, Brasil",
        "vi": "Mato Grosso do Sul, Brazil",
        "nl": "Mato Grosso do Sul, Brazilië",
        "pl": "Mato Grosso do Sul, Brazylia",
        "nb": "Mato Grosso do Sul, Brasil",
        "fi": "Mato Grosso do Sul, Brasilia",
        "ar": "ماتو جروسو دو سول ، البرازيل"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Mato Grosso, Brazil",
        "ko": "브라질 마투 그로수",
        "sc": "巴西马托格罗索",
        "es": "Mato Grosso, Brasil",
        "ru": "Мату-Гросу, Бразилия",
        "ja": "マットグロッソ、ブラジル",
        "fr": "Mato Grosso, Brésil",
        "de": "Mato Grosso, Brasilien",
        "it": "Mato Grosso, Brasile",
        "th": "มาตู กรอสโซ่ บราซิล",
        "id": "Mato Grosso, Brasil",
        "vi": "Mato Grosso, Brazil",
        "nl": "Mato Grosso, Brazilië",
        "pl": "Mato Grosso, Brazylia",
        "nb": "Mato Grosso, Brasil",
        "fi": "Mato Grosso, Brasilia",
        "ar": "ماتو جروسو ، البرازيل"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Montserrat",
        "ko": "몬세라트",
        "sc": "蒙特塞拉特",
        "es": "Montserrat",
        "ru": "Монтсеррат",
        "ja": "モントセラト",
        "fr": "Montserrat",
        "de": "Montserrat",
        "it": "Montserrat",
        "th": "มอนต์เซอร์รัต",
        "id": "Montserrat",
        "vi": "Montserrat",
        "nl": "Montserrat",
        "pl": "Montserrat",
        "nb": "Montserrat",
        "fi": "Montserrat",
        "ar": "مونتسيرات"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "New Brunswick, Canada",
        "ko": "뉴브런즈윅, 캐나다 ",
        "sc": "加拿大新不伦瑞克",
        "es": "Nuevo Brunswick, Canadá",
        "ru": "Нью-Брансуик, Канада",
        "ja": "ニューブランズウィック、カナダ",
        "fr": "Nouveau-Brunswick, Canada",
        "de": "Neubraunschweig, Kanada",
        "it": "Nuovo Brunswick, Canada",
        "th": "นิวบรันสวิก แคนาดา",
        "id": "New Brunswick, Kanada",
        "vi": "New Brunswick, Canada",
        "nl": "New Brunswick, Canada",
        "pl": "Nowy Brunszwik, Kanada",
        "nb": "New Brunswick, Canada",
        "fi": "New Brunswick, Kanada",
        "ar": "نيو برونزويك ، كندا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Newfoundland and Labrador (Labrador), Canada",
        "ko": "뉴펀들랜드 래브라도(래브라도), 캐나다",
        "sc": "加拿大纽芬兰和拉布拉多（拉布拉多）",
        "es": "Terranova y Labrador (Labrador), Canadá",
        "ru": "Ньюфаундленд и Лабрадор (Лабрадор), Канада",
        "ja": "ニューファンドランド・ラブラドール（ラブラドール）、カナダ",
        "fr": "Terre-Neuve-et-Labrador (Labrador), Canada",
        "de": "Neufundland und Labrador (Labrador), Kanada",
        "it": "Terranova e Labrador (Labrador), Canada",
        "th": "รัฐนิวฟันด์แลนด์และแลบราดอร์ (ลาบราดอร์), แคนาดา",
        "id": "Newfoundland dan Labrador (Labrador), Kanada",
        "vi": "Newfoundland và Labrador (Labrador), Canada",
        "nl": "Newfoundland en Labrador (Labrador), Canada",
        "pl": "Nowa Fundlandia i Labrador (Labrador), Kanada",
        "nb": "Newfoundland og Labrador (Labrador), Canada",
        "fi": "Newfoundland ja Labrador (Labrador), Kanada",
        "ar": "نيوفاوندلاند ولابرادور (لابرادور) ، كندا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Nova Scotia, Canada",
        "ko": "노바스코샤주, 캐나다",
        "sc": "加拿大新斯科舍省",
        "es": "Nueva Escocia, Canadá",
        "ru": "Новая Шотландия, Канада",
        "ja": "カナダ、ノバスコシア",
        "fr": "Nouvelle-Écosse, Canada",
        "de": "Nova Scotia, Kanada",
        "it": "Nuova Scozia, Canada",
        "th": "โนวาสโกเชีย แคนาดา",
        "id": "Nova Scotia, Kanada",
        "vi": "Nova Scotia, Canada",
        "nl": "Nova Scotia, Canada",
        "pl": "Nowa Szkocja, Kanada",
        "nb": "Nova Scotia, Canada",
        "fi": "Nova Scotia, Kanada",
        "ar": "نوفا سكوشا ، كندا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Paraguay",
        "ko": "파라과이",
        "sc": "巴拉圭",
        "es": "Paraguay",
        "ru": "Парагвай",
        "ja": "パラグアイ",
        "fr": "Paraguay",
        "de": "Paraguay",
        "it": "Paraguay",
        "th": "ประเทศปารากวัย",
        "id": "Paraguay",
        "vi": "Paraguay",
        "nl": "Paraguay",
        "pl": "Paragwaj",
        "nb": "Paraguay",
        "fi": "Paraguay",
        "ar": "باراغواي"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Prince Edward Island, Canada",
        "ko": "프린스 에드워드 아일랜드, 캐나다 ",
        "sc": "加拿大爱德华王子岛",
        "es": "Isla del Príncipe Eduardo, Canadá",
        "ru": "Остров Принца Эдуарда, Канада",
        "ja": "プリンスエドワードアイランド、カナダ",
        "fr": "Île-du-Prince-Édouard, Canada",
        "de": "Prince Edward Island, Kanada",
        "it": "Isola del Principe Edoardo, Canada",
        "th": "เกาะปรินซ์เอ็ดเวิร์ด แคนาดา",
        "id": "Pulau Pangeran Edward, Kanada",
        "vi": "Đảo Hoàng tử Edward, Canada",
        "nl": "Prins Edwardeiland, Canada",
        "pl": "Wyspa Księcia Edwarda, Kanada",
        "nb": "Prince Edward Island, Canada",
        "fi": "Prinssi Edwardin saari, Kanada",
        "ar": "جزيرة الأمير إدوارد ، كندا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Puerto Rico",
        "ko": "푸에르토 리코",
        "sc": "波多黎各",
        "es": "Puerto Rico",
        "ru": "Пуэрто-Рико",
        "ja": "プエルトリコ",
        "fr": "Porto Rico",
        "de": "Puerto Rico",
        "it": "Portorico",
        "th": "เปอร์โตริโก้",
        "id": "Puerto Riko",
        "vi": "Puerto Rico",
        "nl": "Puerto Rico",
        "pl": "Portoryko",
        "nb": "Puerto Rico",
        "fi": "Puerto Rico",
        "ar": "بورتوريكو"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Roraima, Brazil",
        "ko": "브라질 로라이마",
        "sc": "巴西罗赖马",
        "es": "Roraima, Brasil",
        "ru": "Рорайма, Бразилия",
        "ja": "ロライマ、ブラジル",
        "fr": "Roraima, Brésil",
        "de": "Roraima, Brasilien",
        "it": "Roraima, Brasile",
        "th": "โรไรมา บราซิล",
        "id": "Roraima, Brasil",
        "vi": "Roraima, Brazil",
        "nl": "Roraima, Brazilië",
        "pl": "Roraima, Brazylia",
        "nb": "Roraima, Brasil",
        "fi": "Roraima, Brasilia",
        "ar": "رورايما ، البرازيل"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Rondonia, Brazil",
        "ko": "브라질 론도니아",
        "sc": "巴西朗多尼亚",
        "es": "Rondonia, Brasil",
        "ru": "Рондония, Бразилия",
        "ja": "ロンドニア、ブラジル",
        "fr": "Rondonie, Brésil",
        "de": "Rondonia, Brasilien",
        "it": "Rondonia, Brasile",
        "th": "รอนโดเนีย บราซิล",
        "id": "Rondonia, Brasil",
        "vi": "Rondonia, Brazil",
        "nl": "Rondonia, Brazilië",
        "pl": "Rondonia, Brazylia",
        "nb": "Rondonia, Brasil",
        "fi": "Rondonia, Brasilia",
        "ar": "روندونيا ، البرازيل"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Saba",
        "ko": "사바섬",
        "sc": "萨巴",
        "es": "Isla de Saba",
        "ru": "Саба",
        "ja": "サバ島",
        "fr": "Saba",
        "de": "Saba",
        "it": "Saba",
        "th": "สะบ้า",
        "id": "saba",
        "vi": "Saba",
        "nl": "Saba",
        "pl": "Saba",
        "nb": "Saba",
        "fi": "Saba",
        "ar": "سابا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Saint Barthelemy",
        "ko": "생 바르텔레미",
        "sc": "圣巴泰勒米",
        "es": "San Bartolomé",
        "ru": "Сен-Бартельми",
        "ja": "サンバルテルミー",
        "fr": "Saint Barthélemy",
        "de": "Heiliger Barthelemäus",
        "it": "San Bartolomeo",
        "th": "นักบุญบาร์เธเลมี",
        "id": "Saint Barthelemy",
        "vi": "Saint Barthelemy",
        "nl": "Sint-Bartholomeus",
        "pl": "Św Barthelemy",
        "nb": "Saint Barthelemy",
        "fi": "Saint Barthelemy",
        "ar": "سانت بارتيليمي"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Saint Kitts and Nevis",
        "ko": "세인트키츠 네비스",
        "sc": "圣基茨和尼维斯",
        "es": "San Cristóbal y Nieves",
        "ru": "Сент-Китс и Невис",
        "ja": "セントクリストファー・ネイビス",
        "fr": "Saint-Christophe-et-Niévès",
        "de": "St. Kitts und Nevis",
        "it": "Saint Kitts e Nevis",
        "th": "เซนต์คิตส์และเนวิส",
        "id": "Saint Kitts dan Nevis",
        "vi": "Saint Kitts và Nevis",
        "nl": "Saint Kitts en Nevis",
        "pl": "Saint Kitts i Nevis",
        "nb": "Saint Kitts og Nevis",
        "fi": "Saint Kitts ja Nevis",
        "ar": "سانت كيتس ونيفيس"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Saint Lucia",
        "ko": "세인트루시아",
        "sc": "圣卢西亚",
        "es": "Santa Lucía",
        "ru": "Сент-Люсия",
        "ja": "セントルシア",
        "fr": "Sainte-Lucie",
        "de": "St. Lucia",
        "it": "Santa Lucia",
        "th": "เซนต์ลูเซีย",
        "id": "Saint Lucia",
        "vi": "Saint Lucia",
        "nl": "Sint Lucia",
        "pl": "święta Lucia",
        "nb": "Saint Lucia",
        "fi": "Saint Lucia",
        "ar": "القديسة لوسيا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Saint Martin",
        "ko": "세인트 마틴",
        "sc": "圣马丁",
        "es": "San Martín",
        "ru": "Сен-Мартен",
        "ja": "サンマルタン",
        "fr": "Saint Martin",
        "de": "Sankt Martin",
        "it": "San Martino",
        "th": "เซนต์มาร์ติน",
        "id": "Saint Martin",
        "vi": "Saint martin",
        "nl": "Sint-Maarten",
        "pl": "święty Marcin",
        "nb": "Saint Martin",
        "fi": "Pyhä Martin",
        "ar": "القديس مارتن"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Saint Vincent and the Grenadines",
        "ko": "세인트 빈센트 그레나딘",
        "sc": "圣文森特和格林纳丁斯",
        "es": "San Vicente y las Granadinas",
        "ru": "Святой Винсент и Гренадины",
        "ja": "セントビンセントおよびグレナディーン諸島",
        "fr": "Saint-Vincent-et-les-Grenadines",
        "de": "St. Vincent und die Grenadinen",
        "it": "Saint Vincent e Grenadine",
        "th": "เซนต์วินเซนต์และเกรนาดีนส์",
        "id": "Saint Vincent dan Grenadines",
        "vi": "Saint Vincent và Grenadines",
        "nl": "Saint Vincent en de Grenadines",
        "pl": "Saint Vincent i Grenadyny",
        "nb": "Saint Vincent og Grenadinene",
        "fi": "Saint Vincent ja Grenadiinit",
        "ar": "سانت فنسنت وجزر غرينادين"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Sint Eustatius",
        "ko": "성 유스타티우스",
        "sc": "圣尤斯特歇斯",
        "es": "San Eustaquio",
        "ru": "Синт-Эстатиус",
        "ja": "シントユースタティウス",
        "fr": "Saint Eustache",
        "de": "Sint Eustatius",
        "it": "Sint Eustatius",
        "th": "ซินต์เอิสทาทิอุส",
        "id": "Sint Eustatius",
        "vi": "Sint Eustatius",
        "nl": "Sint Eustatius",
        "pl": "Sint Eustatius",
        "nb": "Sint Eustatius",
        "fi": "Sint Eustatius",
        "ar": "سينت يوستاتيوس"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Sint Maarten",
        "ko": "세인트 마틴",
        "sc": "圣马丁",
        "es": "San Martín",
        "ru": "Синт-Мартен",
        "ja": "シントマールテン",
        "fr": "Saint-Martin",
        "de": "Sint Maarten",
        "it": "Sint Maarten",
        "th": "ซินต์มาร์เทิน",
        "id": "Sint Maarten",
        "vi": "Sint Maarten",
        "nl": "Sint Maarten",
        "pl": "Sint Maarten",
        "nb": "Sint Maarten",
        "fi": "Sint Maarten",
        "ar": "سينت مارتن"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Trinidad and Tobago",
        "ko": "트리니다드토바고",
        "sc": "特立尼达和多巴哥",
        "es": "Trinidad y Tobago",
        "ru": "Тринидад и Тобаго",
        "ja": "トリニダード・トバゴ",
        "fr": "Trinité-et-Tobago",
        "de": "Trinidad und Tobago",
        "it": "Trinidad e Tobago",
        "th": "ตรินิแดดและโตเบโก",
        "id": "Trinidad dan Tobago",
        "vi": "Trinidad và Tobago",
        "nl": "Trinidad en Tobago",
        "pl": "Trynidad i Tobago",
        "nb": "Trinidad og Tobago",
        "fi": "Trinidad ja Tobago",
        "ar": "ترينداد وتوباغو"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Turks and Caicos Islands",
        "ko": "터크스케이커스 제도",
        "sc": "特克斯和凯科斯群岛",
        "es": "Islas Turcas y Caicos",
        "ru": "острова Теркс и Кайкос",
        "ja": "タークス・カイコス諸島",
        "fr": "îles Turques-et-Caïques",
        "de": "Turks- und Caicosinseln",
        "it": "Isole Turks e Caicos",
        "th": "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
        "id": "Kepulauan Turks dan Caicos",
        "vi": "Quần đảo Turks và Caicos",
        "nl": "Turks- en Caicoseilanden",
        "pl": "Wyspy Turks i Caicos",
        "nb": "Turks- og Caicosøyene",
        "fi": "Turks-ja Caicossaaret",
        "ar": "جزر تركس وكايكوس"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "US Virgin Islands",
        "ko": "미국령 버진 아일랜드",
        "sc": "美属维尔京群岛",
        "es": "Islas Vírgenes de EE.UU",
        "ru": "Виргинские острова США",
        "ja": "アメリカ領バージン諸島",
        "fr": "Îles Vierges américaines",
        "de": "US Jungferninseln",
        "it": "Isole Vergini americane",
        "th": "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
        "id": "Kepulauan Virgin AS",
        "vi": "Quần đảo Virgin thuộc Hoa Kỳ",
        "nl": "Amerikaanse Maagdeneilanden",
        "pl": "Wyspy Dziewicze Stanów Zjednoczonych",
        "nb": "De amerikanske jomfruøyene",
        "fi": "Yhdysvaltain Neitsytsaaret",
        "ar": "جزر فيرجن الأمريكية"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Venezuela",
        "ko": "베네수엘라",
        "sc": "委内瑞拉",
        "es": "Venezuela",
        "ru": "Венесуэла",
        "ja": "ベネズエラ",
        "fr": "Venezuela",
        "de": "Venezuela",
        "it": "Venezuela",
        "th": "เวเนซุเอลา",
        "id": "Venezuela",
        "vi": "Venezuela",
        "nl": "Venezuela",
        "pl": "Wenezuela",
        "nb": "Venezuela",
        "fi": "Venezuela",
        "ar": "فنزويلا"
    },
    {
        "value": -400,
        "prefix": "(GMT-04:00)",
        "en": "Quebec (Blanc-Sablon), Canada",
        "ko": "퀘벡(블렁-싸블롱), 캐나다",
        "sc": "魁北克（布兰克-萨布隆），加拿大",
        "es": "Québec (Blanc-Sablon), Canadá",
        "ru": "Квебек (Блан-Саблон), Канада",
        "ja": "ケベック（ブランサブロン）、カナダ",
        "fr": "Québec (Blanc-Sablon), Canada",
        "de": "Quebec (Blanc-Sablon), Kanada",
        "it": "Quebec (Blanc-Sablon), Canada",
        "th": "ควิเบก (Blanc-Sablon), แคนาดา",
        "id": "Quebec (Blanc-Sablon), Kanada",
        "vi": "Quebec (Blanc-Sablon), Canada",
        "nl": "Quebec (Blanc-Sablon), Canada",
        "pl": "Quebec (Blanc-Sablon), Kanada",
        "nb": "Quebec (Blanc-Sablon), Canada",
        "fi": "Quebec (Blanc-Sablon), Kanada",
        "ar": "كيبيك (بلانك سابلون) ، كندا"
    },
    {
        "value": -330,
        "prefix": "(GMT-03:30)",
        "en": "Newfoundland and Labrador (Newfoundland), Canada",
        "ko": "뉴펀들랜드 및 래브라도(뉴펀들랜드), 캐나다",
        "sc": "加拿大纽芬兰和拉布拉多（纽芬兰）",
        "es": "Terranova y Labrador (Terranova), Canadá",
        "ru": "Ньюфаундленд и Лабрадор (Ньюфаундленд), Канада",
        "ja": "ニューファンドランド・ラブラドール州（ニューファンドランド）、カナダ",
        "fr": "Terre-Neuve-et-Labrador (Terre-Neuve), Canada",
        "de": "Neufundland und Labrador (Neufundland), Kanada",
        "it": "Terranova e Labrador (Terranova), Canada",
        "th": "รัฐนิวฟันด์แลนด์และแลบราดอร์ (เกาะนิวฟันด์แลนด์), แคนาดา",
        "id": "Newfoundland dan Labrador (Newfoundland), Kanada",
        "vi": "Newfoundland và Labrador (Newfoundland), Canada",
        "nl": "Newfoundland en Labrador (Newfoundland), Canada",
        "pl": "Nowa Fundlandia i Labrador (Nowa Fundlandia), Kanada",
        "nb": "Newfoundland og Labrador (Newfoundland), Canada",
        "fi": "Newfoundland ja Labrador (Newfoundland), Kanada",
        "ar": "نيوفاوندلاند ولابرادور (نيوفاوندلاند) ، كندا"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Alagoas, Brazil",
        "ko": "알라고아스, 브라질",
        "sc": "巴西阿拉戈斯",
        "es": "Alagoas, Brasil",
        "ru": "Алагоас, Бразилия",
        "ja": "アラゴアス、ブラジル",
        "fr": "Alagoas, Brésil",
        "de": "Alagoas, Brasilien",
        "it": "Alagoas, Brasile",
        "th": "อาลาโกอัส, บราซิล",
        "id": "Alagoas, Brasil",
        "vi": "Alagoas, Brazil",
        "nl": "Alagoas, Brazilië",
        "pl": "Alagoas, Brazylia",
        "nb": "Alagoas, Brasil",
        "fi": "Alagoas, Brasilia",
        "ar": "ألاغواس ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Amapa, Brazil",
        "ko": "아마파, 브라질",
        "sc": "巴西阿马帕",
        "es": "Amapá, Brasil",
        "ru": "Амапа, Бразилия",
        "ja": "アマパ、ブラジル",
        "fr": "Amapá, Brésil",
        "de": "Amapá, Brasilien",
        "it": "Amapa, Brasile",
        "th": "รัฐอามาปา, บราซิล",
        "id": "Amapa, Brasil",
        "vi": "Amapa, Brazil",
        "nl": "Amapa, Brazilië",
        "pl": "Amapa, Brazylia",
        "nb": "Amapa, Brasil",
        "fi": "Amapa, Brasilia",
        "ar": "أمابا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Argentina",
        "ko": "아르헨티나",
        "sc": "阿根廷",
        "es": "Argentina",
        "ru": "Аргентина",
        "ja": "アルゼンチン",
        "fr": "Argentine",
        "de": "Argentinien",
        "it": "Argentina",
        "th": "อาร์เจนตินา",
        "id": "Argentina",
        "vi": "Argentina",
        "nl": "Argentinië",
        "pl": "Argentyna",
        "nb": "Argentina",
        "fi": "Argentiina",
        "ar": "الأرجنتين"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Bahia, Brazil",
        "ko": "바이아, 브라질",
        "sc": "巴西巴伊亚",
        "es": "Bahía, Brasil",
        "ru": "Баия, Бразилия",
        "ja": "バイーア州、ブラジル",
        "fr": "Bahia, Brésil",
        "de": "Bahía, Brasilien",
        "it": "Bahia, Brasile",
        "th": "บาเฮีย บราซิล",
        "id": "Bahia, Brasil",
        "vi": "Bahia, Brazil",
        "nl": "Bahia, Brazilië",
        "pl": "Bahia, Brazylia",
        "nb": "Bahia, Brasil",
        "fi": "Bahia, Brasilia",
        "ar": "باهيا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Ceara, Brazil",
        "ko": "세아라, 브라질",
        "sc": "巴西塞阿拉",
        "es": "Ceará, Brasil",
        "ru": "Сеара, Бразилия",
        "ja": "セアラ、ブラジル",
        "fr": "Ceara, Brésil",
        "de": "Ceara, Brasilien",
        "it": "Ceará, Brasile",
        "th": "รัฐเซอารา, บราซิล",
        "id": "Ceara, Brasil",
        "vi": "Ceara, Brazil",
        "nl": "Ceará, Brazilië",
        "pl": "Ceara, Brazylia",
        "nb": "Ceara, Brasil",
        "fi": "Ceara, Brasilia",
        "ar": "سيارا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Chile, Magallanes Region",
        "ko": "칠레, 마가야네스 지역",
        "sc": "智利，麦哲伦地区",
        "es": "Chile, Región de Magallanes",
        "ru": "Чили, Магальянес",
        "ja": "チリ、マガジャネス地域",
        "fr": "Chili, région de Magallanes",
        "de": "Chile, Region Magallanes",
        "it": "Cile, regione di Magallanes",
        "th": "ชิลี แคว้นมากายาเนส",
        "id": "Chili, Wilayah Magallanes",
        "vi": "Chile, Vùng Magallanes",
        "nl": "Chili, regio Magallanes",
        "pl": "Chile, Region Magallanes",
        "nb": "Chile, Magallanes-regionen",
        "fi": "Chile, Magallanesin alue",
        "ar": "شيلي ، منطقة ماجالانيس"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Distrito Federal, Brazil",
        "ko": "디스트리토, 브라질 연방",
        "sc": "巴西联邦区",
        "es": "Distrito Federal, Brasil",
        "ru": "Федеральный округ, Бразилия",
        "ja": "ブラジル連邦直轄区",
        "fr": "District fédéral, Brésil",
        "de": "Distrito Federal, Brasilien",
        "it": "Distretto Federale, Brasile",
        "th": "เฟเดอรัลดิสตริกต์, บราซิล",
        "id": "Distrito Federal, Brasil",
        "vi": "Liên bang Distrito, Brazil",
        "nl": "Distrito Federal, Brazilië",
        "pl": "Dystrykt Federalny, Brazylia",
        "nb": "Distrito Federal, Brasil",
        "fi": "Distrito Federal, Brasilia",
        "ar": "ديستريتو فيدرال ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Espirito Santo, Brazil",
        "ko": "이스피리투산투 주, 브라질",
        "sc": "巴西圣埃斯皮里图",
        "es": "Espírito Santo, Brasil",
        "ru": "Эспириту-Санту, Бразилия",
        "ja": "エスピリトサント、ブラジル",
        "fr": "Espirito Santo, Brésil",
        "de": "Espírito Santo, Brasilien",
        "it": "Espírito Santo, Brasile",
        "th": "เอสปีรีตูซันตู บราซิล",
        "id": "Espirito Santo, Brasil",
        "vi": "Espirito Santo, Brazil",
        "nl": "Espírito Santo, Brazilië",
        "pl": "Espirito Santo, Brazylia",
        "nb": "Espirito Santo, Brasil",
        "fi": "Espirito Santo, Brasilia",
        "ar": "اسبيريتو سانتو ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Falkland Islands",
        "ko": "포클랜드 제도",
        "sc": "福克兰群岛",
        "es": "Islas Malvinas",
        "ru": "Фолклендские острова",
        "ja": "フォークランド諸島",
        "fr": "les îles Falkland",
        "de": "Falkland Inseln",
        "it": "Isole Falkland",
        "th": "หมู่เกาะฟอล์กแลนด์",
        "id": "Kepulauan Falkland",
        "vi": "Quần đảo Falkland",
        "nl": "Falkland Eilanden",
        "pl": "Falklandy",
        "nb": "Falklandsøyene",
        "fi": "Falkland saaret",
        "ar": "جزر فوكلاند"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "French Guiana",
        "ko": "프랑스령 기아나",
        "sc": "法属圭亚那",
        "es": "Guayana Francesa",
        "ru": "Французская Гвиана",
        "ja": "フランス領ギアナ",
        "fr": "Guyane Française",
        "de": "Französisch-Guayana",
        "it": "Guiana francese",
        "th": "เฟรนช์เกียนา",
        "id": "Guyana Perancis",
        "vi": "Guiana thuộc Pháp",
        "nl": "Frans Guyana",
        "pl": "Gujana Francuska",
        "nb": "fransk Guyana",
        "fi": "Ranskan Guayana",
        "ar": "غيانا الفرنسية"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Goias, Brazil",
        "ko": "고이아스, 브라질",
        "sc": "巴西戈亚斯",
        "es": "Goiás, Brasil",
        "ru": "Гояс, Бразилия",
        "ja": "ゴイアス、ブラジル",
        "fr": "Goias, Brésil",
        "de": "Goias, Brasilien",
        "it": "Goia, Brasile",
        "th": "โกยาส, บราซิล",
        "id": "Goias, Brasil",
        "vi": "Goias, Brazil",
        "nl": "Goias, Brazilië",
        "pl": "Goias, Brazylia",
        "nb": "Goias, Brasil",
        "fi": "Goias, Brasilia",
        "ar": "جوياس ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Greenland",
        "ko": "그린란드",
        "sc": "格陵兰",
        "es": "Groenlandia",
        "ru": "Гренландия",
        "ja": "グリーンランド",
        "fr": "Groenland",
        "de": "Grönland",
        "it": "Groenlandia",
        "th": "กรีนแลนด์",
        "id": "Greenland",
        "vi": "Greenland",
        "nl": "Groenland",
        "pl": "Grenlandia",
        "nb": "Grønland",
        "fi": "Grönlanti",
        "ar": "جرينلاند"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Maranhao, Brazil",
        "ko": "마라냐오, 브라질",
        "sc": "巴西马拉尼奥",
        "es": "Maranhão, Brasil",
        "ru": "Мараньян, Бразилия",
        "ja": "ブラジル、マラニャン",
        "fr": "Maranhão, Brésil",
        "de": "Maranhao, Brasilien",
        "it": "Maranhao, Brasile",
        "th": "มารันเฮา บราซิล",
        "id": "Maranhao, Brasil",
        "vi": "Maranhao, Brazil",
        "nl": "Maranho, Brazilië",
        "pl": "Maranhao, Brazylia",
        "nb": "Maranhao, Brasil",
        "fi": "Maranhao, Brasilia",
        "ar": "مارانهاو ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Minas Gerais, Brazil",
        "ko": "미나스 제라이스, 브라질",
        "sc": "巴西米纳斯吉拉斯州",
        "es": "Minas Gerais, Brasil",
        "ru": "Минас-Жерайс, Бразилия",
        "ja": "ミナスジェライス、ブラジル",
        "fr": "Minas Gerais, Brésil",
        "de": "Minas Gerais, Brasilien",
        "it": "Minas Gerais, Brasile",
        "th": "มินัสเชไรส์, บราซิล",
        "id": "Minas Gerais, Brasil",
        "vi": "Minas Gerais, Brazil",
        "nl": "Minas Gerais, Brazilië",
        "pl": "Minas Gerais, Brazylia",
        "nb": "Minas Gerais, Brasil",
        "fi": "Minas Gerais, Brasilia",
        "ar": "ميناس جيرايس ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Para, Brazil",
        "ko": "파라, 브라질",
        "sc": "帕拉，巴西",
        "es": "Pará, Brasil",
        "ru": "Пара, Бразилия",
        "ja": "パラ、ブラジル",
        "fr": "Pará, Brésil",
        "de": "Para, Brasilien",
        "it": "Para, Brasile",
        "th": "รัฐปารา, บราซิล",
        "id": "Para, Brasil",
        "vi": "Para, Brazil",
        "nl": "Para, Brazilië",
        "pl": "Pará, Brazylia",
        "nb": "Para, Brasil",
        "fi": "Para, Brasilia",
        "ar": "بارا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Paraiba, Brazil",
        "ko": "파라이바, 브라질",
        "sc": "巴西帕拉伊巴",
        "es": "Paraíba, Brasil",
        "ru": "Параиба, Бразилия",
        "ja": "パライバ、ブラジル",
        "fr": "Paraïba, Brésil",
        "de": "Paraiba, Brasilien",
        "it": "Paraiba, Brasile",
        "th": "รัฐปาราอีบา, บราซิล",
        "id": "Paraiba, Brasil",
        "vi": "Paraiba, Brazil",
        "nl": "Paraiba, Brazilië",
        "pl": "Paraiba, Brazylia",
        "nb": "Paraiba, Brasil",
        "fi": "Paraiba, Brasilia",
        "ar": "بارايبا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Parana, Brazil",
        "ko": "파라나, 브라질",
        "sc": "巴西巴拉那",
        "es": "Paraná, Brasil",
        "ru": "Парана, Бразилия",
        "ja": "パラナ、ブラジル",
        "fr": "Paraná, Brésil",
        "de": "Parana, Brasilien",
        "it": "Paranà, Brasile",
        "th": "รัฐปารานา, บราซิล",
        "id": "Parana, Brasil",
        "vi": "Parana, Brazil",
        "nl": "Paraná, Brazilië",
        "pl": "Parana, Brazylia",
        "nb": "Parana, Brasil",
        "fi": "Parana, Brasilia",
        "ar": "بارانا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Pernambuco, Brazil",
        "ko": "페르남부쿠, 브라질",
        "sc": "巴西伯南布哥",
        "es": "Pernambuco, Brasil",
        "ru": "Пернамбуку, Бразилия",
        "ja": "ペルナンブコ、ブラジル",
        "fr": "Pernambouc, Brésil",
        "de": "Pernambuco, Brasilien",
        "it": "Pernambuco, Brasile",
        "th": "เปร์นัมบูโก, บราซิล",
        "id": "Pernambuco, Brasil",
        "vi": "Pernambuco, Brazil",
        "nl": "Pernambuco, Brazilië",
        "pl": "Pernambuco, Brazylia",
        "nb": "Pernambuco, Brasil",
        "fi": "Pernambuco, Brasilia",
        "ar": "بيرنامبوكو ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Piaui, Brazil",
        "ko": "피아우이, 브라질",
        "sc": "巴西皮奥伊",
        "es": "Piauí, Brasil",
        "ru": "Пиауи, Бразилия",
        "ja": "ピアウイ、ブラジル",
        "fr": "Piauí, Brésil",
        "de": "Piauí, Brasilien",
        "it": "Piaui, Brasile",
        "th": "รัฐปีเอาอี, บราซิล",
        "id": "Piaui, Brasil",
        "vi": "Piaui, Brazil",
        "nl": "Piaui, Brazilië",
        "pl": "Piaui, Brazylia",
        "nb": "Piaui, Brasil",
        "fi": "Piaui, Brasilia",
        "ar": "بياوي ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Rio de Janeiro, Brazil",
        "ko": "리우데자네이루, 브라질",
        "sc": "巴西里约热内卢",
        "es": "Rio de Janeiro, Brasil",
        "ru": "Рио-де-Жанейро, Бразилия",
        "ja": "リオデジャネイロ、ブラジル",
        "fr": "Rio de Janeiro, Brésil",
        "de": "Rio de Janeiro, Brasilien",
        "it": "Rio de Janeiro, Brasile",
        "th": "รีโอเดจาเนโร บราซิล",
        "id": "Rio de Janeiro, Brasil",
        "vi": "Rio de Janeiro, Brazil",
        "nl": "Rio de Janeiro, Brazilië",
        "pl": "Rio de Janeiro, Brazylia",
        "nb": "Rio de Janeiro, Brasil",
        "fi": "Rio de Janeiro, Brasilia",
        "ar": "ريو دي جانيرو، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Rio Grande do Norte, Brazil",
        "ko": "리오그란데두노르테, 브라질",
        "sc": "巴西北里奥格兰德",
        "es": "Río Grande del Norte, Brasil",
        "ru": "Риу-Гранди-ду-Норти, Бразилия",
        "ja": "リオグランデドノルテ、ブラジル",
        "fr": "Rio Grande do Norte, Brésil",
        "de": "Rio Grande do Norte, Brasilien",
        "it": "Rio Grande do Norte, Brasile",
        "th": "รีโอกรันดีดูนอร์เต บราซิล",
        "id": "Rio Grande do Norte, Brasil",
        "vi": "Rio Grande do Norte, Brazil",
        "nl": "Rio Grande do Norte, Brazilië",
        "pl": "Rio Grande do Norte, Brazylia",
        "nb": "Rio Grande do Norte, Brasil",
        "fi": "Rio Grande do Norte, Brasilia",
        "ar": "ريو غراندي دو نورتي ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Rio Grande do Sul, Brazil",
        "ko": "리오그란데두술, 브라질",
        "sc": "巴西南里奥格兰德",
        "es": "Rio Grande do Sul, Brasil",
        "ru": "Риу-Гранди-ду-Сул, Бразилия",
        "ja": "リオグランデドスル、ブラジル",
        "fr": "Rio Grande do Sul, Brésil",
        "de": "Rio Grande do Sul, Brasilien",
        "it": "Rio Grande do Sul, Brasile",
        "th": "รีโอกรันดีดูซูล บราซิล",
        "id": "Rio Grande do Sul, Brasil",
        "vi": "Rio Grande do Sul, Brazil",
        "nl": "Rio Grande do Sul, Brazilië",
        "pl": "Rio Grande do Sul, Brazylia",
        "nb": "Rio Grande do Sul, Brasil",
        "fi": "Rio Grande do Sul, Brasilia",
        "ar": "ريو غراندي دو سول ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Saint Pierre and Miquelon",
        "ko": "생 피에르와 미클롱",
        "sc": "圣皮埃尔和密克隆",
        "es": "San Pedro y Miquelón",
        "ru": "Сен-Пьер и Микелон",
        "ja": "サンピエール島とミクロン島",
        "fr": "Saint-Pierre-et-Miquelon",
        "de": "St. Pierre und Miquelon",
        "it": "Saint Pierre e Miquelon",
        "th": "แซงปีแยร์และมีเกอลง",
        "id": "Saint Pierre dan Miquelon",
        "vi": "Saint Pierre và Miquelon",
        "nl": "Saint Pierre en Miquelon",
        "pl": "Saint-Pierre i Miquelon",
        "nb": "Saint Pierre og Miquelon",
        "fi": "Saint Pierre ja Miquelon",
        "ar": "سانت بيير وميكلون"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Santa Catarina, Brazil",
        "ko": "산타 카타리나, 브라질",
        "sc": "巴西圣卡塔琳娜",
        "es": "Santa Catarina, Brasil",
        "ru": "Санта-Катарина, Бразилия",
        "ja": "サンタカタリーナ、ブラジル",
        "fr": "Santa Catarina, Brésil",
        "de": "Santa Catarina, Brasilien",
        "it": "Santa Catarina, Brasile",
        "th": "ซานตา กาตารีนา บราซิล",
        "id": "Santa Catarina, Brasil",
        "vi": "Santa Catarina, Brazil",
        "nl": "Santa Catarina, Brazilië",
        "pl": "Santa Catarina, Brazylia",
        "nb": "Santa Catarina, Brasil",
        "fi": "Santa Catarina, Brasilia",
        "ar": "سانتا كاتارينا ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Sergipe, Brazil",
        "ko": "세르지페, 브라질",
        "sc": "巴西塞尔希佩",
        "es": "Sergipe, Brasil",
        "ru": "Сержипи, Бразилия",
        "ja": "セルジッペ、ブラジル",
        "fr": "Sergipé, Brésil",
        "de": "Sergipe, Brasilien",
        "it": "Sergipe, Brasile",
        "th": "รัฐแซร์จีปี, บราซิล",
        "id": "Sergipe, Brasil",
        "vi": "Sergipe, Brazil",
        "nl": "Sergipe, Brazilië",
        "pl": "Sergipe, Brazylia",
        "nb": "Sergipe, Brasil",
        "fi": "Sergipe, Brasilia",
        "ar": "سيرغيبي ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Sao Paulo, Brazil",
        "ko": "상파울루, 브라질",
        "sc": "巴西圣保罗",
        "es": "São Paulo, Brasil",
        "ru": "Сан-Паулу, Бразилия",
        "ja": "サンパウロ、ブラジル",
        "fr": "São Paulo, Brésil",
        "de": "Sao Paulo, Brasilien",
        "it": "San Paolo, Brasile",
        "th": "เซาเปาโล บราซิล",
        "id": "Sao Paulo, Brasil",
        "vi": "São Paulo, Brazil",
        "nl": "São Paulo, Brazilië",
        "pl": "São Paulo, Brazylia",
        "nb": "São Paulo, Brasil",
        "fi": "Sao Paulo, Brasilia",
        "ar": "ساو باولو، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Suriname",
        "ko": "수리남",
        "sc": "苏里南",
        "es": "Surinam",
        "ru": "Суринам",
        "ja": "スリナム",
        "fr": "Suriname",
        "de": "Surinam",
        "it": "Suriname",
        "th": "ซูรินาเม",
        "id": "Suriname",
        "vi": "Suriname",
        "nl": "Suriname",
        "pl": "Surinam",
        "nb": "Surinam",
        "fi": "Suriname",
        "ar": "سورينام"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Tocantins, Brazil",
        "ko": "토칸틴, 브라질",
        "sc": "巴西托坎廷斯",
        "es": "Tocantins, Brasil",
        "ru": "Токантинс, Бразилия",
        "ja": "トカンティンス、ブラジル",
        "fr": "Tocantins, Brésil",
        "de": "Tocantins, Brasilien",
        "it": "Tocantins, Brasile",
        "th": "รัฐโตกังจิงช์, บราซิล",
        "id": "Tocantins, Brasil",
        "vi": "Tocantins, Brazil",
        "nl": "Tocantins, Brazilië",
        "pl": "Tocantins, Brazylia",
        "nb": "Tocantins, Brasil",
        "fi": "Tocantins, Brasilia",
        "ar": "توكانتينز ، البرازيل"
    },
    {
        "value": -300,
        "prefix": "(GMT-03:00)",
        "en": "Uruguay",
        "ko": "우루과이",
        "sc": "乌拉圭",
        "es": "Uruguay",
        "ru": "Уругвай",
        "ja": "ウルグアイ",
        "fr": "Uruguay",
        "de": "Uruguay",
        "it": "Uruguay",
        "th": "อุรุกวัย",
        "id": "Uruguay",
        "vi": "Uruguay",
        "nl": "Uruguay",
        "pl": "Urugwaj",
        "nb": "Uruguay",
        "fi": "Uruguay",
        "ar": "أوروغواي"
    },
    {
        "value": -200,
        "prefix": "(GMT-02:00)",
        "en": "Fernando de Noronha, Brazil",
        "ko": "페르난도 데 노로냐, 브라질",
        "sc": "费尔南多·迪诺罗尼亚，巴西",
        "es": "Fernando de Noronha, Brasil",
        "ru": "Фернандо де Норонья, Бразилия",
        "ja": "フェルナンドデノローニャ、ブラジル",
        "fr": "Fernando de Noronha, Brésil",
        "de": "Fernando de Noronha, Brasilien",
        "it": "Fernando de Noronha, Brasile",
        "th": "เฟร์นานโด เด โนรอนญา บราซิล",
        "id": "Fernando de Noronha, Brasil",
        "vi": "Fernando de Noronha, Brazil",
        "nl": "Fernando de Noronha, Brazilië",
        "pl": "Fernando de Noronha, Brazylia",
        "nb": "Fernando de Noronha, Brasil",
        "fi": "Fernando de Noronha, Brasilia",
        "ar": "فرناندو دي نورونها ، البرازيل"
    },
    {
        "value": -200,
        "prefix": "(GMT-02:00)",
        "en": "South Georgia Island ",
        "ko": "사우스 조지아 섬",
        "sc": "南乔治亚岛",
        "es": "Isla Georgia del Sur",
        "ru": "Остров Южная Джорджия",
        "ja": "サウスジョージア島",
        "fr": "Île de Géorgie du Sud",
        "de": "Insel Südgeorgien",
        "it": "Isola della Georgia del Sud",
        "th": "เกาะเซาท์จอร์เจีย",
        "id": "Pulau Georgia Selatan",
        "vi": "Đảo Nam Georgia",
        "nl": "Eiland van Zuid-Georgia",
        "pl": "Georgia Południowa",
        "nb": "Sør-Georgia-øya",
        "fi": "Etelä-Georgian saari",
        "ar": "جزيرة جورجيا الجنوبية"
    },
    {
        "value": -200,
        "prefix": "(GMT-02:00)",
        "en": "Trindade, Brazil",
        "ko": "트린다데, 브라질",
        "sc": "巴西特林达德",
        "es": "Trinidad, Brasil",
        "ru": "Триндади, Бразилия",
        "ja": "トリンダーデ、ブラジル",
        "fr": "Trindade, Brésil",
        "de": "Trindade, Brasilien",
        "it": "Trindade, Brasile",
        "th": "Trindade, บราซิล",
        "id": "Trindade, Brasil",
        "vi": "Trindade, Brazil",
        "nl": "Trindade, Brazilië",
        "pl": "Trindade, Brazylia",
        "nb": "Trindade, Brasil",
        "fi": "Trindade, Brasilia",
        "ar": "ترينداد ، البرازيل"
    },
    {
        "value": -100,
        "prefix": "(GMT-01:00)",
        "en": "Cabo Verde",
        "ko": "카보 베르데",
        "sc": "佛得角",
        "es": "Cabo Verde",
        "ru": "Кабо-Верде",
        "ja": "カーボベルデ",
        "fr": "Cap-Vert",
        "de": "Cabo Verde",
        "it": "Capo Verde",
        "th": "ประเทศกาบูเวร์ดี",
        "id": "Cabo Verde",
        "vi": "Cabo Verde",
        "nl": "Kaapverdië",
        "pl": "Cabo Verde",
        "nb": "Cabo Verde",
        "fi": "Cabo Verde",
        "ar": "كابو فيردي"
    },
    {
        "value": -100,
        "prefix": "(GMT-01:00)",
        "en": "Greenland, Ittoqqortoormiit",
        "ko": "그린란드, 이토코르토르미우트",
        "sc": "格陵兰岛，伊托克图尔米特",
        "es": "Groenlandia, Ittoqqortoormiit",
        "ru": "Гренландия, Иттоккортоормиит",
        "ja": "グリーンランド、イットコルトールミート",
        "fr": "Groenland, Ittoqqortoormiit",
        "de": "Grönland, Ittoqqortoormiit",
        "it": "Groenlandia, Ittoqqortoormiit",
        "th": "กรีนแลนด์ อิตต็อกคอร์ทูร์มิต",
        "id": "Greenland, Ittoqqortoormiit",
        "vi": "Greenland, Ittoqqortoormiit",
        "nl": "Groenland, Ittoqqortoormiit",
        "pl": "Grenlandia, Ittoqqortoormiit",
        "nb": "Grønland, Ittoqqortoormiit",
        "fi": "Grönlanti, Ittoqqortoormiit",
        "ar": "جرينلاند ، Ittoqqortoormiit"
    },
    {
        "value": -100,
        "prefix": "(GMT-01:00)",
        "en": "Portugal, Azores",
        "ko": "포르투갈, 아조레스 제도",
        "sc": "葡萄牙、亚速尔群岛",
        "es": "Portugal, Azores",
        "ru": "Португалия, Азорские острова",
        "ja": "ポルトガル、アゾレス諸島",
        "fr": "Portugal, Açores",
        "de": "Portugal, Azoren",
        "it": "Portogallo, Azzorre",
        "th": "โปรตุเกส, อะซอเรส",
        "id": "Portugal, Azores",
        "vi": "Bồ Đào Nha, Azores",
        "nl": "Portugal, Azoren",
        "pl": "Portugalia, Azory",
        "nb": "Portugal, Azorene",
        "fi": "Portugali, Azorit",
        "ar": "البرتغال ، جزر الأزور"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Ascension Island",
        "ko": "아센시온 아일랜드",
        "sc": "阿森松岛",
        "es": "Isla Ascensión",
        "ru": "Остров Вознесения",
        "ja": "アセンション島",
        "fr": "Île de l'Ascension",
        "de": "Himmelfahrtsinsel",
        "it": "Isola dell'Ascensione",
        "th": "เกาะอัสเซนชัน",
        "id": "Pulau Ascension",
        "vi": "Đảo Ascension",
        "nl": "Hemelvaart Eiland",
        "pl": "Wyspa Wniebowstąpienia",
        "nb": "Ascension Island",
        "fi": "Ascension Island",
        "ar": "جزيرة أسنسيون"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Burkina Faso",
        "ko": "부키 나 파소",
        "sc": "布基纳法索",
        "es": "Burkina Faso",
        "ru": "Буркина-Фасо",
        "ja": "ブルキナファソ",
        "fr": "Burkina Faso",
        "de": "Burkina Faso",
        "it": "Burkina Faso",
        "th": "บูร์กินาฟาโซ",
        "id": "Burkina Faso",
        "vi": "Burkina Faso",
        "nl": "Burkina Faso",
        "pl": "Burkina Faso",
        "nb": "Burkina Faso",
        "fi": "Burkina Faso",
        "ar": "بوركينا فاسو"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Cote d'Ivoire",
        "ko": "코트디부아르",
        "sc": "科特迪瓦",
        "es": "Costa de Marfil",
        "ru": "Кот-д’Ивуар",
        "ja": "コートジボワール",
        "fr": "Côte d'Ivoire",
        "de": "Elfenbeinküste",
        "it": "Costa d'Avorio",
        "th": "ประเทศโกตดิวัวร์",
        "id": "Pantai Gading",
        "vi": "Bờ Biển Ngà",
        "nl": "Ivoorkust",
        "pl": "Wybrzeże Kości Słoniowej",
        "nb": "Elfenbenskysten",
        "fi": "Norsunluurannikko",
        "ar": "كوت ديفوار"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Faroe Islands",
        "ko": "페로 제도",
        "sc": "法罗群岛",
        "es": "Islas Faroe",
        "ru": "Фарерские острова",
        "ja": "フェロー諸島",
        "fr": "Îles Féroé",
        "de": "Färöer Inseln",
        "it": "Isole Faroe",
        "th": "หมู่เกาะแฟโร",
        "id": "Kepulauan Faroe",
        "vi": "Quần đảo Faroe",
        "nl": "Faeröer",
        "pl": "Wyspy Owcze",
        "nb": "Færøyene",
        "fi": "Färsaaret",
        "ar": "جزر فاروس"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Gambia",
        "ko": "감비아",
        "sc": "冈比亚",
        "es": "Gambia",
        "ru": "Гамбия",
        "ja": "ガンビア",
        "fr": "Gambie",
        "de": "Gambia",
        "it": "Gambia",
        "th": "แกมเบีย",
        "id": "Gambia",
        "vi": "Gambia",
        "nl": "Gambia",
        "pl": "Gambia",
        "nb": "Gambia",
        "fi": "Gambia",
        "ar": "غامبيا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Ghana",
        "ko": "가나",
        "sc": "加纳",
        "es": "Ghana",
        "ru": "Гана",
        "ja": "ガーナ",
        "fr": "Ghana",
        "de": "Ghana",
        "it": "Ghana",
        "th": "กานา",
        "id": "Ghana",
        "vi": "Ghana",
        "nl": "Ghana",
        "pl": "Ghana",
        "nb": "Ghana",
        "fi": "Ghana",
        "ar": "غانا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Greenland",
        "ko": "그린란드",
        "sc": "格陵兰",
        "es": "Groenlandia",
        "ru": "Гренландия",
        "ja": "グリーンランド",
        "fr": "Groenland",
        "de": "Grönland",
        "it": "Groenlandia",
        "th": "กรีนแลนด์",
        "id": "Greenland",
        "vi": "Greenland",
        "nl": "Groenland",
        "pl": "Grenlandia",
        "nb": "Grønland",
        "fi": "Grönlanti",
        "ar": "جرينلاند"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Guernsey",
        "ko": "건지",
        "sc": "根西岛",
        "es": "Guernesey",
        "ru": "Гернси",
        "ja": "ガーンジー",
        "fr": "Guernesey",
        "de": "Guernsey",
        "it": "Guernsey",
        "th": "เกิร์นซีย์",
        "id": "Guernsey",
        "vi": "Guernsey",
        "nl": "Guernsey",
        "pl": "Guernsey",
        "nb": "Guernsey",
        "fi": "Guernseyssä",
        "ar": "غيرنسي"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Guinea",
        "ko": "기니",
        "sc": "几内亚",
        "es": "Guinea",
        "ru": "Гвинея",
        "ja": "ギニア",
        "fr": "Guinée",
        "de": "Guinea",
        "it": "Guinea",
        "th": "กินี",
        "id": "Guinea",
        "vi": "Guinea",
        "nl": "Guinea",
        "pl": "Gwinea",
        "nb": "Guinea",
        "fi": "Guinea",
        "ar": "غينيا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Guinea-Bissau",
        "ko": "기니비사우",
        "sc": "几内亚比绍",
        "es": "Guinea-Bisáu",
        "ru": "Гвинея-Бисау",
        "ja": "ギニアビサウ",
        "fr": "Guinée-Bissau",
        "de": "Guinea-Bissau",
        "it": "Guinea Bissau",
        "th": "กินี-บิสเซา",
        "id": "Guinea-Bissau",
        "vi": "Guinea-Bissau",
        "nl": "Guinee-Bissau",
        "pl": "Gwinea Bissau",
        "nb": "Guinea-Bissau",
        "fi": "Guinea-Bissau",
        "ar": "غينيا بيساو"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Iceland",
        "ko": "아이슬란드",
        "sc": "冰岛",
        "es": "Islandia",
        "ru": "Исландия",
        "ja": "アイスランド",
        "fr": "Islande",
        "de": "Island",
        "it": "Islanda",
        "th": "ไอซ์แลนด์",
        "id": "Islandia",
        "vi": "Nước Iceland",
        "nl": "IJsland",
        "pl": "Islandia",
        "nb": "Island",
        "fi": "Islanti",
        "ar": "أيسلندا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Ireland",
        "ko": "아일랜드",
        "sc": "爱尔兰",
        "es": "Irlanda",
        "ru": "Ирландия",
        "ja": "アイルランド",
        "fr": "Irlande",
        "de": "Irland",
        "it": "Irlanda",
        "th": "ไอร์แลนด์",
        "id": "Irlandia",
        "vi": "Ailen",
        "nl": "Ierland",
        "pl": "Irlandia",
        "nb": "Irland",
        "fi": "Irlanti",
        "ar": "أيرلندا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Isle of Man",
        "ko": "맨 섬",
        "sc": "马恩岛",
        "es": "Isla del hombre",
        "ru": "Остров Мэн",
        "ja": "マン島",
        "fr": "île de Man",
        "de": "Isle of Man",
        "it": "Isola di Man",
        "th": "เกาะแมน",
        "id": "Pulau Man",
        "vi": "Đảo Man",
        "nl": "eiland Man",
        "pl": "Wyspa Man",
        "nb": "Isle of Man",
        "fi": "Mansaari",
        "ar": "جزيرة آيل أوف مان"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Jersey",
        "ko": "저지",
        "sc": "澤西",
        "es": "Jersey",
        "ru": "Джерси",
        "ja": "ジャージー",
        "fr": "Jersey",
        "de": "Jersey",
        "it": "Baliato di Jersey",
        "th": "เจอร์ซีย์",
        "id": "Jersey",
        "vi": "Jersey",
        "nl": "Jersey",
        "pl": "Jersey",
        "nb": "Jersey",
        "fi": "Jersey",
        "ar": "جيرسي"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Liberia",
        "ko": "라이베리아",
        "sc": "利比里亚",
        "es": "Liberia",
        "ru": "Либерия",
        "ja": "リベリア",
        "fr": "Libéria",
        "de": "Liberia",
        "it": "Liberia",
        "th": "ไลบีเรีย",
        "id": "Liberia",
        "vi": "Liberia",
        "nl": "Liberia",
        "pl": "Liberia",
        "nb": "Liberia",
        "fi": "Liberia",
        "ar": "ليبيريا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Mali",
        "ko": "말리",
        "sc": "马里",
        "es": "Malí",
        "ru": "Мали",
        "ja": "マリ",
        "fr": "Mali",
        "de": "Mali",
        "it": "Mali",
        "th": "มาลี",
        "id": "mali",
        "vi": "Mali",
        "nl": "Mali",
        "pl": "Mali",
        "nb": "Mali",
        "fi": "Mali",
        "ar": "مالي"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Mauritania",
        "ko": "모리타니",
        "sc": "毛里塔尼亚",
        "es": "Mauritania",
        "ru": "Мавритания",
        "ja": "モーリタニア",
        "fr": "Mauritanie",
        "de": "Mauretanien",
        "it": "Mauritania",
        "th": "มอริเตเนีย",
        "id": "Mauritania",
        "vi": "Mauritania",
        "nl": "Mauritanië",
        "pl": "Mauretania",
        "nb": "Mauritania",
        "fi": "Mauritania",
        "ar": "موريتانيا"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Portugal, main territory",
        "ko": "포르투갈, 주요 영토",
        "sc": "葡萄牙，主要领土",
        "es": "Portugal, territorio principal",
        "ru": "Португалия, основная территория",
        "ja": "ポルトガル、主要な領土",
        "fr": "Portugal, territoire principal",
        "de": "Portugal, Hauptgebiet",
        "it": "Portogallo, territorio principale",
        "th": "โปรตุเกส ดินแดนหลัก",
        "id": "Portugal, wilayah utama",
        "vi": "Bồ Đào Nha, lãnh thổ chính",
        "nl": "Portugal, hoofdgebied",
        "pl": "Portugalia, główne terytorium",
        "nb": "Portugal, hovedterritorium",
        "fi": "Portugali, pääalue",
        "ar": "البرتغال ، الإقليم الرئيسي"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Saint Helena",
        "ko": "세인트 헬레나",
        "sc": "圣赫勒拿",
        "es": "Santa Elena",
        "ru": "Святая Елена",
        "ja": "セントヘレナ",
        "fr": "Sainte-Hélène",
        "de": "Heilige Helena",
        "it": "Sant'Elena",
        "th": "เซนต์เฮเลนา",
        "id": "Saint Helena",
        "vi": "Saint Helena",
        "nl": "Sint Helena",
        "pl": "Święta Helena",
        "nb": "Saint Helena",
        "fi": "Pyhä Helena",
        "ar": "سانت هيلانة"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Sao Tome and Principe",
        "ko": "상투메프린시페",
        "sc": "圣多美和普林西比",
        "es": "Santo Tomé y Príncipe",
        "ru": "Сан-Томе и Принсипи",
        "ja": "サントメ・プリンシペ",
        "fr": "Sao Tomé et Principe",
        "de": "Sao Tome und Principe",
        "it": "Sao Tomé e Principe",
        "th": "เซาตูเมและปรินซิปี",
        "id": "Sao Tome dan Principe",
        "vi": "Sao Tome và Principe",
        "nl": "Sao Tomé en Principe",
        "pl": "Wyspy Świętego Tomasza i Książęca",
        "nb": "Sao Tome og Principe",
        "fi": "Sao Tome ja Principe",
        "ar": "ساو تومي وبرينسيبي"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Senegal",
        "ko": "세네갈",
        "sc": "塞内加尔",
        "es": "Senegal",
        "ru": "Сенегал",
        "ja": "セネガル",
        "fr": "Sénégal",
        "de": "Senegal",
        "it": "Senegal",
        "th": "เซเนกัล",
        "id": "Senegal",
        "vi": "Senegal",
        "nl": "Senegal",
        "pl": "Senegal",
        "nb": "Senegal",
        "fi": "Senegal",
        "ar": "السنغال"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Sierra Leone",
        "ko": "시에라리온",
        "sc": "塞拉利昂",
        "es": "Sierra Leona",
        "ru": "Сьерра-Леоне",
        "ja": "シエラレオネ",
        "fr": "Sierra Leone",
        "de": "Sierra Leone",
        "it": "Sierra Leone",
        "th": "เซียร์ราลีโอน",
        "id": "Sierra Leone",
        "vi": "Sierra Leone",
        "nl": "Sierra Leone",
        "pl": "Sierra Leone",
        "nb": "Sierra Leone",
        "fi": "Sierra Leone",
        "ar": "سيرا ليون"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Spain, Canary Islands",
        "ko": "스페인, 카나리아 제도",
        "sc": "西班牙、加那利群岛",
        "es": "España, Islas Canarias",
        "ru": "Испания, Канарские острова",
        "ja": "スペイン、カナリア諸島",
        "fr": "Espagne, Îles Canaries",
        "de": "Spanien, Kanarische Inseln",
        "it": "Spagna, Isole Canarie",
        "th": "สเปน, หมู่เกาะคะเนรี",
        "id": "Spanyol, Kepulauan Canary",
        "vi": "Tây Ban Nha, quần đảo Canary",
        "nl": "Spanje, Canarische Eilanden",
        "pl": "Hiszpania, Wyspy Kanaryjskie",
        "nb": "Spania, Kanariøyene",
        "fi": "Espanja, Kanariansaaret",
        "ar": "إسبانيا ، جزر الكناري"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Togo",
        "ko": "토고",
        "sc": "多哥",
        "es": "Togo",
        "ru": "Того",
        "ja": "トーゴ",
        "fr": "Togo",
        "de": "Togo",
        "it": "Togo",
        "th": "ประเทศโตโก",
        "id": "Togo",
        "vi": "Togo",
        "nl": "Togo",
        "pl": "Togo",
        "nb": "Togo",
        "fi": "Togo",
        "ar": "توجو"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "Tristan da Cunha",
        "ko": "트리스탄 다 쿠냐",
        "sc": "特里斯坦达库尼亚",
        "es": "Tristán da Cunha",
        "ru": "Тристан-да-Кунья",
        "ja": "トリスタンダクーニャ",
        "fr": "Tristan de Cunha",
        "de": "Tristan da Cunha",
        "it": "Tristano da Cunha",
        "th": "ทริสตัน ดา กุนยา",
        "id": "Tristan da Cunha",
        "vi": "Tristan da Cunha",
        "nl": "Tristan da Cunha",
        "pl": "Tristan da Cunha",
        "nb": "Tristan da Cunha",
        "fi": "Tristan da Cunha",
        "ar": "تريستان دا كونها"
    },
    {
        "value": 0,
        "prefix": "(GMT±00:00)",
        "en": "United Kingdom",
        "ko": "영국",
        "sc": "英国",
        "es": "Reino Unido",
        "ru": "Соединенное Королевство",
        "ja": "イギリス",
        "fr": "Royaume-Uni",
        "de": "Vereinigtes Königreich",
        "it": "Regno Unito",
        "th": "ประเทศอังกฤษ",
        "id": "Britania Raya",
        "vi": "Vương quốc Anh",
        "nl": "Verenigd Koninkrijk",
        "pl": "Zjednoczone Królestwo",
        "nb": "Storbritannia",
        "fi": "Yhdistynyt kuningaskunta",
        "ar": "المملكة المتحدة"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Albania",
        "ko": "알바니아",
        "sc": "阿尔巴尼亚",
        "es": "Albania",
        "ru": "Албания",
        "ja": "アルバニア",
        "fr": "Albanie",
        "de": "Albanien",
        "it": "Albania",
        "th": "แอลเบเนีย",
        "id": "Albania",
        "vi": "Albania",
        "nl": "Albanië",
        "pl": "Albania",
        "nb": "Albania",
        "fi": "Albania",
        "ar": "ألبانيا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Algeria",
        "ko": "알제리",
        "sc": "阿尔及利亚",
        "es": "Argelia",
        "ru": "Алжир",
        "ja": "アルジェリア",
        "fr": "Algérie",
        "de": "Algerien",
        "it": "Algeria",
        "th": "แอลจีเรีย",
        "id": "Aljazair",
        "vi": "Algeria",
        "nl": "Algerije",
        "pl": "Algieria",
        "nb": "Algerie",
        "fi": "Algeria",
        "ar": "الجزائر"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Andorra",
        "ko": "안도라",
        "sc": "安道尔",
        "es": "Andorra",
        "ru": "Андорра",
        "ja": "アンドラ",
        "fr": "Andorre",
        "de": "Andorra",
        "it": "Andorra",
        "th": "อันดอร์รา",
        "id": "andora",
        "vi": "Andorra",
        "nl": "Andorra",
        "pl": "Andora",
        "nb": "Andorra",
        "fi": "Andorra",
        "ar": "أندورا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Angola",
        "ko": "앙골라",
        "sc": "安哥拉",
        "es": "angola",
        "ru": "Ангола",
        "ja": "アンゴラ",
        "fr": "Angola",
        "de": "Angola",
        "it": "Angola",
        "th": "แองโกลา",
        "id": "Angola",
        "vi": "Angola",
        "nl": "Angola",
        "pl": "Angola",
        "nb": "Angola",
        "fi": "Angola",
        "ar": "أنغولا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Austria",
        "ko": "오스트리아",
        "sc": "奥地利",
        "es": "Austria",
        "ru": "Австрия",
        "ja": "オーストリア",
        "fr": "L'Autriche",
        "de": "Österreich",
        "it": "Austria",
        "th": "ออสเตรีย",
        "id": "Austria",
        "vi": "Áo",
        "nl": "Oostenrijk",
        "pl": "Austria",
        "nb": "Østerrike",
        "fi": "Itävalta",
        "ar": "النمسا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Belgium",
        "ko": "벨기에",
        "sc": "比利时",
        "es": "Bélgica",
        "ru": "Бельгия",
        "ja": "ベルギー",
        "fr": "Belgique",
        "de": "Belgien",
        "it": "Belgio",
        "th": "เบลเยียม",
        "id": "Belgium",
        "vi": "nước Bỉ",
        "nl": "België",
        "pl": "Belgia",
        "nb": "Belgia",
        "fi": "Belgia",
        "ar": "بلجيكا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Benin",
        "ko": "베냉",
        "sc": "贝宁",
        "es": "Benín",
        "ru": "Бенин",
        "ja": "ベナン",
        "fr": "Bénin",
        "de": "Benin",
        "it": "Benin",
        "th": "เบนิน",
        "id": "Benin",
        "vi": "Benin",
        "nl": "Benin",
        "pl": "Benin",
        "nb": "Benin",
        "fi": "Benin",
        "ar": "بنين"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Bosnia and Herzegovina",
        "ko": "보스니아 헤르체고비나",
        "sc": "波斯尼亚和黑塞哥维那",
        "es": "Bosnia y Herzegovina",
        "ru": "Босния и Герцеговина",
        "ja": "ボスニア・ヘルツェゴビナ",
        "fr": "Bosnie Herzégovine",
        "de": "Bosnien und Herzegowina",
        "it": "Bosnia Erzegovina",
        "th": "บอสเนียและเฮอร์เซโก",
        "id": "Bosnia dan Herzegovina",
        "vi": "Bosnia và Herzegovina",
        "nl": "Bosnië-Herzegovina",
        "pl": "Bośnia i Hercegowina",
        "nb": "Bosnia og Herzegovina",
        "fi": "Bosnia ja Hertsegovina",
        "ar": "البوسنة والهرسك"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Cameroon",
        "ko": "카메룬",
        "sc": "喀麦隆",
        "es": "Camerún",
        "ru": "Камерун",
        "ja": "カメルーン",
        "fr": "Cameroun",
        "de": "Kamerun",
        "it": "Camerun",
        "th": "แคเมอรูน",
        "id": "Kamerun",
        "vi": "Cameroon",
        "nl": "Kameroen",
        "pl": "Kamerun",
        "nb": "Kamerun",
        "fi": "Kamerun",
        "ar": "الكاميرون"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Central African Republic",
        "ko": "중앙 아프리카 공화국",
        "sc": "中非共和国",
        "es": "República Centroafricana",
        "ru": "Центрально-Африканская Республика",
        "ja": "中央アフリカ共和国",
        "fr": "République centrafricaine",
        "de": "Zentralafrikanische Republik",
        "it": "Repubblica Centrafricana",
        "th": "สาธารณรัฐแอฟริกากลาง",
        "id": "Republik Afrika Tengah",
        "vi": "Cộng hòa trung phi",
        "nl": "Centraal Afrikaanse Republiek",
        "pl": "Republika Środkowoafrykańska",
        "nb": "Den sentralafrikanske republikk",
        "fi": "Keski-Afrikan tasavalta",
        "ar": "جمهورية افريقيا الوسطى"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Chad",
        "ko": "차드",
        "sc": "乍得",
        "es": "Chad",
        "ru": "Чад",
        "ja": "チャド",
        "fr": "Tchad",
        "de": "Tschad",
        "it": "Chad",
        "th": "ประเทศชาด",
        "id": "Chad",
        "vi": "Chad",
        "nl": "Tsjaad",
        "pl": "Czad",
        "nb": "Tsjad",
        "fi": "Tšad",
        "ar": "تشاد"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Congo, Republic of the",
        "ko": "콩고 공화국",
        "sc": "刚果共和国",
        "es": "Congo, República del",
        "ru": "Конго, Республика",
        "ja": "コンゴ共和国",
        "fr": "Congo, République du",
        "de": "Kongo, Republik der",
        "it": "Congo, Repubblica del",
        "th": "คองโก สาธารณรัฐ",
        "id": "Kongo, Republik",
        "vi": "Congo, Cộng hòa",
        "nl": "Congo, Republiek der",
        "pl": "Kongo, Republika",
        "nb": "Kongo, republikken",
        "fi": "Kongon tasavalta",
        "ar": "جمهورية الكونغو"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Congo, Democratic Republic of, western part",
        "ko": "콩고민주공화국 서부",
        "sc": "刚果民主共和国，西部",
        "es": "República Democrática del, parte occidental",
        "ru": "Конго, Демократическая Республика, западная часть",
        "ja": "コンゴ民主共和国、西部",
        "fr": "Congo, République démocratique du, partie occidentale",
        "de": "Kongo, Demokratische Republik, westlicher Teil",
        "it": "Congo, Repubblica Democratica del, parte occidentale",
        "th": "คองโก สาธารณรัฐประชาธิปไตย ภาคตะวันตก",
        "id": "Kongo, Republik Demokratik, bagian barat",
        "vi": "Congo, Cộng hòa dân chủ, phần phía tây",
        "nl": "Congo, Democratische Republiek, westelijk deel",
        "pl": "Kongo, Demokratyczna Republika, część zachodnia",
        "nb": "Kongo, Den demokratiske republikken, vestlige del",
        "fi": "Kongon demokraattinen tasavalta, länsiosa",
        "ar": "جمهورية الكونغو الديمقراطية ، الجزء الغربي"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Croatia",
        "ko": "크로아티아",
        "sc": "克罗地亚",
        "es": "Croacia",
        "ru": "Хорватия",
        "ja": "クロアチア",
        "fr": "Croatie",
        "de": "Kroatien",
        "it": "Croazia",
        "th": "โครเอเชีย",
        "id": "Kroasia",
        "vi": "Croatia",
        "nl": "Kroatië",
        "pl": "Chorwacja",
        "nb": "Kroatia",
        "fi": "Kroatia",
        "ar": "كرواتيا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Czechia",
        "ko": "체코",
        "sc": "捷克",
        "es": "Chequia",
        "ru": "Чехия",
        "ja": "チェコ",
        "fr": "Tchéquie",
        "de": "Tschechien",
        "it": "Cechia",
        "th": "เช็กเกีย",
        "id": "Ceko",
        "vi": "Czechia",
        "nl": "Tsjechië",
        "pl": "Czechy",
        "nb": "Tsjekkia",
        "fi": "Tšekki",
        "ar": "التشيك"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Denmark",
        "ko": "덴마크",
        "sc": "丹麦",
        "es": "Dinamarca",
        "ru": "Дания",
        "ja": "デンマーク",
        "fr": "Danemark",
        "de": "Dänemark",
        "it": "Danimarca",
        "th": "เดนมาร์ก",
        "id": "Denmark",
        "vi": "Đan mạch",
        "nl": "Denemarken",
        "pl": "Dania",
        "nb": "Danmark",
        "fi": "Tanska",
        "ar": "الدنمارك"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Equatorial Guinea",
        "ko": "적도 기니",
        "sc": "赤道几内亚",
        "es": "Guinea Ecuatorial",
        "ru": "Экваториальная Гвинея",
        "ja": "赤道ギニア",
        "fr": "Guinée Équatoriale",
        "de": "Äquatorialguinea",
        "it": "Guinea Equatoriale",
        "th": "อิเควทอเรียลกินี",
        "id": "Guinea ekuator",
        "vi": "Equatorial Guinea",
        "nl": "Equatoriaal-Guinea",
        "pl": "Gwinea Równikowa",
        "nb": "Ekvatorial-Guinea",
        "fi": "Päiväntasaajan Guinea",
        "ar": "غينيا الإستوائية"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "France",
        "ko": "프랑스",
        "sc": "法国",
        "es": "Francia",
        "ru": "Франция",
        "ja": "フランス",
        "fr": "France",
        "de": "Frankreich",
        "it": "Francia",
        "th": "ฝรั่งเศส",
        "id": "Perancis",
        "vi": "Nước pháp",
        "nl": "Frankrijk",
        "pl": "Francja",
        "nb": "Frankrike",
        "fi": "Ranska",
        "ar": "فرنسا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Gabon",
        "ko": "가봉",
        "sc": "加蓬",
        "es": "Gabón",
        "ru": "Габон",
        "ja": "ガボン",
        "fr": "Gabon",
        "de": "Gabun",
        "it": "Gabon",
        "th": "กาบอง",
        "id": "Gabon",
        "vi": "Gabon",
        "nl": "Gabon",
        "pl": "Gabon",
        "nb": "Gabon",
        "fi": "Gabon",
        "ar": "الجابون"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Germany",
        "ko": "독일",
        "sc": "德国",
        "es": "Alemania",
        "ru": "Германия",
        "ja": "ドイツ",
        "fr": "Allemagne",
        "de": "Deutschland",
        "it": "Germania",
        "th": "เยอรมนี",
        "id": "Jerman",
        "vi": "nước Đức",
        "nl": "Duitsland",
        "pl": "Niemcy",
        "nb": "Tyskland",
        "fi": "Saksa",
        "ar": "ألمانيا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Gibraltar",
        "ko": "지브롤터",
        "sc": "直布罗陀",
        "es": "Gibraltar",
        "ru": "Гибралтар",
        "ja": "ジブラルタル",
        "fr": "Gibraltar",
        "de": "Gibraltar",
        "it": "Gibilterra",
        "th": "ยิบรอลตาร์",
        "id": "Gibraltar",
        "vi": "Gibraltar",
        "nl": "Gibraltar",
        "pl": "Gibraltar",
        "nb": "Gibraltar",
        "fi": "Gibraltar",
        "ar": "جبل طارق"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Hungary",
        "ko": "헝가리",
        "sc": "匈牙利",
        "es": "Hungría",
        "ru": "Венгрия",
        "ja": "ハンガリー",
        "fr": "Hongrie",
        "de": "Ungarn",
        "it": "Ungheria",
        "th": "ฮังการี",
        "id": "Hungaria",
        "vi": "Hungary",
        "nl": "Hongarije",
        "pl": "Węgry",
        "nb": "Ungarn",
        "fi": "Unkari",
        "ar": "هنغاريا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Italy",
        "ko": "이탈리아",
        "sc": "意大利",
        "es": "Italia",
        "ru": "Италия",
        "ja": "イタリア",
        "fr": "Italie",
        "de": "Italien",
        "it": "Italia",
        "th": "อิตาลี",
        "id": "Italia",
        "vi": "Nước Ý",
        "nl": "Italië",
        "pl": "Włochy",
        "nb": "Italia",
        "fi": "Italia",
        "ar": "إيطاليا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Kosovo",
        "ko": "코소보",
        "sc": "科索沃",
        "es": "Kosovo",
        "ru": "Косово",
        "ja": "コソボ",
        "fr": "Kosovo",
        "de": "Kosovo",
        "it": "Kosovo",
        "th": "โคโซโว",
        "id": "Kosovo",
        "vi": "Kosovo",
        "nl": "Kosovo",
        "pl": "Kosowo",
        "nb": "Kosovo",
        "fi": "Kosovo",
        "ar": "كوسوفو"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Liechtenstein",
        "ko": "리히텐슈타인",
        "sc": "列支敦士登",
        "es": "Liechtenstein",
        "ru": "Лихтенштейн",
        "ja": "リヒテンシュタイン",
        "fr": "Liechtenstein",
        "de": "Liechtenstein",
        "it": "Liechtenstein",
        "th": "ลิกเตนสไตน์",
        "id": "Liechtenstein",
        "vi": "Liechtenstein",
        "nl": "Liechtenstein",
        "pl": "Liechtenstein",
        "nb": "Liechtenstein",
        "fi": "Liechtenstein",
        "ar": "ليختنشتاين"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Luxembourg",
        "ko": "룩셈부르크",
        "sc": "卢森堡",
        "es": "luxemburgo",
        "ru": "Люксембург",
        "ja": "ルクセンブルク",
        "fr": "Luxembourg",
        "de": "Luxemburg",
        "it": "Lussemburgo",
        "th": "ลักเซมเบิร์ก",
        "id": "Luksemburg",
        "vi": "Luxembourg",
        "nl": "Luxemburg",
        "pl": "Luksemburg",
        "nb": "Luxembourg",
        "fi": "Luxemburg",
        "ar": "لوكسمبورغ"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Malta",
        "ko": "몰타",
        "sc": "马耳他",
        "es": "Malta",
        "ru": "Мальта",
        "ja": "マルタ",
        "fr": "Malte",
        "de": "Malta",
        "it": "Malta",
        "th": "มอลตา",
        "id": "Malta",
        "vi": "Malta",
        "nl": "Malta",
        "pl": "Malta",
        "nb": "Malta",
        "fi": "Malta",
        "ar": "مالطا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Monaco",
        "ko": "모나코",
        "sc": "摩纳哥",
        "es": "Mónaco",
        "ru": "Монако",
        "ja": "モナコ",
        "fr": "Monaco",
        "de": "Monaco",
        "it": "Monaco",
        "th": "โมนาโก",
        "id": "Monako",
        "vi": "Monaco",
        "nl": "Monaco",
        "pl": "Monako",
        "nb": "Monaco",
        "fi": "Monaco",
        "ar": "موناكو"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Montenegro",
        "ko": "몬테네그로",
        "sc": "黑山",
        "es": "montenegro",
        "ru": "Черногория",
        "ja": "モンテネグロ",
        "fr": "Monténégro",
        "de": "Montenegro",
        "it": "Montenegro",
        "th": "มอนเตเนโกร",
        "id": "Montenegro",
        "vi": "Montenegro",
        "nl": "Montenegro",
        "pl": "Czarnogóra",
        "nb": "Montenegro",
        "fi": "Montenegro",
        "ar": "الجبل الأسود"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Morocco",
        "ko": "모로코",
        "sc": "摩洛哥",
        "es": "Marruecos",
        "ru": "Марокко",
        "ja": "モロッコ",
        "fr": "Maroc",
        "de": "Marokko",
        "it": "Marocco",
        "th": "โมร็อกโก",
        "id": "Maroko",
        "vi": "Maroc",
        "nl": "Marokko",
        "pl": "Maroko",
        "nb": "Marokko",
        "fi": "Marokko",
        "ar": "المغرب"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Netherlands",
        "ko": "네덜란드",
        "sc": "荷兰",
        "es": "Países Bajos",
        "ru": "Нидерланды",
        "ja": "オランダ",
        "fr": "Pays-Bas",
        "de": "Niederlande",
        "it": "Olanda",
        "th": "เนเธอร์แลนด์",
        "id": "Belanda",
        "vi": "nước Hà Lan",
        "nl": "Nederland",
        "pl": "Holandia",
        "nb": "Nederland",
        "fi": "Alankomaat",
        "ar": "هولندا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Niger",
        "ko": "니제르",
        "sc": "尼日尔",
        "es": "Níger",
        "ru": "Нигер",
        "ja": "ニジェール",
        "fr": "Niger",
        "de": "Niger",
        "it": "Niger",
        "th": "ไนเจอร์",
        "id": "Nigeria",
        "vi": "Niger",
        "nl": "Niger",
        "pl": "Niger",
        "nb": "Niger",
        "fi": "Niger",
        "ar": "النيجر"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Nigeria",
        "ko": "나이지리아",
        "sc": "尼日利亚",
        "es": "Nigeria",
        "ru": "Нигерия",
        "ja": "ナイジェリア",
        "fr": "Nigeria",
        "de": "Nigeria",
        "it": "Nigeria",
        "th": "ไนจีเรีย",
        "id": "Nigeria",
        "vi": "Nigeria",
        "nl": "Nigeria",
        "pl": "Nigeria",
        "nb": "Nigeria",
        "fi": "Nigeria",
        "ar": "نيجيريا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "North Macedonia",
        "ko": "북 마케도니아",
        "sc": "北马其顿",
        "es": "macedonia del norte",
        "ru": "Северная Македония",
        "ja": "北マケドニア",
        "fr": "Macédoine du Nord",
        "de": "Nordmazedonien",
        "it": "Macedonia del Nord",
        "th": "มาซิโดเนียเหนือ",
        "id": "Makedonia Utara",
        "vi": "Bắc Macedonia",
        "nl": "Noord-Macedonië",
        "pl": "Macedonia Północna",
        "nb": "Nord-Makedonia",
        "fi": "Pohjois-Makedonia",
        "ar": "مقدونيا الشمالية"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Norway",
        "ko": "노르웨이",
        "sc": "挪威",
        "es": "Noruega",
        "ru": "Норвегия",
        "ja": "ノルウェー",
        "fr": "Norvège",
        "de": "Norwegen",
        "it": "Norvegia",
        "th": "นอร์เวย์",
        "id": "Norway",
        "vi": "Na Uy",
        "nl": "Noorwegen",
        "pl": "Norwegia",
        "nb": "Norge",
        "fi": "Norja",
        "ar": "النرويج"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Poland",
        "ko": "폴란드",
        "sc": "波兰",
        "es": "Polonia",
        "ru": "Польша",
        "ja": "ポーランド",
        "fr": "Pologne",
        "de": "Polen",
        "it": "Polonia",
        "th": "โปแลนด์",
        "id": "Polandia",
        "vi": "Ba lan",
        "nl": "Polen",
        "pl": "Polska",
        "nb": "Polen",
        "fi": "Puola",
        "ar": "بولندا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "San Marino",
        "ko": "산 마리노",
        "sc": "圣马力诺",
        "es": "San Marino",
        "ru": "Сан-Марино",
        "ja": "サンマリノ",
        "fr": "Saint Marin",
        "de": "San Marino",
        "it": "San Marino",
        "th": "ซานมารีโน",
        "id": "San Marino",
        "vi": "San Marino",
        "nl": "San Marino",
        "pl": "San Marino",
        "nb": "San Marino",
        "fi": "San Marino",
        "ar": "سان مارينو"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Serbia",
        "ko": "세르비아",
        "sc": "塞尔维亚",
        "es": "Serbia",
        "ru": "Сербия",
        "ja": "セルビア",
        "fr": "Serbie",
        "de": "Serbien",
        "it": "Serbia",
        "th": "เซอร์เบีย",
        "id": "Serbia",
        "vi": "Xéc-bi-a",
        "nl": "Servië",
        "pl": "Serbia",
        "nb": "Serbia",
        "fi": "Serbia",
        "ar": "صربيا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Slovakia",
        "ko": "슬로바키아",
        "sc": "斯洛伐克",
        "es": "Eslovaquia",
        "ru": "Словакия",
        "ja": "スロバキア",
        "fr": "Slovaquie",
        "de": "Slowakei",
        "it": "Slovacchia",
        "th": "สโลวาเกีย",
        "id": "Slowakia",
        "vi": "Xlô-va-ki-a",
        "nl": "Slowakije",
        "pl": "Słowacja",
        "nb": "Slovakia",
        "fi": "Slovakia",
        "ar": "سلوفاكيا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Slovenia",
        "ko": "슬로베니아",
        "sc": "斯洛文尼亚",
        "es": "Eslovenia",
        "ru": "Словения",
        "ja": "スロベニア",
        "fr": "Slovénie",
        "de": "Slowenien",
        "it": "Slovenia",
        "th": "สโลวีเนีย",
        "id": "Slovenia",
        "vi": "Slovenia",
        "nl": "Slovenië",
        "pl": "Słowenia",
        "nb": "Slovenia",
        "fi": "Slovenia",
        "ar": "سلوفينيا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Spain, main territory",
        "ko": "스페인, 주요 영토",
        "sc": "西班牙，主要领土",
        "es": "España, territorio principal",
        "ru": "Испания, основная территория",
        "ja": "スペイン、主要な領土",
        "fr": "Espagne, territoire principal",
        "de": "Spanien, Hauptgebiet",
        "it": "Spagna, territorio principale",
        "th": "สเปน ดินแดนหลัก",
        "id": "Spanyol, wilayah utama",
        "vi": "Tây Ban Nha, lãnh thổ chính",
        "nl": "Spanje, hoofdgebied",
        "pl": "Hiszpania, główne terytorium",
        "nb": "Spania, hovedterritorium",
        "fi": "Espanja, pääalue",
        "ar": "إسبانيا ، الإقليم الرئيسي"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Svalbard and Jan Mayen",
        "ko": "스발바르와 얀 마옌",
        "sc": "斯瓦尔巴和扬马延",
        "es": "Svalbard y Jan Mayen",
        "ru": "Шпицберген и Ян-Майен",
        "ja": "スバールバル諸島およびヤンマイエン",
        "fr": "Svalbard et Jan Mayen",
        "de": "Spitzbergen und Jan Mayen",
        "it": "Svalbard e Jan Mayen",
        "th": "สฟาลบาร์และยานไมเอน",
        "id": "Svalbard dan Jan Mayen",
        "vi": "Svalbard và Jan Mayen",
        "nl": "Svalbard en Jan Mayen",
        "pl": "Svalbard i Jan Mayen",
        "nb": "Svalbard og Jan Mayen",
        "fi": "Svalbard ja Jan Mayen",
        "ar": "سفالبارد وجان ماين"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Sweden",
        "ko": "스웨덴",
        "sc": "瑞典",
        "es": "Suecia",
        "ru": "Швеция",
        "ja": "スウェーデン",
        "fr": "Suède",
        "de": "Schweden",
        "it": "Svezia",
        "th": "สวีเดน",
        "id": "Swedia",
        "vi": "Thụy Điển",
        "nl": "Zweden",
        "pl": "Szwecja",
        "nb": "Sverige",
        "fi": "Ruotsi",
        "ar": "السويد"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Switzerland",
        "ko": "스위스",
        "sc": "瑞士",
        "es": "Suiza",
        "ru": "Швейцария",
        "ja": "スイス",
        "fr": "Suisse",
        "de": "Schweiz",
        "it": "Svizzera",
        "th": "สวิตเซอร์แลนด์",
        "id": "Swiss",
        "vi": "Thụy sĩ",
        "nl": "Zwitserland",
        "pl": "Szwajcaria",
        "nb": "Sveits",
        "fi": "Sveitsi",
        "ar": "سويسرا"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Tunisia",
        "ko": "튀니지",
        "sc": "突尼斯",
        "es": "Túnez",
        "ru": "Тунис",
        "ja": "チュニジア",
        "fr": "Tunisie",
        "de": "Tunesien",
        "it": "Tunisia",
        "th": "ตูนิเซีย",
        "id": "Tunisia",
        "vi": "Tunisia",
        "nl": "Tunesië",
        "pl": "Tunezja",
        "nb": "Tunisia",
        "fi": "Tunisia",
        "ar": "تونس"
    },
    {
        "value": 100,
        "prefix": "(GMT+01:00)",
        "en": "Vatican City (Holy See)",
        "ko": "바티칸 시국(교황청)",
        "sc": "梵蒂冈城（教廷）",
        "es": "Ciudad del Vaticano (Santa Sede)",
        "ru": "Ватикан (Святой Престол)",
        "ja": "バチカン市国（聖座）",
        "fr": "Cité du Vatican (Saint-Siège)",
        "de": "Vatikanstadt (Heiliger Stuhl)",
        "it": "Città del Vaticano (Santa Sede)",
        "th": "นครวาติกัน (สันตะสำนัก)",
        "id": "Kota Vatikan (Tahta Suci)",
        "vi": "Thành phố Vatican (Tòa thánh)",
        "nl": "Vaticaanstad (Heilige Stoel)",
        "pl": "Watykan (Stolica Apostolska)",
        "nb": "Vatikanstaten (Holy See)",
        "fi": "Vatikaani (Pyhä istuin)",
        "ar": "مدينة الفاتيكان (الكرسي الرسولي)"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Aland Islands",
        "ko": "올란드 제도",
        "sc": "奥兰群岛",
        "es": "Islas Aland",
        "ru": "Аландские острова",
        "ja": "オーランド諸島",
        "fr": "Iles Aland",
        "de": "Aland-Inseln",
        "it": "Isole Aland",
        "th": "หมู่เกาะโอลันด์",
        "id": "Pulau Aland",
        "vi": "Quần đảo Aland",
        "nl": "Aland-eilanden",
        "pl": "Wyspy Alandzkie",
        "nb": "Ålandsøyene",
        "fi": "Ahvenanmaan saaret",
        "ar": "جزر آلاند"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Botswana",
        "ko": "보츠와나",
        "sc": "博茨瓦纳",
        "es": "Botsuana",
        "ru": "Ботсвана",
        "ja": "ボツワナ",
        "fr": "Bostwana",
        "de": "Botswana",
        "it": "Botswana",
        "th": "บอตสวานา",
        "id": "Botswana",
        "vi": "Botswana",
        "nl": "Botswana",
        "pl": "Botswana",
        "nb": "Botswana",
        "fi": "Botswana",
        "ar": "بوتسوانا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Bulgaria",
        "ko": "불가리아",
        "sc": "保加利亚",
        "es": "Bulgaria",
        "ru": "Болгария",
        "ja": "ブルガリア",
        "fr": "Bulgarie",
        "de": "Bulgarien",
        "it": "Bulgaria",
        "th": "บัลแกเรีย",
        "id": "Bulgaria",
        "vi": "Bungari",
        "nl": "Bulgarije",
        "pl": "Bułgaria",
        "nb": "Bulgaria",
        "fi": "Bulgaria",
        "ar": "بلغاريا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Burundi",
        "ko": "부룬디",
        "sc": "布隆迪",
        "es": "Burundi",
        "ru": "Бурунди",
        "ja": "ブルンジ",
        "fr": "Burundi",
        "de": "Burundi",
        "it": "Burundi",
        "th": "บุรุนดี",
        "id": "Burundi",
        "vi": "Burundi",
        "nl": "Burundi",
        "pl": "Burundi",
        "nb": "Burundi",
        "fi": "Burundi",
        "ar": "بوروندي"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Congo, Democratic Republic of, eastern part",
        "ko": "콩고, 민주공화국 동부",
        "sc": "刚果民主共和国，东部",
        "es": "Congo, República Democrática del, parte oriental",
        "ru": "Конго, Демократическая Республика, восточная часть",
        "ja": "コンゴ民主共和国、東部",
        "fr": "Congo, République démocratique du, partie orientale",
        "de": "Kongo, Demokratische Republik, östlicher Teil",
        "it": "Congo, Repubblica Democratica del, parte orientale",
        "th": "คองโก สาธารณรัฐประชาธิปไตย ภาคตะวันออก",
        "id": "Kongo, Republik Demokratik, bagian timur",
        "vi": "Congo, Cộng hòa dân chủ, miền đông",
        "nl": "Congo, Democratische Republiek, oostelijk deel",
        "pl": "Kongo, Demokratyczna Republika, część wschodnia",
        "nb": "Kongo, Den demokratiske republikken, østlige del",
        "fi": "Kongon demokraattinen tasavalta, itäosa",
        "ar": "جمهورية الكونغو الديمقراطية ، الجزء الشرقي"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Cyprus",
        "ko": "키프로스",
        "sc": "塞浦路斯",
        "es": "Chipre",
        "ru": "Кипр",
        "ja": "キプロス",
        "fr": "Chypre",
        "de": "Zypern",
        "it": "Cipro",
        "th": "ไซปรัส",
        "id": "Siprus",
        "vi": "Síp",
        "nl": "Cyprus",
        "pl": "Cypr",
        "nb": "Kypros",
        "fi": "Kypros",
        "ar": "قبرص"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Egypt",
        "ko": "이집트",
        "sc": "埃及",
        "es": "Egipto",
        "ru": "Египет",
        "ja": "エジプト",
        "fr": "Egypte",
        "de": "Ägypten",
        "it": "Egitto",
        "th": "อียิปต์",
        "id": "Mesir",
        "vi": "Ai cập",
        "nl": "Egypte",
        "pl": "Egipt",
        "nb": "Egypt",
        "fi": "Egypti",
        "ar": "مصر"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Estonia",
        "ko": "에스토니아",
        "sc": "爱沙尼亚",
        "es": "Estonia",
        "ru": "Эстония",
        "ja": "エストニア",
        "fr": "Estonie",
        "de": "Estland",
        "it": "Estonia",
        "th": "เอสโตเนีย",
        "id": "Estonia",
        "vi": "Estonia",
        "nl": "Estland",
        "pl": "Estonia",
        "nb": "Estland",
        "fi": "Viro",
        "ar": "إستونيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Eswatini",
        "ko": "에스와티니",
        "sc": "斯威士兰",
        "es": "Esuatini",
        "ru": "Эсватини",
        "ja": "エスワティニ",
        "fr": "Eswatini",
        "de": "Eswatini",
        "it": "Eswatini",
        "th": "เอสวาตินี",
        "id": "Eswatini",
        "vi": "Eswatini",
        "nl": "Swatini",
        "pl": "Eswatini",
        "nb": "Eswatini",
        "fi": "Eswatini",
        "ar": "إيسواتيني"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Finland",
        "ko": "핀란드",
        "sc": "芬兰",
        "es": "Finlandia",
        "ru": "Финляндия",
        "ja": "フィンランド",
        "fr": "Finlande",
        "de": "Finnland",
        "it": "Finlandia",
        "th": "ฟินแลนด์",
        "id": "Finlandia",
        "vi": "Phần Lan",
        "nl": "Finland",
        "pl": "Finlandia",
        "nb": "Finland",
        "fi": "Suomi",
        "ar": "فنلندا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Greece",
        "ko": "그리스",
        "sc": "希腊",
        "es": "Grecia",
        "ru": "Греция",
        "ja": "ギリシャ",
        "fr": "Grèce",
        "de": "Griechenland",
        "it": "Grecia",
        "th": "กรีซ",
        "id": "Yunani",
        "vi": "Hy Lạp",
        "nl": "Griekenland",
        "pl": "Grecja",
        "nb": "Hellas",
        "fi": "Kreikka",
        "ar": "اليونان"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Israel",
        "ko": "이스라엘",
        "sc": "以色列",
        "es": "Israel",
        "ru": "Израиль",
        "ja": "イスラエル",
        "fr": "Israël",
        "de": "Israel",
        "it": "Israele",
        "th": "อิสราเอล",
        "id": "Israel",
        "vi": "Người israel",
        "nl": "Israël",
        "pl": "Izrael",
        "nb": "Israel",
        "fi": "Israel",
        "ar": "إسرائيل"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Jordan",
        "ko": "요르단",
        "sc": "约旦",
        "es": "Jordán",
        "ru": "Иордания",
        "ja": "ヨルダン",
        "fr": "Jordan",
        "de": "Jordanien",
        "it": "Giordania",
        "th": "จอร์แดน",
        "id": "Yordania",
        "vi": "Jordan",
        "nl": "Jordanië",
        "pl": "Jordania",
        "nb": "Jordan",
        "fi": "Jordania",
        "ar": "الأردن"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Kaliningrad, Russia",
        "ko": "러시아 칼리닌그라드",
        "sc": "俄罗斯加里宁格勒",
        "es": "Kaliningrado, Rusia",
        "ru": "Калининград, Россия",
        "ja": "カリーニングラード、ロシア",
        "fr": "Kaliningrad, Russie",
        "de": "Kaliningrad, Russland",
        "it": "Kaliningrad, Russia",
        "th": "คาลินินกราด รัสเซีย",
        "id": "Kaliningrad, Rusia",
        "vi": "Kaliningrad, Nga",
        "nl": "Kaliningrad, Rusland",
        "pl": "Kaliningrad, Rosja",
        "nb": "Kaliningrad, Russland",
        "fi": "Kaliningrad, Venäjä",
        "ar": "كالينينغراد ، روسيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Latvia",
        "ko": "라트비아",
        "sc": "拉脱维亚",
        "es": "letonia",
        "ru": "Латвия",
        "ja": "ラトビア",
        "fr": "Lettonie",
        "de": "Lettland",
        "it": "Lettonia",
        "th": "ลัตเวีย",
        "id": "Latvia",
        "vi": "Latvia",
        "nl": "Letland",
        "pl": "Łotwa",
        "nb": "Latvia",
        "fi": "Latvia",
        "ar": "لاتفيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Lebanon",
        "ko": "레바논",
        "sc": "黎巴嫩",
        "es": "Líbano",
        "ru": "Ливан",
        "ja": "レバノン",
        "fr": "Liban",
        "de": "Libanon",
        "it": "Libano",
        "th": "เลบานอน",
        "id": "Libanon",
        "vi": "Lebanon",
        "nl": "Libanon",
        "pl": "Liban",
        "nb": "Libanon",
        "fi": "Libanon",
        "ar": "لبنان"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Lesotho",
        "ko": "레소토",
        "sc": "莱索托",
        "es": "Lesoto",
        "ru": "Лесото",
        "ja": "レソト",
        "fr": "Lesotho",
        "de": "Lesotho",
        "it": "Lesoto",
        "th": "เลโซโท",
        "id": "Lesotho",
        "vi": "Lesotho",
        "nl": "Lesotho",
        "pl": "Lesoto",
        "nb": "Lesotho",
        "fi": "Lesotho",
        "ar": "ليسوتو"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Libya",
        "ko": "리비아",
        "sc": "利比亚",
        "es": "Libia",
        "ru": "Ливия",
        "ja": "リビア",
        "fr": "Libye",
        "de": "Libyen",
        "it": "Libia",
        "th": "ลิเบีย",
        "id": "Libya",
        "vi": "Libya",
        "nl": "Libië",
        "pl": "Libia",
        "nb": "Libya",
        "fi": "Libya",
        "ar": "ليبيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Lithuania",
        "ko": "리투아니아",
        "sc": "立陶宛",
        "es": "Lituania",
        "ru": "Литва",
        "ja": "リトアニア",
        "fr": "Lituanie",
        "de": "Litauen",
        "it": "Lituania",
        "th": "ลิทัวเนีย",
        "id": "Lithuania",
        "vi": "Lithuania",
        "nl": "Litouwen",
        "pl": "Litwa",
        "nb": "Litauen",
        "fi": "Liettua",
        "ar": "ليتوانيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Malawi",
        "ko": "말라위",
        "sc": "马拉维",
        "es": "Malaui",
        "ru": "Малави",
        "ja": "マラウイ",
        "fr": "Malawi",
        "de": "Malawi",
        "it": "Malawi",
        "th": "มาลาวี",
        "id": "Malawi",
        "vi": "Malawi",
        "nl": "Malawi",
        "pl": "Malawi",
        "nb": "Malawi",
        "fi": "Malawi",
        "ar": "ملاوي"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Moldova",
        "ko": "몰도바",
        "sc": "摩尔多瓦",
        "es": "Moldavia",
        "ru": "Молдова",
        "ja": "モルドバ",
        "fr": "Moldavie",
        "de": "Moldawien",
        "it": "Moldavia",
        "th": "มอลโดวา",
        "id": "Moldova",
        "vi": "Moldova",
        "nl": "Moldavië",
        "pl": "Moldova",
        "nb": "Moldova",
        "fi": "Moldova",
        "ar": "مولدوفا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Mozambique",
        "ko": "모잠비크",
        "sc": "莫桑比克",
        "es": "Mozambique",
        "ru": "Мозамбик",
        "ja": "モザンビーク",
        "fr": "Mozambique",
        "de": "Mosambik",
        "it": "Mozambico",
        "th": "โมซัมบิก",
        "id": "Mozambik",
        "vi": "Mozambique",
        "nl": "Mozambique",
        "pl": "Mozambik",
        "nb": "Mosambik",
        "fi": "Mosambik",
        "ar": "موزمبيق"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Namibia",
        "ko": "나미비아",
        "sc": "纳米比亚",
        "es": "Namibia",
        "ru": "Намибия",
        "ja": "ナミビア",
        "fr": "Namibie",
        "de": "Namibia",
        "it": "Namibia",
        "th": "นามิเบีย",
        "id": "Namibia",
        "vi": "Namibia",
        "nl": "Namibië",
        "pl": "Namibia",
        "nb": "Namibia",
        "fi": "Namibia",
        "ar": "ناميبيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Palestine",
        "ko": "팔레스타인",
        "sc": "巴勒斯坦",
        "es": "Palestina",
        "ru": "Палестина",
        "ja": "パレスチナ",
        "fr": "Palestine",
        "de": "Palästina",
        "it": "Palestina",
        "th": "ปาเลสไตน์",
        "id": "Palestina",
        "vi": "Palestine",
        "nl": "Palestina",
        "pl": "Palestyna",
        "nb": "Palestina",
        "fi": "Palestiina",
        "ar": "فلسطين"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Romania",
        "ko": "루마니아",
        "sc": "罗马尼亚",
        "es": "Rumania",
        "ru": "Румыния",
        "ja": "ルーマニア",
        "fr": "Roumanie",
        "de": "Rumänien",
        "it": "Romania",
        "th": "โรมาเนีย",
        "id": "Rumania",
        "vi": "Romania",
        "nl": "Roemenië",
        "pl": "Rumunia",
        "nb": "Romania",
        "fi": "Romania",
        "ar": "رومانيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Rwanda",
        "ko": "르완다",
        "sc": "卢旺达",
        "es": "Ruanda",
        "ru": "Руанда",
        "ja": "ルワンダ",
        "fr": "Rwanda",
        "de": "Ruanda",
        "it": "Ruanda",
        "th": "รวันดา",
        "id": "Rwanda",
        "vi": "Rwanda",
        "nl": "Rwanda",
        "pl": "Rwanda",
        "nb": "Rwanda",
        "fi": "Ruanda",
        "ar": "رواندا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "South Africa",
        "ko": "남아프리카",
        "sc": "南非",
        "es": "Sudáfrica",
        "ru": "Южная Африка",
        "ja": "南アフリカ",
        "fr": "Afrique du Sud",
        "de": "Südafrika",
        "it": "Sud Africa",
        "th": "แอฟริกาใต้",
        "id": "Afrika Selatan",
        "vi": "Nam Phi",
        "nl": "Zuid-Afrika",
        "pl": "Afryka Południowa",
        "nb": "Sør-Afrika",
        "fi": "Etelä-Afrikka",
        "ar": "جنوب أفريقيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "South Sudan",
        "ko": "남 수단",
        "sc": "南苏丹",
        "es": "Sudán del Sur",
        "ru": "южный Судан",
        "ja": "南スーダン",
        "fr": "Soudan du sud",
        "de": "Südsudan",
        "it": "Sudan del Sud",
        "th": "ซูดานใต้",
        "id": "Sudan Selatan",
        "vi": "phía nam Sudan",
        "nl": "Zuid Soedan",
        "pl": "Południowy Sudan",
        "nb": "Sør-Sudan",
        "fi": "eteläsudan",
        "ar": "جنوب السودان"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Sudan",
        "ko": "수단",
        "sc": "苏丹",
        "es": "Sudán",
        "ru": "Судан",
        "ja": "スーダン",
        "fr": "Soudan",
        "de": "Sudan",
        "it": "Sudan",
        "th": "ซูดาน",
        "id": "Sudan",
        "vi": "Sudan",
        "nl": "Soedan",
        "pl": "Sudan",
        "nb": "Sudan",
        "fi": "Sudan",
        "ar": "السودان"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Syria",
        "ko": "시리아",
        "sc": "叙利亚",
        "es": "Siria",
        "ru": "Сирия",
        "ja": "シリア",
        "fr": "Syrie",
        "de": "Syrien",
        "it": "Siria",
        "th": "ซีเรีย",
        "id": "Suriah",
        "vi": "Syria",
        "nl": "Syrië",
        "pl": "Syria",
        "nb": "Syria",
        "fi": "Syyria",
        "ar": "سوريا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Ukraine",
        "ko": "우크라이나",
        "sc": "乌克兰",
        "es": "Ucrania",
        "ru": "Украина",
        "ja": "ウクライナ",
        "fr": "Ukraine",
        "de": "Ukraine",
        "it": "Ucraina",
        "th": "ยูเครน",
        "id": "Ukraina",
        "vi": "Ukraine",
        "nl": "Oekraïne",
        "pl": "Ukraina",
        "nb": "Ukraina",
        "fi": "Ukraina",
        "ar": "أوكرانيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Zambia",
        "ko": "잠비아",
        "sc": "赞比亚",
        "es": "Zambia",
        "ru": "Замбия",
        "ja": "ザンビア",
        "fr": "Zambie",
        "de": "Sambia",
        "it": "Zambia",
        "th": "แซมเบีย",
        "id": "Zambia",
        "vi": "Zambia",
        "nl": "Zambia",
        "pl": "Zambia",
        "nb": "Zambia",
        "fi": "Sambia",
        "ar": "زامبيا"
    },
    {
        "value": 200,
        "prefix": "(GMT+02:00)",
        "en": "Zimbabwe",
        "ko": "짐바브웨",
        "sc": "津巴布韦",
        "es": "Zimbabue",
        "ru": "Зимбабве",
        "ja": "ジンバブエ",
        "fr": "Zimbabwe",
        "de": "Zimbabwe",
        "it": "Zimbabwe",
        "th": "ซิมบับเว",
        "id": "Zimbabwe",
        "vi": "Zimbabwe",
        "nl": "Zimbabwe",
        "pl": "Zimbabwe",
        "nb": "Zimbabwe",
        "fi": "Zimbabwe",
        "ar": "زيمبابوي"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Arkhangelsk, Russia",
        "ko": "아르한겔스크, 러시아",
        "sc": "俄罗斯阿尔汉格尔斯克",
        "es": "Arcángel, Rusia",
        "ru": "Архангельск, Россия",
        "ja": "アルハンゲリスク、ロシア",
        "fr": "Arkhangelsk, Russie",
        "de": "Archangelsk, Russland",
        "it": "Arkhangelsk, Russia",
        "th": "อาร์คันเกลสค์ รัสเซีย",
        "id": "Arkhangelsk, Rusia",
        "vi": "Arkhangelsk, Nga",
        "nl": "Archangelsk, Rusland",
        "pl": "Archangielsk, Rosja",
        "nb": "Arkhangelsk, Russland",
        "fi": "Arkhangelsk, Venäjä",
        "ar": "أرخانجيلسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Bahrain",
        "ko": "바레인",
        "sc": "巴林",
        "es": "Baréin",
        "ru": "Бахрейн",
        "ja": "バーレーン",
        "fr": "Bahreïn",
        "de": "Bahrein",
        "it": "Bahrein",
        "th": "บาห์เรน",
        "id": "Bahrain",
        "vi": "Bahrain",
        "nl": "Bahrein",
        "pl": "Bahrajn",
        "nb": "Bahrain",
        "fi": "Bahrain",
        "ar": "البحرين"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Belgorod, Russia",
        "ko": "벨고로드, 러시아",
        "sc": "俄罗斯别尔哥罗德",
        "es": "Bélgorod, Rusia",
        "ru": "Белгород, Россия",
        "ja": "ベルゴロド、ロシア",
        "fr": "Belgorod, Russie",
        "de": "Belgorod, Russland",
        "it": "Belgorod, Russia",
        "th": "เบลโกรอด รัสเซีย",
        "id": "Belgorod, Rusia",
        "vi": "Belgorod, Nga",
        "nl": "Belgorod, Rusland",
        "pl": "Biełgorod, Rosja",
        "nb": "Belgorod, Russland",
        "fi": "Belgorod, Venäjä",
        "ar": "بيلغورود ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Belarus",
        "ko": "벨라루스",
        "sc": "白俄罗斯",
        "es": "Bielorrusia",
        "ru": "Беларусь",
        "ja": "ベラルーシ",
        "fr": "Biélorussie",
        "de": "Weißrussland",
        "it": "Bielorussia",
        "th": "เบลารุส",
        "id": "Belarusia",
        "vi": "Belarus",
        "nl": "Wit-Rusland",
        "pl": "Białoruś",
        "nb": "Hviterussland",
        "fi": "Valko-Venäjä",
        "ar": "بيلاروسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Bryansk, Russia",
        "ko": "브랸스크, 러시아",
        "sc": "俄罗斯布良斯克",
        "es": "Briansk, Rusia",
        "ru": "Брянск, Россия",
        "ja": "ブリャンスク、ロシア",
        "fr": "Briansk, Russie",
        "de": "Brjansk, Russland",
        "it": "Brjansk, Russia",
        "th": "ไบรอันสค์ รัสเซีย",
        "id": "Bryansk, Rusia",
        "vi": "Bryansk, Nga",
        "nl": "Brjansk, Rusland",
        "pl": "Briańsk, Rosja",
        "nb": "Bryansk, Russland",
        "fi": "Bryansk, Venäjä",
        "ar": "بريانسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Cheboksary, Russia",
        "ko": "체복사리, 러시아",
        "sc": "俄罗斯切博克萨雷",
        "es": "Cheboksary, Rusia",
        "ru": "Чебоксары, Россия",
        "ja": "チェボクサリ、ロシア",
        "fr": "Tcheboksary, Russie",
        "de": "Tscheboksary, Russland",
        "it": "Cheboksary, Russia",
        "th": "เชบอคซารี รัสเซีย",
        "id": "Cheboksary, Rusia",
        "vi": "Cheboksary, Nga",
        "nl": "Tsjeboksary, Rusland",
        "pl": "Czeboksary, Rosja",
        "nb": "Cheboksary, Russland",
        "fi": "Cheboksary, Venäjä",
        "ar": "تشيبوكساري ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Cherkessk, Russia",
        "ko": "체르케스크, 러시아",
        "sc": "俄罗斯切尔克斯克",
        "es": "Cherkesk, Rusia",
        "ru": "Черкесск, Россия",
        "ja": "チェルケスク、ロシア",
        "fr": "Tcherkessk, Russie",
        "de": "Tscherkessk, Russland",
        "it": "Cherkessk, Russia",
        "th": "เชียร์เคสสค์ รัสเซีย",
        "id": "Cherkessk, Rusia",
        "vi": "Cherkessk, Nga",
        "nl": "Tsjerkessk, Rusland",
        "pl": "Czerkiesk, Rosja",
        "nb": "Cherkessk, Russland",
        "fi": "Cherkessk, Venäjä",
        "ar": "تشيركيسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Comoros",
        "ko": "코모로",
        "sc": "科摩罗",
        "es": "Comoras",
        "ru": "Коморы",
        "ja": "コモロ",
        "fr": "Comores",
        "de": "Komoren",
        "it": "Comore",
        "th": "คอโมโรส",
        "id": "Komoro",
        "vi": "Comoros",
        "nl": "Comoren",
        "pl": "Komory",
        "nb": "Komorene",
        "fi": "Komorit",
        "ar": "جزر القمر"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Djibouti",
        "ko": "지부티",
        "sc": "吉布提",
        "es": "Yibuti",
        "ru": "Джибути",
        "ja": "ジブチ",
        "fr": "Djibouti",
        "de": "Dschibuti",
        "it": "Gibuti",
        "th": "จิบูตี",
        "id": "Djibouti",
        "vi": "Djibouti",
        "nl": "Djibouti",
        "pl": "Dżibuti",
        "nb": "Djibouti",
        "fi": "Djibouti",
        "ar": "جيبوتي"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Elista, Russia",
        "ko": "엘리스타, 러시아",
        "sc": "俄罗斯埃利斯塔",
        "es": "Elistá, Rusia",
        "ru": "Элиста, Россия",
        "ja": "エリスタ、ロシア",
        "fr": "Élista, Russie",
        "de": "Elista, Russland",
        "it": "Elista, Russia",
        "th": "เอลิสตา รัสเซีย",
        "id": "Elista, Rusia",
        "vi": "Elista, Nga",
        "nl": "Elista, Rusland",
        "pl": "Elista, Rosja",
        "nb": "Elista, Russland",
        "fi": "Elista, Venäjä",
        "ar": "إليستا ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Eritrea",
        "ko": "에리트레아",
        "sc": "厄立特里亚",
        "es": "Eritrea",
        "ru": "Эритрея",
        "ja": "エリトリア",
        "fr": "Érythrée",
        "de": "Eritrea",
        "it": "Eritrea",
        "th": "เอริเทรีย",
        "id": "Eritrea",
        "vi": "Eritrea",
        "nl": "Eritrea",
        "pl": "Erytrea",
        "nb": "Eritrea",
        "fi": "Eritrea",
        "ar": "إريتريا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Ethiopia",
        "ko": "에티오피아",
        "sc": "埃塞俄比亚",
        "es": "Etiopía",
        "ru": "Эфиопия",
        "ja": "エチオピア",
        "fr": "Ethiopie",
        "de": "Äthiopien",
        "it": "Etiopia",
        "th": "เอธิโอเปีย",
        "id": "Etiopia",
        "vi": "Ethiopia",
        "nl": "Ethiopië",
        "pl": "Etiopia",
        "nb": "Etiopia",
        "fi": "Etiopia",
        "ar": "أثيوبيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Grozny, Russia",
        "ko": "그로즈니, 러시아",
        "sc": "俄罗斯格罗兹尼",
        "es": "Grozni, Rusia",
        "ru": "Грозный, Россия",
        "ja": "グロズヌイ、ロシア",
        "fr": "Grozny, Russie",
        "de": "Grosny, Russland",
        "it": "Grozny, Russia",
        "th": "กรอซนี รัสเซีย",
        "id": "Grozny, Rusia",
        "vi": "Grozny, Nga",
        "nl": "Grozny, Rusland",
        "pl": "Grozny, Rosja",
        "nb": "Grozny, Russland",
        "fi": "Grozny, Venäjä",
        "ar": "غروزني ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Iraq",
        "ko": "이라크",
        "sc": "伊拉克",
        "es": "Irak",
        "ru": "Ирак",
        "ja": "イラク",
        "fr": "Irak",
        "de": "Irak",
        "it": "Iraq",
        "th": "อิรัก",
        "id": "Irak",
        "vi": "I-rắc",
        "nl": "Irak",
        "pl": "Irak",
        "nb": "Irak",
        "fi": "Irak",
        "ar": "العراق"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Ivanovo, Russia",
        "ko": "이바노보, 러시아 ",
        "sc": "俄罗斯伊万诺沃",
        "es": "Ivánovo, Rusia",
        "ru": "Иваново, Россия",
        "ja": "イヴァノヴォ、ロシア",
        "fr": "Ivanovo, Russie",
        "de": "Iwanowo, Russland",
        "it": "Ivanovo, Russia",
        "th": "อิวาโนโว, รัสเซีย",
        "id": "Ivanovo, Rusia",
        "vi": "Ivanovo, Nga",
        "nl": "Ivanovo, Rusland",
        "pl": "Iwanowo, Rosja",
        "nb": "Ivanovo, Russland",
        "fi": "Ivanovo, Venäjä",
        "ar": "إيفانوفو ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kaluga, Russia",
        "ko": "칼루가, 러시아",
        "sc": "俄罗斯卡卢加",
        "es": "Kaluga, Rusia",
        "ru": "Калуга, Россия",
        "ja": "カルーガ、ロシア",
        "fr": "Kalouga, Russie",
        "de": "Kaluga, Russland",
        "it": "Kaluga, Russia",
        "th": "คาลูกา, รัสเซีย",
        "id": "Kaluga, Rusia",
        "vi": "Kaluga, Nga",
        "nl": "Kaluga, Rusland",
        "pl": "Kaługa, Rosja",
        "nb": "Kaluga, Russland",
        "fi": "Kaluga, Venäjä",
        "ar": "كالوغا ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kazan, Russia",
        "ko": "카잔, 러시아",
        "sc": "俄罗斯喀山",
        "es": "Kazán, Rusia",
        "ru": "Казань, Россия",
        "ja": "カザン、ロシア",
        "fr": "Kazan, Russie",
        "de": "Kasan, Russland",
        "it": "Kazan, Russia",
        "th": "คาซาน, รัสเซีย",
        "id": "Kazan, Rusia",
        "vi": "Kazan, Nga",
        "nl": "Kazan, Rusland",
        "pl": "Kazań, Rosja",
        "nb": "Kazan, Russland",
        "fi": "Kazan, Venäjä",
        "ar": "قازان ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kenya",
        "ko": "케냐",
        "sc": "肯尼亚",
        "es": "Kenia",
        "ru": "Кения",
        "ja": "ケニア",
        "fr": "Kenya",
        "de": "Kenia",
        "it": "Kenia",
        "th": "เคนยา",
        "id": "Kenya",
        "vi": "Kenya",
        "nl": "Kenia",
        "pl": "Kenia",
        "nb": "Kenya",
        "fi": "Kenia",
        "ar": "كينيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kirov, Russia",
        "ko": "키로프, 러시아 ",
        "sc": "俄罗斯基洛夫",
        "es": "Kírov, Rusia",
        "ru": "Киров, Россия",
        "ja": "キーロフ、ロシア",
        "fr": "Kirov, Russie",
        "de": "Kirow, Russland",
        "it": "Kirov, Russia",
        "th": "คิรอฟ รัสเซีย",
        "id": "Kirov, Rusia",
        "vi": "Kirov, Nga",
        "nl": "Kirov, Rusland",
        "pl": "Kirow, Rosja",
        "nb": "Kirov, Russland",
        "fi": "Kirov, Venäjä",
        "ar": "كيروف ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kostroma, Russia",
        "ko": "코스트로마, 러시아 ",
        "sc": "俄罗斯科斯特罗马",
        "es": "Kostromá, Rusia",
        "ru": "Кострома, Россия",
        "ja": "コストロマ、ロシア",
        "fr": "Kostroma, Russie",
        "de": "Kostroma, Russland",
        "it": "Kostroma, Russia",
        "th": "คอสโตรมา, รัสเซีย",
        "id": "Kostroma, Rusia",
        "vi": "Kostroma, Nga",
        "nl": "Kostroma, Rusland",
        "pl": "Kostroma, Rosja",
        "nb": "Kostroma, Russland",
        "fi": "Kostroma, Venäjä",
        "ar": "كوستروما ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Krasnodar, Russia",
        "ko": "크라스노다르, 러시아 ",
        "sc": "俄罗斯克拉斯诺达尔",
        "es": "Krasnodar, Rusia",
        "ru": "Краснодар, Россия",
        "ja": "クラスノダール、ロシア",
        "fr": "Krasnodar, Russie",
        "de": "Krasnodar, Russland",
        "it": "Krasnodar, Russia",
        "th": "ครัสโนดาร์ รัสเซีย",
        "id": "Krasnodar, Rusia",
        "vi": "Krasnodar, Nga",
        "nl": "Krasnodar, Rusland",
        "pl": "Krasnodar, Rosja",
        "nb": "Krasnodar, Russland",
        "fi": "Krasnodar, Venäjä",
        "ar": "كراسنودار ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kuwait",
        "ko": "쿠웨이트",
        "sc": "科威特",
        "es": "Kuwait",
        "ru": "Кувейт",
        "ja": "クウェート",
        "fr": "Koweit",
        "de": "Kuwait",
        "it": "Kuwait",
        "th": "คูเวต",
        "id": "Kuwait",
        "vi": "Kuwait",
        "nl": "Koeweit",
        "pl": "Kuwejt",
        "nb": "Kuwait",
        "fi": "Kuwait",
        "ar": "الكويت"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Kursk, Russia",
        "ko": "쿠르스크, 러시아 ",
        "sc": "俄罗斯库尔斯克",
        "es": "Kursk, Rusia",
        "ru": "Курск, Россия",
        "ja": "クルスク、ロシア",
        "fr": "Koursk, Russie",
        "de": "Kursk, Russland",
        "it": "Kursk, Russia",
        "th": "คูสค์, รัสเซีย",
        "id": "Kursk, Rusia",
        "vi": "Kursk, Nga",
        "nl": "Koersk, Rusland",
        "pl": "Kursk, Rosja",
        "nb": "Kursk, Russland",
        "fi": "Kursk, Venäjä",
        "ar": "كورسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Lipetsk, Russia",
        "ko": "리페츠크, 러시아",
        "sc": "俄罗斯利佩茨克",
        "es": "Lípetsk, Rusia",
        "ru": "Липецк, Россия",
        "ja": "リペツク、ロシア",
        "fr": "Lipetsk, Russie",
        "de": "Lipezk, Russland",
        "it": "Lipeck, Russia",
        "th": "ลีเปตสค์ รัสเซีย",
        "id": "Lipetsk, Rusia",
        "vi": "Lipetsk, Nga",
        "nl": "Lipetsk, Rusland",
        "pl": "Lipieck, Rosja",
        "nb": "Lipetsk, Russland",
        "fi": "Lipetsk, Venäjä",
        "ar": "ليبيتسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Madagascar",
        "ko": "마다가스카르",
        "sc": "马达加斯加",
        "es": "Madagascar",
        "ru": "Мадагаскар",
        "ja": "マダガスカル",
        "fr": "Madagascar",
        "de": "Madagaskar",
        "it": "Madagascar",
        "th": "มาดากัสการ์",
        "id": "Madagaskar",
        "vi": "Madagascar",
        "nl": "Madagascar",
        "pl": "Madagaskar",
        "nb": "Madagaskar",
        "fi": "Madagaskar",
        "ar": "مدغشقر"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Magas, Russia",
        "ko": "마가스, 러시아",
        "sc": "俄罗斯马加斯",
        "es": "Magás, Rusia",
        "ru": "Магас, Россия",
        "ja": "マガス、ロシア",
        "fr": "Magas, Russie",
        "de": "Magas, Russland",
        "it": "Magas, Russia",
        "th": "มากัส รัสเซีย",
        "id": "Magas, Rusia",
        "vi": "Magas, Nga",
        "nl": "Magas, Rusland",
        "pl": "Magas, Rosja",
        "nb": "Magas, Russland",
        "fi": "Magas, Venäjä",
        "ar": "ماجاس ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Makhachkala, Russia",
        "ko": "마하치칼라, 러시아",
        "sc": "俄罗斯马哈奇卡拉",
        "es": "Majachkalá, Rusia",
        "ru": "Махачкала, Россия",
        "ja": "マハチカラ、ロシア",
        "fr": "Makhatchkala, Russie",
        "de": "Machatschkala, Russland",
        "it": "Machačkala, Russia",
        "th": "มาคัชคาลา รัสเซีย",
        "id": "Makhachkala, Rusia",
        "vi": "Makhachkala, Nga",
        "nl": "Makhachkala, Rusland",
        "pl": "Machaczkała, Rosja",
        "nb": "Makhachkala, Russland",
        "fi": "Makhachkala, Venäjä",
        "ar": "محج قلعة ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Maykop, Russia",
        "ko": "메이콥, 러시아",
        "sc": "俄罗斯梅科普",
        "es": "Maykop, Rusia",
        "ru": "Майкоп, Россия",
        "ja": "マイコープ、ロシア",
        "fr": "Maïkop, Russie",
        "de": "Maikop, Russland",
        "it": "Maykop, Russia",
        "th": "มายคอป รัสเซีย",
        "id": "Maykop, Rusia",
        "vi": "Maykop, Nga",
        "nl": "Maykop, Rusland",
        "pl": "Majkop, Rosja",
        "nb": "Maykop, Russland",
        "fi": "Maykop, Venäjä",
        "ar": "مايكوب ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Mayotte",
        "ko": "마요트",
        "sc": "马约特岛",
        "es": "Mayotte",
        "ru": "Майотта",
        "ja": "マヨット",
        "fr": "Mayotte",
        "de": "Mayotte",
        "it": "Mayotte",
        "th": "มายอต",
        "id": "mayotte",
        "vi": "Mayotte",
        "nl": "Mayotte",
        "pl": "Majotta",
        "nb": "Mayotte",
        "fi": "Mayotte",
        "ar": "مايوت"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Moscow, Russia",
        "ko": "모스크바, 러시아",
        "sc": "俄罗斯莫斯科",
        "es": "Moscú, Rusia",
        "ru": "Москва, Россия",
        "ja": "ロシアのモスクワ",
        "fr": "Moscou, Russie",
        "de": "Moskau, Russland",
        "it": "Mosca, Russia",
        "th": "มอสโควประเทศรัสเซีย",
        "id": "Moskow, Rusia",
        "vi": "Mát-xcơ-va, Nga",
        "nl": "Moskou, Rusland",
        "pl": "Moskwa, Rosja",
        "nb": "Moskva, Russland",
        "fi": "Moskova, Venäjä",
        "ar": "موسكو، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Murmansk, Russia",
        "ko": "무르만스크, 러시아",
        "sc": "俄罗斯摩尔曼斯克",
        "es": "Múrmansk, Rusia",
        "ru": "Мурманск, Россия",
        "ja": "ムルマンスク、ロシア",
        "fr": "Mourmansk, Russie",
        "de": "Murmansk, Russland",
        "it": "Murmansk, Russia",
        "th": "มูร์มันสค์ รัสเซีย",
        "id": "Murmansk, Rusia",
        "vi": "Murmansk, Nga",
        "nl": "Moermansk, Rusland",
        "pl": "Murmańsk, Rosja",
        "nb": "Murmansk, Russland",
        "fi": "Murmansk, Venäjä",
        "ar": "مورمانسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Nalchik, Russia",
        "ko": "날치크, 러시아",
        "sc": "俄罗斯纳尔奇克",
        "es": "Nálchik, Rusia",
        "ru": "Нальчик, Россия",
        "ja": "ナリチク、ロシア",
        "fr": "Naltchik, Russie",
        "de": "Naltschik, Russland",
        "it": "Nalčik, Russia",
        "th": "นัลชิค รัสเซีย",
        "id": "Nalchik, Rusia",
        "vi": "Nalchik, Nga",
        "nl": "Nalchik, Rusland",
        "pl": "Nalczyk, Rosja",
        "nb": "Nalchik, Russland",
        "fi": "Naltshik, Venäjä",
        "ar": "نالتشيك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Naryan-Mar, Russia",
        "ko": "나리얀마르, 러시아 ",
        "sc": "俄罗斯纳良马尔",
        "es": "Naryan-Mar, Rusia",
        "ru": "Нарьян-Мар, Россия",
        "ja": "ナリヤンマル、ロシア",
        "fr": "Narian-Mar, Russie",
        "de": "Naryan-Mar, Russland",
        "it": "Naryan-Mar, Russia",
        "th": "Naryan-Mar รัสเซีย",
        "id": "Naryan-Mar, Rusia",
        "vi": "Naryan-Mar, Nga",
        "nl": "Naryan-Mar, Rusland",
        "pl": "Naryan-Mar, Rosja",
        "nb": "Naryan-Mar, Russland",
        "fi": "Naryan-Mar, Venäjä",
        "ar": "ناريان مار ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Nizhny Novgorod, Russia",
        "ko": "니즈니노브고로드, 러시아",
        "sc": "俄罗斯下诺夫哥罗德",
        "es": "Nizhni Nóvgorod, Rusia",
        "ru": "Нижний Новгород, Россия",
        "ja": "ニジニノヴゴロド、ロシア",
        "fr": "Nijni Novgorod, Russie",
        "de": "Nischni Nowgorod, Russland",
        "it": "Nizhny Novgorod, Russia",
        "th": "นิชนีย์ นอฟโกรอด รัสเซีย",
        "id": "Nizhny Novgorod, Rusia",
        "vi": "Nizhny Novgorod, Nga",
        "nl": "Nizjni Novgorod, Rusland",
        "pl": "Niżny Nowogród, Rosja",
        "nb": "Nizhny Novgorod, Russland",
        "fi": "Nižni Novgorod, Venäjä",
        "ar": "نيجني نوفغورود ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Oryol, Russia",
        "ko": "오뇰, 러시아 ",
        "sc": "俄罗斯奥廖尔",
        "es": "Oriol, Rusia",
        "ru": "Орёл, Россия",
        "ja": "オリョール、ロシア",
        "fr": "Orel, Russie",
        "de": "Orjol, Russland",
        "it": "Orël, Russia",
        "th": "โอริออล, รัสเซีย",
        "id": "Oryol, Rusia",
        "vi": "Oryol, Nga",
        "nl": "Orjol, Rusland",
        "pl": "Oryol, Rosja",
        "nb": "Oryol, Russland",
        "fi": "Oryol, Venäjä",
        "ar": "أوريول ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Penza, Russia",
        "ko": "펜자, 러시아",
        "sc": "俄罗斯奔萨",
        "es": "Penza, Rusia",
        "ru": "Пенза, Россия",
        "ja": "ペンザ、ロシア",
        "fr": "Penza, Russie",
        "de": "Pensa, Russland",
        "it": "Penza, Russia",
        "th": "เพนซา รัสเซีย",
        "id": "Penza, Rusia",
        "vi": "Penza, Nga",
        "nl": "Penza, Rusland",
        "pl": "Penza, Rosja",
        "nb": "Penza, Russland",
        "fi": "Penza, Venäjä",
        "ar": "بينزا ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Petrozavodsk, Russia",
        "ko": "페트로자보츠크, 러시아",
        "sc": "俄罗斯彼得罗扎沃茨克",
        "es": "Petrozavodsk, Rusia",
        "ru": "Петрозаводск, Россия",
        "ja": "ペトロザボーツク、ロシア",
        "fr": "Petrozavodsk, Russie",
        "de": "Petrosawodsk, Russland",
        "it": "Petrozavodsk, Russia",
        "th": "เปโตรซาวอดสค์ รัสเซีย",
        "id": "Petrozavodsk, Rusia",
        "vi": "Petrozavodsk, Nga",
        "nl": "Petrozavodsk, Rusland",
        "pl": "Pietrozawodsk, Rosja",
        "nb": "Petrozavodsk, Russland",
        "fi": "Petroskoi, Venäjä",
        "ar": "بتروزافودسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Pskov, Russia",
        "ko": "프스코프, 러시아",
        "sc": "俄罗斯普斯科夫",
        "es": "Pskov, Rusia",
        "ru": "Псков, Россия",
        "ja": "プスコフ、ロシア",
        "fr": "Pskov, Russie",
        "de": "Pskow, Russland",
        "it": "Pskov, Russia",
        "th": "ปัสคอฟ รัสเซีย",
        "id": "Pskov, Rusia",
        "vi": "Pskov, Nga",
        "nl": "Pskov, Rusland",
        "pl": "Psków, Rosja",
        "nb": "Pskov, Russland",
        "fi": "Pihkova, Venäjä",
        "ar": "بسكوف ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Qatar",
        "ko": "카타르",
        "sc": "卡塔尔",
        "es": "Katar",
        "ru": "Катар",
        "ja": "カタール",
        "fr": "Qatar",
        "de": "Katar",
        "it": "Qatar",
        "th": "กาตาร์",
        "id": "Qatar",
        "vi": "Qatar",
        "nl": "Qatar",
        "pl": "Katar",
        "nb": "Qatar",
        "fi": "Qatar",
        "ar": "دولة قطر"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Rostov-on-Don, Russia",
        "ko": "로스토프나도누, 러시아",
        "sc": "俄罗斯顿河畔罗斯托夫",
        "es": "Rostov del Don, Rusia",
        "ru": "Ростов-на-Дону, Россия",
        "ja": "ロストフオンドン、ロシア",
        "fr": "Rostov-sur-le-Don, Russie",
        "de": "Rostow am Don, Russland",
        "it": "Rostov sul Don, Russia",
        "th": "รอสตอฟ ออนดอน รัสเซีย",
        "id": "Rostov-on-Don, Rusia",
        "vi": "Rostov-on-Don, Nga",
        "nl": "Rostov aan de Don, Rusland",
        "pl": "Rostów nad Donem, Rosja",
        "nb": "Rostov ved Don, Russland",
        "fi": "Rostov-on-Don, Venäjä",
        "ar": "روستوف أون دون ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Ryazan, Russia",
        "ko": "랴잔, 러시아",
        "sc": "俄罗斯梁赞",
        "es": "Riazán, Rusia",
        "ru": "Рязань, Россия",
        "ja": "リャザン、ロシア",
        "fr": "Riazan, Russie",
        "de": "Rjasan, Russland",
        "it": "Riazán, Russia",
        "th": "เรียซัน, รัสเซีย",
        "id": "Ryazan, Rusia",
        "vi": "Ryazan, Nga",
        "nl": "Ryazan, Rusland",
        "pl": "Riazań, Rosja",
        "nb": "Ryazan, Russland",
        "fi": "Ryazan, Venäjä",
        "ar": "ريازان ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Saint Petersburg, Russia",
        "ko": "상트페테르부르크, 러시아",
        "sc": "俄罗斯圣彼得堡",
        "es": "San Petersburgo, Rusia",
        "ru": "Санкт-Петербург, Россия",
        "ja": "サンクトペテルブルク、ロシア",
        "fr": "Saint-Pétersbourg, Russie",
        "de": "Sankt Petersburg, Russland",
        "it": "San Pietroburgo, Russia",
        "th": "เซนต์ปีเตอร์สเบิร์ก รัสเซีย",
        "id": "Saint Petersburg, Rusia",
        "vi": "Saint Petersburg, Nga",
        "nl": "Sint-Petersburg, Rusland",
        "pl": "Sankt Petersburg, Rosja",
        "nb": "Sankt Petersburg, Russland",
        "fi": "Pietari, Venäjä",
        "ar": "سانت بطرسبرغ ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Saransk, Russia",
        "ko": "사란스크, 러시아",
        "sc": "俄罗斯萨兰斯克",
        "es": "Saransk, Rusia",
        "ru": "Саранск, Россия",
        "ja": "サランスク、ロシア",
        "fr": "Saransk, Russie",
        "de": "Saransk, Russland",
        "it": "Saransk, Russia",
        "th": "ซารันสค์ รัสเซีย",
        "id": "Saransk, Rusia",
        "vi": "Saransk, Nga",
        "nl": "Saransk, Rusland",
        "pl": "Sarańsk, Rosja",
        "nb": "Saransk, Russland",
        "fi": "Saransk, Venäjä",
        "ar": "سارانسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Saratov, Russia",
        "ko": "사라토프, 러시아",
        "sc": "俄罗斯萨拉托夫",
        "es": "Sarátov, Rusia",
        "ru": "Саратов, Россия",
        "ja": "サラトフ、ロシア",
        "fr": "Saratov, Russie",
        "de": "Saratow, Russland",
        "it": "Saratov, Russia",
        "th": "ซาราตอฟ รัสเซีย",
        "id": "Saratov, Rusia",
        "vi": "Saratov, Nga",
        "nl": "Saratov, Rusland",
        "pl": "Saratów, Rosja",
        "nb": "Saratov, Russland",
        "fi": "Saratov, Venäjä",
        "ar": "ساراتوف ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Saudi Arabia",
        "ko": "사우디 아라비아",
        "sc": "沙特阿拉伯",
        "es": "Arabia Saudita",
        "ru": "Саудовская Аравия",
        "ja": "サウジアラビア",
        "fr": "Arabie Saoudite",
        "de": "Saudi-Arabien",
        "it": "Arabia Saudita",
        "th": "ซาอุดิอาราเบีย",
        "id": "Arab Saudi",
        "vi": "Ả Rập Saudi",
        "nl": "Saoedi-Arabië",
        "pl": "Arabia Saudyjska",
        "nb": "Saudi-Arabia",
        "fi": "Saudi-Arabia",
        "ar": "المملكة العربية السعودية"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Sevastopol, Russia",
        "ko": "세바스토폴, 러시아",
        "sc": "俄罗斯塞瓦斯托波尔",
        "es": "Sebastopol, Rusia",
        "ru": "Севастополь, Россия",
        "ja": "セヴァストポリ、ロシア",
        "fr": "Sébastopol, Russie",
        "de": "Sewastopol, Russland",
        "it": "Sebastopoli, Russia",
        "th": "เซวาสโทพอล รัสเซีย",
        "id": "Sevastopol, Rusia",
        "vi": "Sevastopol, Nga",
        "nl": "Sebastopol, Rusland",
        "pl": "Sewastopol, Rosja",
        "nb": "Sevastopol, Russland",
        "fi": "Sevastopol, Venäjä",
        "ar": "سيفاستوبول ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Simferopol, Russia",
        "ko": "심페로폴, 러시아",
        "sc": "俄罗斯辛菲罗波尔",
        "es": "Simferópol, Rusia",
        "ru": "Симферополь, Россия",
        "ja": "シンフェロポリ、ロシア",
        "fr": "Simferopol, Russie",
        "de": "Simferopol, Russland",
        "it": "Simferopoli, Russia",
        "th": "ซิมเฟอโรโพล รัสเซีย",
        "id": "Simferopol, Rusia",
        "vi": "Simferopol, Nga",
        "nl": "Simferopol, Rusland",
        "pl": "Symferopol, Rosja",
        "nb": "Simferopol, Russland",
        "fi": "Simferopol, Venäjä",
        "ar": "سيمفيروبول ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Smolensk, Russia",
        "ko": "스몰렌스크, 러시아",
        "sc": "俄罗斯斯摩棱斯克",
        "es": "Smolensk, Rusia",
        "ru": "Смоленск, Россия",
        "ja": "スモレンスク、ロシア",
        "fr": "Smolensk, Russie",
        "de": "Smolensk, Russland",
        "it": "Smolensk, Russia",
        "th": "สโมเลนสค์ รัสเซีย",
        "id": "Smolensk, Rusia",
        "vi": "Smolensk, Nga",
        "nl": "Smolensk, Rusland",
        "pl": "Smoleńsk, Rosja",
        "nb": "Smolensk, Russland",
        "fi": "Smolensk, Venäjä",
        "ar": "سمولينسك ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Somalia",
        "ko": "소말리아",
        "sc": "索马里",
        "es": "Somalia",
        "ru": "Сомали",
        "ja": "ソマリア",
        "fr": "Somalie",
        "de": "Somalia",
        "it": "Somalia",
        "th": "โซมาเลีย",
        "id": "Somalia",
        "vi": "Somalia",
        "nl": "Somalië",
        "pl": "Somali",
        "nb": "Somalia",
        "fi": "Somalia",
        "ar": "الصومال"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Stavropol, Russia",
        "ko": "스타브로폴, 러시아",
        "sc": "俄罗斯斯塔夫罗波尔",
        "es": "Stavropol, Rusia",
        "ru": "Ставрополь, Россия",
        "ja": "スタヴロポリ、ロシア",
        "fr": "Stavropol, Russie",
        "de": "Stawropol, Russland",
        "it": "Stavropol, Russia",
        "th": "สตัฟโรปอล, รัสเซีย",
        "id": "Stavropol, Rusia",
        "vi": "Stavropol, Nga",
        "nl": "Stavropol, Rusland",
        "pl": "Stawropol, Rosja",
        "nb": "Stavropol, Russland",
        "fi": "Stavropol, Venäjä",
        "ar": "ستافروبول ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Syktyvkar, Russia",
        "ko": "식티프카르, 러시아",
        "sc": "俄罗斯塞克特夫卡尔",
        "es": "Syktyvkar, Rusia",
        "ru": "Сыктывкар, Россия",
        "ja": "シクティフカル、ロシア",
        "fr": "Syktyvkar, Russie",
        "de": "Syktywkar, Russland",
        "it": "Syktyvkar, Russia",
        "th": "ซิคทิฟคาร์ รัสเซีย",
        "id": "Syktyvkar, Rusia",
        "vi": "Syktyvkar, Nga",
        "nl": "Syktyvkar, Rusland",
        "pl": "Syktywkar, Rosja",
        "nb": "Syktyvkar, Russland",
        "fi": "Syktyvkar, Venäjä",
        "ar": "سيكتيفكار ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Tambov, Russia",
        "ko": "탐보프, 러시아",
        "sc": "俄罗斯坦波夫",
        "es": "Tambov, Rusia",
        "ru": "Тамбов, Россия",
        "ja": "タンボフ、ロシア",
        "fr": "Tambov, Russie",
        "de": "Tambow, Russland",
        "it": "Tambov, Russia",
        "th": "ตัมบอฟ รัสเซีย",
        "id": "Tambov, Rusia",
        "vi": "Tambov, Nga",
        "nl": "Tambov, Rusland",
        "pl": "Tambow, Rosja",
        "nb": "Tambov, Russland",
        "fi": "Tambov, Venäjä",
        "ar": "تامبوف ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Tanzania",
        "ko": "탄자니아",
        "sc": "坦桑尼亚",
        "es": "Tanzania",
        "ru": "Танзания",
        "ja": "タンザニア",
        "fr": "Tanzanie",
        "de": "Tansania",
        "it": "Tanzania",
        "th": "แทนซาเนีย",
        "id": "Tanzania",
        "vi": "Tanzania",
        "nl": "Tanzania",
        "pl": "Tanzania",
        "nb": "Tanzania",
        "fi": "Tansania",
        "ar": "تنزانيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Tula, Russia",
        "ko": "툴라, 러시아",
        "sc": "俄罗斯图拉",
        "es": "Tula, Rusia",
        "ru": "Тула, Россия",
        "ja": "トゥーラ、ロシア",
        "fr": "Toula, Russie",
        "de": "Tula, Russland",
        "it": "Tula, Russia",
        "th": "ทูลา รัสเซีย",
        "id": "Tula, Rusia",
        "vi": "Tula, Nga",
        "nl": "Tula, Rusland",
        "pl": "Tuła, Rosja",
        "nb": "Tula, Russland",
        "fi": "Tula, Venäjä",
        "ar": "تولا ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Turkey (Türkiye)",
        "ko": "터키(튀르키예)",
        "sc": "土耳其",
        "es": "Turquía (Türkiye)",
        "ru": "Турция (Türkiye)",
        "ja": "トルコ（Türkiye）",
        "fr": "Turquie (Türkiye)",
        "de": "Türkei (Türkiye)",
        "it": "Turchia (Turchia)",
        "th": "ตุรกี (Türkiye)",
        "id": "Turki (Turkiye)",
        "vi": "Thổ Nhĩ Kỳ (Türkiye)",
        "nl": "Turkije",
        "pl": "Turcja (Turcja)",
        "nb": "Tyrkia (Türkiye)",
        "fi": "Turkki (Türkiye)",
        "ar": "تركيا (Türkiye)"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Tver, Russia",
        "ko": "트베르, 러시아",
        "sc": "俄罗斯特维尔",
        "es": "Tver, Rusia",
        "ru": "Тверь, Россия",
        "ja": "トヴェリ、ロシア",
        "fr": "Tver, Russie",
        "de": "Twer, Russland",
        "it": "Tver, Russia",
        "th": "ตเวียร์, รัสเซีย",
        "id": "Tver, Rusia",
        "vi": "Tver, Nga",
        "nl": "Tver, Rusland",
        "pl": "Twer, Rosja",
        "nb": "Tver, Russland",
        "fi": "Tver, Venäjä",
        "ar": "تفير ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Uganda",
        "ko": "우간다",
        "sc": "乌干达",
        "es": "Uganda",
        "ru": "Уганда",
        "ja": "ウガンダ",
        "fr": "Ouganda",
        "de": "Uganda",
        "it": "Uganda",
        "th": "ยูกันดา",
        "id": "Uganda",
        "vi": "Uganda",
        "nl": "Oeganda",
        "pl": "Uganda",
        "nb": "Uganda",
        "fi": "Uganda",
        "ar": "أوغندا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Veliky Novgorod, Russia",
        "ko": "벨리키 노브고로드, 러시아",
        "sc": "俄罗斯大诺夫哥罗德",
        "es": "Veliky Nóvgorod, Rusia",
        "ru": "Великий Новгород, Россия",
        "ja": "ノヴゴロド、ロシア",
        "fr": "Veliki Novgorod, Russie",
        "de": "Weliki Nowgorod, Russland",
        "it": "Velikij Novgorod, Russia",
        "th": "เวลิกี นอฟโกรอด รัสเซีย",
        "id": "Veliky Novgorod, Rusia",
        "vi": "Veliky Novgorod, Nga",
        "nl": "Veliki Novgorod, Rusland",
        "pl": "Nowogród Wielki, Rosja",
        "nb": "Veliky Novgorod, Russland",
        "fi": "Veliki Novgorod, Venäjä",
        "ar": "فيليكي نوفغورود ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Vladimir, Russia",
        "ko": "블라디미르, 러시아",
        "sc": "俄罗斯弗拉基米尔",
        "es": "Vladímir, Rusia",
        "ru": "Владимир, Россия",
        "ja": "ウラジミール、ロシア",
        "fr": "Vladimir, Russie",
        "de": "Wladimir, Russland",
        "it": "Vladimir, Russia",
        "th": "วลาดิเมียร์ รัสเซีย",
        "id": "Vladimir, Rusia",
        "vi": "Vladimir, Nga",
        "nl": "Vladimir, Rusland",
        "pl": "Włodzimierz, Rosja",
        "nb": "Vladimir, Russland",
        "fi": "Vladimir, Venäjä",
        "ar": "فلاديمير ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Vladikavkaz, Russia",
        "ko": "블라디카프카즈, 러시아",
        "sc": "俄罗斯弗拉季高加索",
        "es": "Vladikavkaz, Rusia",
        "ru": "Владикавказ, Россия",
        "ja": "ウラジカフカス、ロシア",
        "fr": "Vladikavkaz, Russie",
        "de": "Wladikawkas, Russland",
        "it": "Vladikavkaz, Russia",
        "th": "วลาดิคัฟคัซ รัสเซีย",
        "id": "Vladikavkaz, Rusia",
        "vi": "Vladikavkaz, Nga",
        "nl": "Vladikavkaz, Rusland",
        "pl": "Władykaukaz, Rosja",
        "nb": "Vladikavkaz, Russland",
        "fi": "Vladikavkaz, Venäjä",
        "ar": "فلاديكافكاز ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Volgograd, Russia",
        "ko": "볼고그라드, 러시아",
        "sc": "俄罗斯伏尔加格勒",
        "es": "Volgogrado, Rusia",
        "ru": "Волгоград, Россия",
        "ja": "ヴォルゴグラード、ロシア",
        "fr": "Volgograd, Russie",
        "de": "Wolgograd, Russland",
        "it": "Volgograd, Russia",
        "th": "โวลโกกราด รัสเซีย",
        "id": "Volgograd, Rusia",
        "vi": "Volgograd, Nga",
        "nl": "Volgograd, Rusland",
        "pl": "Wołgograd, Rosja",
        "nb": "Volgograd, Russland",
        "fi": "Volgograd, Venäjä",
        "ar": "فولغوغراد ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Vologda, Russia",
        "ko": "볼로그다, 러시아",
        "sc": "俄罗斯沃洛格达",
        "es": "Vólogda, Rusia",
        "ru": "Вологда, Россия",
        "ja": "ヴォログダ、ロシア",
        "fr": "Vologda, Russie",
        "de": "Wologda, Russland",
        "it": "Vologda, Russia",
        "th": "โวลอกดา, รัสเซีย",
        "id": "Vologda, Rusia",
        "vi": "Vologda, Nga",
        "nl": "Vologda, Rusland",
        "pl": "Wołogda, Rosja",
        "nb": "Vologda, Russland",
        "fi": "Vologda, Venäjä",
        "ar": "فولوغدا ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Voronezh, Russia",
        "ko": "보로네시, 러시아",
        "sc": "俄罗斯沃罗涅日",
        "es": "Vorónezh, Rusia",
        "ru": "Воронеж, Россия",
        "ja": "ヴォロネジ、ロシア",
        "fr": "Voronej, Russie",
        "de": "Woronesch, Russland",
        "it": "Voronez, Russia",
        "th": "โวโรเนจ รัสเซีย",
        "id": "Voronezh, Rusia",
        "vi": "Voronezh, Nga",
        "nl": "Voronezj, Rusland",
        "pl": "Woroneż, Rosja",
        "nb": "Voronezh, Russland",
        "fi": "Voronezh, Venäjä",
        "ar": "فورونيج ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Yaroslavl, Russia",
        "ko": "야로슬라블, 러시아",
        "sc": "俄罗斯雅罗斯拉夫尔",
        "es": "Yaroslavl, Rusia",
        "ru": "Ярославль, Россия",
        "ja": "ヤロスラヴリ、ロシア",
        "fr": "Iaroslavl, Russie",
        "de": "Jaroslawl, Russland",
        "it": "Jaroslavl, Russia",
        "th": "ยาโรสลาฟล์, รัสเซีย",
        "id": "Yaroslavl, Rusia",
        "vi": "Yaroslavl, Nga",
        "nl": "Yaroslavl, Rusland",
        "pl": "Jarosław, Rosja",
        "nb": "Yaroslavl, Russland",
        "fi": "Jaroslavl, Venäjä",
        "ar": "ياروسلافل ، روسيا"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Yemen",
        "ko": "예멘",
        "sc": "也门",
        "es": "Yemen",
        "ru": "Йемен",
        "ja": "イエメン",
        "fr": "Yémen",
        "de": "Jemen",
        "it": "Yemen",
        "th": "เยเมน",
        "id": "Yaman",
        "vi": "Yemen",
        "nl": "Jemen",
        "pl": "Jemen",
        "nb": "Jemen",
        "fi": "Jemen",
        "ar": "اليمن"
    },
    {
        "value": 300,
        "prefix": "(GMT+03:00)",
        "en": "Yoshkar-Ola, Russia",
        "ko": "요시카르올라, 러시아",
        "sc": "俄罗斯约什卡尔奥拉",
        "es": "Yoshkar-Ola, Rusia",
        "ru": "Йошкар-Ола, Россия",
        "ja": "ヨシュカル・オラ、ロシア",
        "fr": "Iochkar-Ola, Russie",
        "de": "Joschkar-Ola, Russland",
        "it": "Yoshkar-Ola, Russia",
        "th": "ยอชคาร์-โอลา, รัสเซีย",
        "id": "Yoshikar-Ola, Rusia",
        "vi": "Yoshkar-Ola, Nga",
        "nl": "Yoshkar-Ola, Rusland",
        "pl": "Joszkar-Ola, Rosja",
        "nb": "Yoshkar-Ola, Russland",
        "fi": "Joškar-Ola, Venäjä",
        "ar": "يوشكار أولا ، روسيا"
    },
    {
        "value": 330,
        "prefix": "(GMT+03:30)",
        "en": "Iran",
        "ko": "이란",
        "sc": "伊朗",
        "es": "Irán",
        "ru": "Иран",
        "ja": "イラン",
        "fr": "L'Iran",
        "de": "Iran",
        "it": "Iran",
        "th": "อิหร่าน",
        "id": "Iran",
        "vi": "Iran",
        "nl": "Iran",
        "pl": "Iran",
        "nb": "Iran",
        "fi": "Iran",
        "ar": "إيران"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Armenia",
        "ko": "아르메니아",
        "sc": "亚美尼亚",
        "es": "Armenia",
        "ru": "Армения",
        "ja": "アルメニア",
        "fr": "Arménie",
        "de": "Armenien",
        "it": "Armenia",
        "th": "อาร์เมเนีย",
        "id": "Armenia",
        "vi": "Armenia",
        "nl": "Armenië",
        "pl": "Armenia",
        "nb": "Armenia",
        "fi": "Armenia",
        "ar": "أرمينيا"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Astrakhan, Russia",
        "ko": "아스트라한, 러시아",
        "sc": "俄罗斯阿斯特拉罕",
        "es": "Astracán, Rusia",
        "ru": "Астрахань, Россия",
        "ja": "アストラハン、ロシア",
        "fr": "Astrakhan, Russie",
        "de": "Astrachan, Russland",
        "it": "Astrachan, Russia",
        "th": "อัสตราคาน รัสเซีย",
        "id": "Astrakhan, Rusia",
        "vi": "Astrakhan, Nga",
        "nl": "Astrachan, Rusland",
        "pl": "Astrachań, Rosja",
        "nb": "Astrakhan, Russland",
        "fi": "Astrakhan, Venäjä",
        "ar": "استراخان ، روسيا"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Azerbaijan",
        "ko": "아제르바이잔",
        "sc": "阿塞拜疆",
        "es": "Azerbaiyán",
        "ru": "Азербайджан",
        "ja": "アゼルバイジャン",
        "fr": "Azerbaïdjan",
        "de": "Aserbaidschan",
        "it": "Azerbaigian",
        "th": "อาเซอร์ไบจาน",
        "id": "Azerbaijan",
        "vi": "Azerbaijan",
        "nl": "Azerbeidzjan",
        "pl": "Azerbejdżan",
        "nb": "Aserbajdsjan",
        "fi": "Azerbaidžan",
        "ar": "أذربيجان"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Georgia",
        "ko": "조지아",
        "sc": "乔治亚州",
        "es": "Georgia",
        "ru": "Грузия",
        "ja": "ジョージア",
        "fr": "Géorgie",
        "de": "Georgia",
        "it": "Georgia",
        "th": "จอร์เจีย",
        "id": "Georgia",
        "vi": "Georgia",
        "nl": "Georgië",
        "pl": "Gruzja",
        "nb": "Georgia",
        "fi": "Georgia",
        "ar": "جورجيا"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Izhevsk, Russia",
        "ko": "이젭스크, 러시아",
        "sc": "俄罗斯伊热夫斯克",
        "es": "Izhevsk, Rusia",
        "ru": "Ижевск, Россия",
        "ja": "イジェフスク、ロシア",
        "fr": "Ijevsk, Russie",
        "de": "Ischewsk, Russland",
        "it": "Iževsk, Russia",
        "th": "อีเจฟสค์ รัสเซีย",
        "id": "Izhevsk, Rusia",
        "vi": "Izhevsk, Nga",
        "nl": "Izjevsk, Rusland",
        "pl": "Iżewsk, Rosja",
        "nb": "Izhevsk, Russland",
        "fi": "Izhevsk, Venäjä",
        "ar": "إيجيفسك ، روسيا"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Mauritius",
        "ko": "모리셔스",
        "sc": "毛里求斯",
        "es": "Mauricio",
        "ru": "Маврикий",
        "ja": "モーリシャス",
        "fr": "Maurice",
        "de": "Mauritius",
        "it": "Maurizio",
        "th": "มอริเชียส",
        "id": "Mauritius",
        "vi": "Mauritius",
        "nl": "Mauritius",
        "pl": "Mauritius",
        "nb": "Mauritius",
        "fi": "Mauritius",
        "ar": "موريشيوس"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Oman",
        "ko": "오만",
        "sc": "阿曼",
        "es": "Omán",
        "ru": "Оман",
        "ja": "オマーン",
        "fr": "Oman",
        "de": "Oman",
        "it": "Oman",
        "th": "โอมาน",
        "id": "Oman",
        "vi": "Oman",
        "nl": "Oman",
        "pl": "Oman",
        "nb": "Oman",
        "fi": "Oman",
        "ar": "سلطنة عمان"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Réunion",
        "ko": "레이뉘옹",
        "sc": "Réunion",
        "es": "Reunión",
        "ru": "Реюньон",
        "ja": "レユニオン",
        "fr": "Réunion",
        "de": "Réunion",
        "it": "La Riunione",
        "th": "เรอูว์นียง",
        "id": "Réunion",
        "vi": "Réunion",
        "nl": "Réunion",
        "pl": "Reunion",
        "nb": "Réunion",
        "fi": "Réunion",
        "ar": "لا ريونيون"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Samara, Russia",
        "ko": "사마라, 러시아",
        "sc": "俄罗斯萨马拉",
        "es": "Samara, Rusia",
        "ru": "Самара, Россия",
        "ja": "サマラ、ロシア",
        "fr": "Samara, Russie",
        "de": "Samara, Russland",
        "it": "Samara, Russia",
        "th": "ซามารา รัสเซีย",
        "id": "Samara, Rusia",
        "vi": "Samara, Nga",
        "nl": "Samara, Rusland",
        "pl": "Samara, Rosja",
        "nb": "Samara, Russland",
        "fi": "Samara, Venäjä",
        "ar": "سامارا ، روسيا"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Seychelles",
        "ko": "세이셸",
        "sc": "塞舌尔",
        "es": "Seychelles",
        "ru": "Сейшелы",
        "ja": "セイシェル",
        "fr": "les Seychelles",
        "de": "Seychellen",
        "it": "Seychelles",
        "th": "เซเชลส์",
        "id": "Seychelles",
        "vi": "Seychelles",
        "nl": "Seychellen",
        "pl": "Seszele",
        "nb": "Seychellene",
        "fi": "Seychellit",
        "ar": "سيشيل"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "Ulyanovsk, Russia",
        "ko": "울리야놉스크, 러시아",
        "sc": "俄罗斯乌里扬诺夫斯克",
        "es": "Uliánovsk, Rusia",
        "ru": "Ульяновск, Россия",
        "ja": "ウリヤノフスク、ロシア",
        "fr": "Oulianovsk, Russie",
        "de": "Uljanowsk, Russland",
        "it": "Ulyanovsk, Russia",
        "th": "อุลยานอฟสค์ รัสเซีย",
        "id": "Ulyanovsk, Rusia",
        "vi": "Ulyanovsk, Nga",
        "nl": "Oeljanovsk, Rusland",
        "pl": "Uljanowsk, Rosja",
        "nb": "Ulyanovsk, Russland",
        "fi": "Uljanovski, Venäjä",
        "ar": "أوليانوفسك ، روسيا"
    },
    {
        "value": 400,
        "prefix": "(GMT+04:00)",
        "en": "United Arab Emirates",
        "ko": "아랍 에미리트",
        "sc": "阿拉伯联合酋长国",
        "es": "Emiratos Árabes Unidos",
        "ru": "Объединенные Арабские Эмираты",
        "ja": "アラブ首長国連邦",
        "fr": "Emirats Arabes Unis",
        "de": "Vereinigte Arabische Emirate",
        "it": "Emirati Arabi Uniti",
        "th": "สหรัฐอาหรับเอมิเรตส์",
        "id": "Uni Emirat Arab",
        "vi": "các Tiểu Vương Quốc Ả Rập Thống Nhất",
        "nl": "Verenigde Arabische Emiraten",
        "pl": "Zjednoczone Emiraty Arabskie",
        "nb": "De forente arabiske emirater",
        "fi": "Yhdistyneet Arabiemiirikunnat",
        "ar": "الإمارات العربية المتحدة"
    },
    {
        "value": 430,
        "prefix": "(GMT+04:30)",
        "en": "Afghanistan",
        "ko": "아프가니스탄",
        "sc": "阿富汗",
        "es": "Afganistán",
        "ru": "Афганистан",
        "ja": "アフガニスタン",
        "fr": "Afghanistan",
        "de": "Afghanistan",
        "it": "Afghanistan",
        "th": "อัฟกานิสถาน",
        "id": "Afganistan",
        "vi": "Afghanistan",
        "nl": "Afghanistan",
        "pl": "Afganistan",
        "nb": "Afghanistan",
        "fi": "Afganistan",
        "ar": "أفغانستان"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Chelyabinsk, Russia",
        "ko": "첼랴빈스크, 러시아",
        "sc": "俄罗斯车里雅宾斯克",
        "es": "Cheliábinsk, Rusia",
        "ru": "Челябинск, Россия",
        "ja": "チェリャビンスク、ロシア",
        "fr": "Tcheliabinsk, Russie",
        "de": "Tscheljabinsk, Russland",
        "it": "Chelyabinsk, Russia",
        "th": "เชเลียบินสค์ รัสเซีย",
        "id": "Chelyabinsk, Rusia",
        "vi": "Chelyabinsk, Nga",
        "nl": "Tsjeljabinsk, Rusland",
        "pl": "Czelabińsk, Rosja",
        "nb": "Chelyabinsk, Russland",
        "fi": "Tšeljabinsk, Venäjä",
        "ar": "تشيليابينسك ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Kazakhstan, western part",
        "ko": "카자흐스탄, 서부",
        "sc": "哈萨克斯坦，西部",
        "es": "Kazajstán, parte occidental",
        "ru": "Казахстан, западная часть",
        "ja": "カザフスタン、西部",
        "fr": "Kazakhstan, partie ouest",
        "de": "Kasachstan, westlicher Teil",
        "it": "Kazakistan, parte occidentale",
        "th": "คาซัคสถาน ทางตะวันตก",
        "id": "Kazakstan, bagian barat",
        "vi": "Kazakhstan, phần phía tây",
        "nl": "Kazachstan, westelijk deel",
        "pl": "Kazachstan, część zachodnia",
        "nb": "Kasakhstan, den vestlige delen",
        "fi": "Kazakstan, länsiosa",
        "ar": "كازاخستان الجزء الغربي"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Kerguelen Islands",
        "ko": "케르겔렌 제도",
        "sc": "凯尔盖朗群岛",
        "es": "Islas Kerguelén",
        "ru": "Острова Кергелен",
        "ja": "ケルゲレン諸島",
        "fr": "Îles Kerguelen",
        "de": "Kerguelen-Inseln",
        "it": "Isole Kerguelen",
        "th": "หมู่เกาะ Kerguelen",
        "id": "Kepulauan Kerguelen",
        "vi": "Quần đảo Kerguelen",
        "nl": "Kerguelen-eilanden",
        "pl": "Wyspy Kerguelena",
        "nb": "Kerguelen-øyene",
        "fi": "Kerguelenin saaret",
        "ar": "جزر كيرغولين"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Khanty-Mansiysk, Russia",
        "ko": "한티만시스크, 러시아",
        "sc": "俄罗斯汉特-曼西斯克",
        "es": "Khanty-Mansiysk, Rusia",
        "ru": "Ханты-Мансийск, Россия",
        "ja": "ハンティ・マンシースク、ロシア",
        "fr": "Khanty-Mansiysk, Russie",
        "de": "Chanty-Mansijsk, Russland",
        "it": "Khanty-Mansijsk, Russia",
        "th": "Khanty-Mansiysk รัสเซีย",
        "id": "Khanty-Mansiysk, Rusia",
        "vi": "Khanty-Mansiysk, Nga",
        "nl": "Khanty-Mansiysk, Rusland",
        "pl": "Chanty-Mansyjsk, Rosja",
        "nb": "Khanty-Mansiysk, Russland",
        "fi": "Hanti-Mansiysk, Venäjä",
        "ar": "خانتي مانسيسك ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Kurgan, Russia",
        "ko": "쿠르간, 러시아",
        "sc": "俄罗斯库尔干",
        "es": "Kurgán, Rusia",
        "ru": "Курган, Россия",
        "ja": "クルガン、ロシア",
        "fr": "Kourgane, Russie",
        "de": "Kurgan, Russland",
        "it": "Kurgan, Russia",
        "th": "Kurgan, รัสเซีย",
        "id": "Kurgan, Rusia",
        "vi": "Kurgan, Nga",
        "nl": "Koergan, Rusland",
        "pl": "Kurgan, Rosja",
        "nb": "Kurgan, Russland",
        "fi": "Kurgan, Venäjä",
        "ar": "كورغان ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Maldives",
        "ko": "몰디브",
        "sc": "马尔代夫",
        "es": "Maldivas",
        "ru": "Мальдивы",
        "ja": "モルディブ",
        "fr": "Maldives",
        "de": "Malediven",
        "it": "Maldive",
        "th": "มัลดีฟส์",
        "id": "Maladewa",
        "vi": "Maldives",
        "nl": "Maldiven",
        "pl": "Malediwy",
        "nb": "Maldivene",
        "fi": "Malediivit",
        "ar": "جزر المالديف"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Orenburg, Russia",
        "ko": "오렌부르크, 러시아",
        "sc": "俄罗斯奥伦堡",
        "es": "Oremburgo, Rusia",
        "ru": "Оренбург, Россия",
        "ja": "オレンブルク、ロシア",
        "fr": "Orenbourg, Russie",
        "de": "Orenburg, Russland",
        "it": "Orenburg, Russia",
        "th": "โอเรนบุร์ก, รัสเซีย",
        "id": "Orenburg, Rusia",
        "vi": "Orenburg, Nga",
        "nl": "Orenburg, Rusland",
        "pl": "Orenburg, Rosja",
        "nb": "Orenburg, Russland",
        "fi": "Orenburg, Venäjä",
        "ar": "أورينبورغ ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Pakistan",
        "ko": "파키스탄",
        "sc": "巴基斯坦",
        "es": "Pakistán",
        "ru": "Пакистан",
        "ja": "パキスタン",
        "fr": "Pakistan",
        "de": "Pakistan",
        "it": "Pakistan",
        "th": "ปากีสถาน",
        "id": "pakistan",
        "vi": "Pakistan",
        "nl": "Pakistan",
        "pl": "Pakistan",
        "nb": "Pakistan",
        "fi": "Pakistan",
        "ar": "باكستان"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Perm, Russia",
        "ko": "페름, 러시아",
        "sc": "俄罗斯彼尔姆",
        "es": "Perm, Rusia",
        "ru": "Пермь, Россия",
        "ja": "ペルミ、ロシア",
        "fr": "Perm, Russie",
        "de": "Perm, Russland",
        "it": "Perm, Russia",
        "th": "เปียร์ม รัสเซีย",
        "id": "Perm, Rusia",
        "vi": "Perm, Nga",
        "nl": "Perm, Rusland",
        "pl": "Perm, Rosja",
        "nb": "Perm, Russland",
        "fi": "Perm, Venäjä",
        "ar": "بيرم ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Salekhard, Russia",
        "ko": "살레하르트, 러시아",
        "sc": "俄罗斯萨列哈德",
        "es": "Salejard, Rusia",
        "ru": "Салехард, Россия",
        "ja": "サレハルト、ロシア",
        "fr": "Salekhard, Russie",
        "de": "Salechard, Russland",
        "it": "Salekhard, Russia",
        "th": "Salekhard รัสเซีย",
        "id": "Salehard, Rusia",
        "vi": "Salekhard, Nga",
        "nl": "Salechard, Rusland",
        "pl": "Salechard, Rosja",
        "nb": "Salekhard, Russland",
        "fi": "Salekhard, Venäjä",
        "ar": "سالخارد ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Tajikistan",
        "ko": "타지키스탄",
        "sc": "塔吉克斯坦",
        "es": "Tayikistán",
        "ru": "Таджикистан",
        "ja": "タジキスタン",
        "fr": "Tadjikistan",
        "de": "Tadschikistan",
        "it": "Tagikistan",
        "th": "ทาจิกิสถาน",
        "id": "Tajikistan",
        "vi": "Tajikistan",
        "nl": "Tadzjikistan",
        "pl": "Tadżykistan",
        "nb": "Tadsjikistan",
        "fi": "Tadžikistan",
        "ar": "طاجيكستان"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Turkmenistan",
        "ko": "투르크메니스탄",
        "sc": "土库曼斯坦",
        "es": "turkmenistán",
        "ru": "Туркменистан",
        "ja": "トルクメニスタン",
        "fr": "Turkménistan",
        "de": "Turkmenistan",
        "it": "Turkmenistan",
        "th": "เติร์กเมนิสถาน",
        "id": "Turkmenistan",
        "vi": "Turkmenistan",
        "nl": "Turkmenistan",
        "pl": "Turkmenia",
        "nb": "Turkmenistan",
        "fi": "Turkmenistan",
        "ar": "تركمانستان"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Tyumen, Russia",
        "ko": "튜멘, 러시아",
        "sc": "俄罗斯秋明",
        "es": "Tiumén, Rusia",
        "ru": "Тюмень, Россия",
        "ja": "チュメニ、ロシア",
        "fr": "Tioumen, Russie",
        "de": "Tjumen, Russland",
        "it": "Tjumen', Russia",
        "th": "Tyumen, รัสเซีย",
        "id": "Tyumen, Rusia",
        "vi": "Tyumen, Nga",
        "nl": "Tyumen, Rusland",
        "pl": "Tiumeń, Rosja",
        "nb": "Tyumen, Russland",
        "fi": "Tyumen, Venäjä",
        "ar": "تيومين ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Ufa, Russia",
        "ko": "우파, 러시아",
        "sc": "俄罗斯乌法",
        "es": "Ufá, Rusia",
        "ru": "Уфа, Россия",
        "ja": "ウファ、ロシア",
        "fr": "Oufa, Russie",
        "de": "Ufa, Russland",
        "it": "Ufa, Russia",
        "th": "อูฟา รัสเซีย",
        "id": "Ufa, Rusia",
        "vi": "Ufa, Nga",
        "nl": "Oefa, Rusland",
        "pl": "Ufa, Rosja",
        "nb": "Ufa, Russland",
        "fi": "Ufa, Venäjä",
        "ar": "أوفا ، روسيا"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Uzbekistan",
        "ko": "우즈베키스탄",
        "sc": "乌兹别克斯坦",
        "es": "Uzbekistán",
        "ru": "Узбекистан",
        "ja": "ウズベキスタン",
        "fr": "Ouzbékistan",
        "de": "Usbekistan",
        "it": "Uzbekistan",
        "th": "อุซเบกิสถาน",
        "id": "Uzbekistan",
        "vi": "U-dơ-bê-ki-xtan",
        "nl": "Oezbekistan",
        "pl": "Uzbekistan",
        "nb": "Usbekistan",
        "fi": "Uzbekistan",
        "ar": "أوزبكستان"
    },
    {
        "value": 500,
        "prefix": "(GMT+05:00)",
        "en": "Yekaterinburg, Russia",
        "ko": "예카테린부르크, 러시아",
        "sc": "俄罗斯叶卡捷琳堡",
        "es": "Ekaterimburgo, Rusia",
        "ru": "Екатеринбург, Россия",
        "ja": "エカテリンブルク、ロシア",
        "fr": "Iekaterinbourg, Russie",
        "de": "Jekaterinburg, Russland",
        "it": "Ekaterinburg, Russia",
        "th": "เยคาเตรินเบิร์ก รัสเซีย",
        "id": "Yekaterinburg, Rusia",
        "vi": "Yekaterinburg, Nga",
        "nl": "Jekaterinenburg, Rusland",
        "pl": "Jekaterynburg, Rosja",
        "nb": "Jekaterinburg, Russland",
        "fi": "Jekaterinburg, Venäjä",
        "ar": "يكاترينبورغ ، روسيا"
    },
    {
        "value": 530,
        "prefix": "(GMT+05:30)",
        "en": "India",
        "ko": "인도",
        "sc": "印度",
        "es": "India",
        "ru": "Индия",
        "ja": "インド",
        "fr": "Inde",
        "de": "Indien",
        "it": "India",
        "th": "อินเดีย",
        "id": "India",
        "vi": "Ấn Độ",
        "nl": "India",
        "pl": "Indie",
        "nb": "India",
        "fi": "Intia",
        "ar": "الهند"
    },
    {
        "value": 530,
        "prefix": "(GMT+05:30)",
        "en": "Sri Lanka",
        "ko": "스리랑카",
        "sc": "斯里兰卡",
        "es": "Sri Lanka",
        "ru": "Шри-Ланка",
        "ja": "スリランカ",
        "fr": "Sri Lanka",
        "de": "Sri Lanka",
        "it": "Sri Lanka",
        "th": "ศรีลังกา",
        "id": "Srilanka",
        "vi": "Sri Lanka",
        "nl": "Sri Lanka",
        "pl": "Sri Lanka",
        "nb": "Sri Lanka",
        "fi": "Sri Lanka",
        "ar": "سيريلانكا"
    },
    {
        "value": 600,
        "prefix": "(GMT+06:00)",
        "en": "Bangladesh",
        "ko": "방글라데시",
        "sc": "孟加拉国",
        "es": "Bangladesh",
        "ru": "Бангладеш",
        "ja": "バングラデシュ",
        "fr": "Bengladesh",
        "de": "Bangladesch",
        "it": "Bangladesh",
        "th": "บังคลาเทศ",
        "id": "Bangladesh",
        "vi": "Bangladesh",
        "nl": "Bangladesh",
        "pl": "Bangladesz",
        "nb": "Bangladesh",
        "fi": "Bangladesh",
        "ar": "بنغلاديش"
    },
    {
        "value": 600,
        "prefix": "(GMT+06:00)",
        "en": "Bhutan",
        "ko": "부탄",
        "sc": "不丹",
        "es": "Bután",
        "ru": "Бутан",
        "ja": "ブータン",
        "fr": "Bhoutan",
        "de": "Bhutan",
        "it": "Bhutan",
        "th": "ภูฏาน",
        "id": "Bhutan",
        "vi": "Bhutan",
        "nl": "Bhutan",
        "pl": "Bhutan",
        "nb": "Bhutan",
        "fi": "Bhutan",
        "ar": "بوتان"
    },
    {
        "value": 600,
        "prefix": "(GMT+06:00)",
        "en": "British Indian Ocean Territory",
        "ko": "영국령 인도양 영토",
        "sc": "英属印度洋领地",
        "es": "Territorio Británico del Océano Índico",
        "ru": "Британская территория Индийского океана",
        "ja": "イギリス領インド洋地域",
        "fr": "Territoire britannique de l'océan Indien",
        "de": "Britisches Territorium des Indischen Ozeans",
        "it": "Territorio britannico dell'Oceano Indiano",
        "th": "บริติชอินเดียนโอเชียนเทร์ริทอรี",
        "id": "Wilayah Samudra Hindia Britania",
        "vi": "Lãnh thổ Ấn Độ Dương thuộc Anh",
        "nl": "Brits-Indisch oceaan gebied",
        "pl": "Brytyjskie Terytorium Oceanu Indyjskiego",
        "nb": "Britisk territorium i det indiske hav",
        "fi": "Brittiläinen Intian valtameren alue",
        "ar": "إقليم المحيط البريطاني الهندي"
    },
    {
        "value": 600,
        "prefix": "(GMT+06:00)",
        "en": "Kazakhstan, eastern part",
        "ko": "카자흐스탄, 동부",
        "sc": "哈萨克斯坦，东部",
        "es": "Kazajstán, parte oriental",
        "ru": "Казахстан, восточная часть",
        "ja": "カザフスタン、東部",
        "fr": "Kazakhstan, partie orientale",
        "de": "Kasachstan, östlicher Teil",
        "it": "Kazakistan, parte orientale",
        "th": "คาซัคสถาน ภาคตะวันออก",
        "id": "Kazakstan, bagian timur",
        "vi": "Kazakhstan, phần phía đông",
        "nl": "Kazachstan, oostelijk deel",
        "pl": "Kazachstan, część wschodnia",
        "nb": "Kasakhstan, østlige del",
        "fi": "Kazakstan, itäosa",
        "ar": "كازاخستان ، الجزء الشرقي"
    },
    {
        "value": 600,
        "prefix": "(GMT+06:00)",
        "en": "Kyrgyzstan",
        "ko": "키르기스스탄",
        "sc": "吉尔吉斯斯坦",
        "es": "Kirguistán",
        "ru": "Кыргызстан",
        "ja": "キルギスタン",
        "fr": "Kirghizistan",
        "de": "Kirgistan",
        "it": "Kirghizistan",
        "th": "คีร์กีซสถาน",
        "id": "Kirgistan",
        "vi": "Kyrgyzstan",
        "nl": "Kirgizië",
        "pl": "Kirgistan",
        "nb": "Kirgisistan",
        "fi": "Kirgisia",
        "ar": "قيرغيزستان"
    },
    {
        "value": 600,
        "prefix": "(GMT+06:00)",
        "en": "Omsk, Russia",
        "ko": "옴스크, 러시아",
        "sc": "俄罗斯鄂木斯克",
        "es": "Omsk, Rusia",
        "ru": "Омск, Россия",
        "ja": "オムスク、ロシア",
        "fr": "Omsk, Russie",
        "de": "Omsk, Russland",
        "it": "Omsk, Russia",
        "th": "ออมสค์ รัสเซีย",
        "id": "Omsk, Rusia",
        "vi": "Omsk, Nga",
        "nl": "Omsk, Rusland",
        "pl": "Omsk, Rosja",
        "nb": "Omsk, Russland",
        "fi": "Omsk, Venäjä",
        "ar": "أومسك ، روسيا"
    },
    {
        "value": 630,
        "prefix": "(GMT+06:30)",
        "en": "Cocos (Keeling) Islands",
        "ko": "코코스(킬링) 제도",
        "sc": "科科斯（基林）群岛",
        "es": "Islas Cocos (Keeling)",
        "ru": "Кокосовые (Килинг) острова",
        "ja": "ココス（キーリング）諸島",
        "fr": "Îles Cocos (Keeling)",
        "de": "Kokosinseln (Keelinginseln).",
        "it": "Isole Cocos (Keeling).",
        "th": "หมู่เกาะโคโคส (คีลิง)",
        "id": "Kepulauan Cocos (Keeling)",
        "vi": "Quần đảo Cocos (Keeling)",
        "nl": "Cocos (Keeling) Eilanden",
        "pl": "Wyspy Kokosowe (Keelinga)",
        "nb": "Kokosøyene",
        "fi": "Kookossaaret (Keeling).",
        "ar": "جزر كوكوس (كيلينغ)"
    },
    {
        "value": 630,
        "prefix": "(GMT+06:30)",
        "en": "Myanmar",
        "ko": "미얀마",
        "sc": "缅甸",
        "es": "Birmania",
        "ru": "Мьянма",
        "ja": "ミャンマー",
        "fr": "Birmanie",
        "de": "Burma",
        "it": "Birmania",
        "th": "พม่า",
        "id": "Myanmar",
        "vi": "Myanmar",
        "nl": "Myanmar",
        "pl": "Myanmar",
        "nb": "Myanmar",
        "fi": "Myanmar",
        "ar": "ميانمار"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Abakan, Russia",
        "ko": "아바칸, 러시아",
        "sc": "俄罗斯阿巴坎",
        "es": "Abakán, Rusia",
        "ru": "Абакан, Россия",
        "ja": "アバカン、ロシア",
        "fr": "Abakan, Russie",
        "de": "Abakan, Russland",
        "it": "Abakan, Russia",
        "th": "อาบาคาน รัสเซีย",
        "id": "Abakan, Rusia",
        "vi": "Abakan, Nga",
        "nl": "Abakan, Rusland",
        "pl": "Abakan, Rosja",
        "nb": "Abakan, Russland",
        "fi": "Abakan, Venäjä",
        "ar": "أباكان ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Barnaul, Russia",
        "ko": "바르나울, 러시아",
        "sc": "俄罗斯巴尔瑙尔",
        "es": "Barnaúl, Rusia",
        "ru": "Барнаул, Россия",
        "ja": "バルナウル、ロシア",
        "fr": "Barnaoul, Russie",
        "de": "Barnaul, Russland",
        "it": "Barnaul, Russia",
        "th": "บาร์นาอูล รัสเซีย",
        "id": "Barnaul, Rusia",
        "vi": "Barnaul, Nga",
        "nl": "Barnaul, Rusland",
        "pl": "Barnauł, Rosja",
        "nb": "Barnaul, Russland",
        "fi": "Barnaul, Venäjä",
        "ar": "بارناول ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Bayan-Olgii, Mongolia",
        "ko": "바얀올기, 몽골",
        "sc": "蒙古巴彦奥尔盖",
        "es": "Bayan-Olgii, Mongolia",
        "ru": "Баян-Улгий, Монголия",
        "ja": "バヤンウルギー、モンゴル",
        "fr": "Bayan-Olgii, Mongolie",
        "de": "Bayan-Olgii, Mongolei",
        "it": "Bayan-Olgii, Mongolia",
        "th": "บายัน-ออลจิ, มองโกเลีย",
        "id": "Bayan-Olgii, Mongolia",
        "vi": "Bayan-Olgii, Mông Cổ",
        "nl": "Bayan-Olgii, Mongolië",
        "pl": "Bayan-Olgii, Mongolia",
        "nb": "Bayan-Olgii, Mongolia",
        "fi": "Bayan-Olgii, Mongolia",
        "ar": "بيان أولجي ، منغوليا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Cambodia",
        "ko": "캄보디아",
        "sc": "柬埔寨",
        "es": "Camboya",
        "ru": "Камбоджа",
        "ja": "カンボジア",
        "fr": "Cambodge",
        "de": "Kambodscha",
        "it": "Cambogia",
        "th": "กัมพูชา",
        "id": "Kamboja",
        "vi": "Campuchia",
        "nl": "Cambodja",
        "pl": "Kambodża",
        "nb": "Kambodsja",
        "fi": "Kambodža",
        "ar": "كمبوديا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Central Kalimantan, Indonesia",
        "ko": "인도네시아 중부 칼리만탄",
        "sc": "印度尼西亚中加里曼丹",
        "es": "Kalimantán central, Indonesia",
        "ru": "Центральный Калимантан, Индонезия",
        "ja": "インドネシア中部カリマンタン",
        "fr": "Kalimantan central, Indonésie",
        "de": "Zentralkalimantan, Indonesien",
        "it": "Kalimantan centrale, Indonesia",
        "th": "กาลิมันตันกลาง อินโดนีเซีย",
        "id": "Kalimantan Tengah, Indonesia",
        "vi": "Trung tâm Kalimantan, Indonesia",
        "nl": "Centraal Kalimantan, Indonesië",
        "pl": "Środkowy Kalimantan, Indonezja",
        "nb": "Sentral-Kalimantan, Indonesia",
        "fi": "Keski-Kalimantan, Indonesia",
        "ar": "كاليمانتان الوسطى ، إندونيسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Christmas Island",
        "ko": "크리스마스 섬",
        "sc": "圣诞岛",
        "es": "Isla de Navidad",
        "ru": "Остров Рождества",
        "ja": "クリスマス島",
        "fr": "L'île de noël",
        "de": "Weihnachtsinsel",
        "it": "Isola di Natale",
        "th": "เกาะคริสต์มาส",
        "id": "Pulau Natal",
        "vi": "Đảo giáng sinh",
        "nl": "Kersteiland",
        "pl": "Wyspa Bożego Narodzenia",
        "nb": "Juleøya",
        "fi": "Joulusaari",
        "ar": "جزيرة الكريسماس"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Gorno-Altaysk, Russia",
        "ko": "러시아 고르노 알타이스크",
        "sc": "俄罗斯戈尔诺-阿尔泰",
        "es": "Gorno-Altaisk, Rusia",
        "ru": "Горно-Алтайск, Россия",
        "ja": "ゴルノアルタイスク、ロシア",
        "fr": "Gorno-Altaïsk, Russie",
        "de": "Gorno-Altaisk, Russland",
        "it": "Gorno-Altajsk, Russia",
        "th": "กอร์โน-อัลไตสค์ รัสเซีย",
        "id": "Gorno-Altaysk, Rusia",
        "vi": "Gorno-Altaysk, Nga",
        "nl": "Gorno-Altajsk, Rusland",
        "pl": "Gornoałtajsk, Rosja",
        "nb": "Gorno-Altaysk, Russland",
        "fi": "Gorno-Altaysk, Venäjä",
        "ar": "جورنو ألتايسك ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Java Island, Indonesia",
        "ko": "자바 섬, 인도네시아",
        "sc": "印度尼西亚爪哇岛",
        "es": "Isla de Java, Indonesia",
        "ru": "Остров Ява, Индонезия",
        "ja": "ジャワ島、インドネシア",
        "fr": "Île de Java, Indonésie",
        "de": "Insel Java, Indonesien",
        "it": "Isola di Giava, Indonesia",
        "th": "เกาะชวา อินโดนีเซีย",
        "id": "Pulau Jawa, Indonesia",
        "vi": "Đảo Java, Indonesia",
        "nl": "Java-eiland, Indonesië",
        "pl": "Wyspa Jawa, Indonezja",
        "nb": "Java Island, Indonesia",
        "fi": "Java Island, Indonesia",
        "ar": "جزيرة جافا ، إندونيسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Kemerovo, Russia",
        "ko": "케메로보, 러시아",
        "sc": "俄罗斯克麦罗沃",
        "es": "Kémerovo, Rusia",
        "ru": "Кемерово, Россия",
        "ja": "ケメロヴォ、ロシア",
        "fr": "Kemerovo, Russie",
        "de": "Kemerowo, Russland",
        "it": "Kemerovo, Russia",
        "th": "เคเมโรโว รัสเซีย",
        "id": "Kemerovo, Rusia",
        "vi": "Kemerovo, Nga",
        "nl": "Kemerovo, Rusland",
        "pl": "Kemerowo, Rosja",
        "nb": "Kemerovo, Russland",
        "fi": "Kemerovo, Venäjä",
        "ar": "كيميروفو ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Krasnoyarsk, Russia",
        "ko": "크라스노야르스크, 러시아",
        "sc": "俄罗斯克拉斯诺亚尔斯克",
        "es": "Krasnoyarsk, Rusia",
        "ru": "Красноярск, Россия",
        "ja": "クラスノヤルスク、ロシア",
        "fr": "Krasnoïarsk, Russie",
        "de": "Krasnojarsk, Russland",
        "it": "Krasnojarsk, Russia",
        "th": "ครัสโนยาสค์ รัสเซีย",
        "id": "Krasnoyarsk, Rusia",
        "vi": "Krasnoyarsk, Nga",
        "nl": "Krasnojarsk, Rusland",
        "pl": "Krasnojarsk, Rosja",
        "nb": "Krasnoyarsk, Russland",
        "fi": "Krasnojarsk, Venäjä",
        "ar": "كراسنويارسك ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Kyzyl, Russia",
        "ko": "키질, 러시아",
        "sc": "俄罗斯克孜勒",
        "es": "Kyzyl, Rusia",
        "ru": "Кызыл, Россия",
        "ja": "クズル、ロシア",
        "fr": "Kyzil, Russie",
        "de": "Kysyl, Russland",
        "it": "Kyzyl, Russia",
        "th": "คืยซิล, รัสเซีย",
        "id": "Kyzyl, Rusia",
        "vi": "Kyzyl, Nga",
        "nl": "Kyzyl, Rusland",
        "pl": "Kyzył, Rosja",
        "nb": "Kyzyl, Russland",
        "fi": "Kyzyl, Venäjä",
        "ar": "كيزيل ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Laos",
        "ko": "라오스",
        "sc": "老挝",
        "es": "Laos",
        "ru": "Лаос",
        "ja": "ラオス",
        "fr": "Laos",
        "de": "Laos",
        "it": "Laos",
        "th": "ลาว",
        "id": "Laos",
        "vi": "Nước Lào",
        "nl": "Laos",
        "pl": "Laos",
        "nb": "Laos",
        "fi": "Laos",
        "ar": "لاوس"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Novosibirsk, Russia",
        "ko": "노보시비르스크, 러시아",
        "sc": "俄罗斯新西伯利亚",
        "es": "Novosibirsk, Rusia",
        "ru": "Новосибирск, Россия",
        "ja": "ノボシビルスク、ロシア",
        "fr": "Novossibirsk, Russie",
        "de": "Nowosibirsk, Russland",
        "it": "Novosibirsk, Russia",
        "th": "โนโวซีบีสค์ รัสเซีย",
        "id": "Novosibirsk, Rusia",
        "vi": "Novosibirsk, Nga",
        "nl": "Novosibirsk, Rusland",
        "pl": "Nowosybirsk, Rosja",
        "nb": "Novosibirsk, Russland",
        "fi": "Novosibirsk, Venäjä",
        "ar": "نوفوسيبيرسك ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Provinces of Khovd, Mongolia",
        "ko": "몽골 코브드 지방",
        "sc": "蒙古霍布德省",
        "es": "Provincias de Khovd, Mongolia",
        "ru": "Провинция Ховд, Монголия",
        "ja": "モンゴル、ホブド州",
        "fr": "Provinces de Khovd, Mongolie",
        "de": "Provinzen Khovd, Mongolei",
        "it": "Province di Khovd, Mongolia",
        "th": "จังหวัดของ Khovd มองโกเลีย",
        "id": "Provinsi Khovd, Mongolia",
        "vi": "Các tỉnh Khovd, Mông Cổ",
        "nl": "Provincies van Khovd, Mongolië",
        "pl": "Prowincje Khovd, Mongolia",
        "nb": "Provinsene Khovd, Mongolia",
        "fi": "Khovdin maakunnat, Mongolia",
        "ar": "مقاطعات خوفد ، منغوليا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Sumatra Island, Indonesia",
        "ko": "인도네시아 수마트라 섬",
        "sc": "印度尼西亚苏门答腊岛",
        "es": "Isla de Sumatra, Indonesia",
        "ru": "Остров Суматра, Индонезия",
        "ja": "インドネシア、スマトラ島",
        "fr": "Île de Sumatra, Indonésie",
        "de": "Insel Sumatra, Indonesien",
        "it": "Isola di Sumatra, Indonesia",
        "th": "เกาะสุมาตรา อินโดนีเซีย",
        "id": "Pulau Sumatera, Indonesia",
        "vi": "Đảo Sumatra, Indonesia",
        "nl": "Sumatra, Indonesië",
        "pl": "Sumatra, Indonezja",
        "nb": "Sumatra Island, Indonesia",
        "fi": "Sumatran saari, Indonesia",
        "ar": "جزيرة سومطرة ، إندونيسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Thailand",
        "ko": "태국",
        "sc": "泰国",
        "es": "Tailandia",
        "ru": "Таиланд",
        "ja": "タイ",
        "fr": "Thaïlande",
        "de": "Thailand",
        "it": "Tailandia",
        "th": "ประเทศไทย",
        "id": "Thailand",
        "vi": "nước Thái Lan",
        "nl": "Thailand",
        "pl": "Tajlandia",
        "nb": "Thailand",
        "fi": "Thaimaa",
        "ar": "تايلاند"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Tomsk, Russia",
        "ko": "톰스크, 러시아",
        "sc": "俄罗斯托木斯克",
        "es": "Tomsk, Rusia",
        "ru": "Томск, Россия",
        "ja": "トムスク、ロシア",
        "fr": "Tomsk, Russie",
        "de": "Tomsk, Russland",
        "it": "Tomsk, Russia",
        "th": "ทอมสค์ รัสเซีย",
        "id": "Tomsk, Rusia",
        "vi": "Tomsk, Nga",
        "nl": "Tomsk, Rusland",
        "pl": "Tomsk, Rosja",
        "nb": "Tomsk, Russland",
        "fi": "Tomsk, Venäjä",
        "ar": "تومسك ، روسيا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Uvs, Mongolia",
        "ko": "오브스, 몽골",
        "sc": "乌布苏省, 蒙古",
        "es": "UVS, Mongolia",
        "ru": "Увс, Монголия",
        "ja": "ウブス、モンゴル",
        "fr": "Uvs, Mongolie",
        "de": "Uws-Aimag, Mongolei",
        "it": "Provincia dell'Uvs, Mongolia",
        "th": "จังหวัดอุฟส์, มองโกเลีย",
        "id": "Uvs, Mongolia",
        "vi": "Uvs, Mông Cổ",
        "nl": "Uvs, Mongolië",
        "pl": "Ajmak uwski, Mongolia",
        "nb": "Uvs, Mongolia",
        "fi": "Uvs, Mongolia",
        "ar": "Uvs ، منغوليا"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "Vietnam",
        "ko": "베트남",
        "sc": "越南",
        "es": "Vietnam",
        "ru": "Вьетнам",
        "ja": "ベトナム",
        "fr": "Viêt Nam",
        "de": "Vietnam",
        "it": "Vietnam",
        "th": "เวียดนาม",
        "id": "Vietnam",
        "vi": "Việt Nam",
        "nl": "Vietnam",
        "pl": "Wietnam",
        "nb": "Vietnam",
        "fi": "Vietnam",
        "ar": "فيتنام"
    },
    {
        "value": 700,
        "prefix": "(GMT+07:00)",
        "en": "West Kalimantan, Indonesia",
        "ko": "인도네시아 서부 칼리만탄",
        "sc": "印度尼西亚西加里曼丹",
        "es": "Borneo Occidental, Indonesia",
        "ru": "Западный Калимантан, Индонезия",
        "ja": "インドネシア、西カリマンタン",
        "fr": "Kalimantan occidental, Indonésie",
        "de": "Westkalimantan, Indonesien",
        "it": "Kalimantan occidentale, Indonesia",
        "th": "กาลิมันตันตะวันตก อินโดนีเซีย",
        "id": "Kalimantan Barat, Indonesia",
        "vi": "Tây Kalimantan, Indonesia",
        "nl": "West Kalimantan, Indonesië",
        "pl": "Zachodni Kalimantan, Indonezja",
        "nb": "Vest-Kalimantan, Indonesia",
        "fi": "Länsi-Kalimantan, Indonesia",
        "ar": "كاليمانتان الغربية ، إندونيسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Brunei",
        "ko": "브루나이",
        "sc": "文莱",
        "es": "Brunéi",
        "ru": "Бруней",
        "ja": "ブルネイ",
        "fr": "Brunéi",
        "de": "Brunei",
        "it": "Brunei",
        "th": "บรูไน",
        "id": "brunei",
        "vi": "Brunei",
        "nl": "Brunei",
        "pl": "Brunei",
        "nb": "Brunei",
        "fi": "Brunei",
        "ar": "بروناي"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "China",
        "ko": "중국",
        "sc": "中国",
        "es": "República Popular China",
        "ru": "Китай",
        "ja": "中国",
        "fr": "Chine",
        "de": "China",
        "it": "Cina",
        "th": "จีน",
        "id": "Cina",
        "vi": "Trung Quốc",
        "nl": "China",
        "pl": "Chiny",
        "nb": "Kina",
        "fi": "Kiina",
        "ar": "الصين"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "East Kalimantan, Indonesia",
        "ko": "인도네시아 동부 칼리만탄",
        "sc": "印度尼西亚东加里曼丹",
        "es": "Borneo Oriental, Indonesia",
        "ru": "Восточный Калимантан, Индонезия",
        "ja": "東カリマンタン、インドネシア",
        "fr": "Kalimantan oriental, Indonésie",
        "de": "Ostkalimantan, Indonesien",
        "it": "Kalimantan orientale, Indonesia",
        "th": "กาลิมันตันตะวันออก อินโดนีเซีย",
        "id": "Kalimantan Timur, Indonesia",
        "vi": "Đông Kalimantan, Indonesia",
        "nl": "Oost-Kalimantan, Indonesië",
        "pl": "Wschodni Kalimantan, Indonezja",
        "nb": "Øst-Kalimantan, Indonesia",
        "fi": "Itä-Kalimantan, Indonesia",
        "ar": "كاليمانتان الشرقية ، إندونيسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Hong Kong",
        "ko": "홍콩",
        "sc": "香港",
        "es": "Hong Kong",
        "ru": "Гонконг",
        "ja": "香港",
        "fr": "Hong Kong",
        "de": "Hongkong",
        "it": "Hong Kong",
        "th": "ฮ่องกง",
        "id": "Hongkong",
        "vi": "Hồng Kông",
        "nl": "Hongkong",
        "pl": "Hongkong",
        "nb": "Hong Kong",
        "fi": "Hong Kong",
        "ar": "هونج كونج"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Irkutsk, Russia",
        "ko": "이르쿠츠크, 러시아",
        "sc": "俄罗斯伊尔库茨克",
        "es": "Irkutsk, Rusia",
        "ru": "Иркутск, Россия",
        "ja": "イルクーツク、ロシア",
        "fr": "Irkoutsk, Russie",
        "de": "Irkutsk, Russland",
        "it": "Irkutsk, Russia",
        "th": "อีร์คุตสค์ รัสเซีย",
        "id": "Irkutsk, Rusia",
        "vi": "Irkutsk, Nga",
        "nl": "Irkoetsk, Rusland",
        "pl": "Irkuck, Rosja",
        "nb": "Irkutsk, Russland",
        "fi": "Irkutsk, Venäjä",
        "ar": "إيركوتسك ، روسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Lesser Sunda Islands, Indonesia",
        "ko": "인도네시아 소순다 제도",
        "sc": "印度尼西亚小巽他群岛",
        "es": "Islas menores de la Sonda, Indonesia",
        "ru": "Малые Зондские острова, Индонезия",
        "ja": "小スンダ列島、インドネシア",
        "fr": "Petites îles de la Sonde, Indonésie",
        "de": "Kleine Sunda-Inseln, Indonesien",
        "it": "Piccole Isole della Sonda, Indonesia",
        "th": "หมู่เกาะเลสเซอร์ซุนดา อินโดนีเซีย",
        "id": "Kepulauan Sunda Kecil, Indonesia",
        "vi": "Quần đảo Sunda Nhỏ, Indonesia",
        "nl": "Kleine Soenda-eilanden, Indonesië",
        "pl": "Małe Wyspy Sundajskie, Indonezja",
        "nb": "De mindre Sundaøyene, Indonesia",
        "fi": "Pienet Sundan saaret, Indonesia",
        "ar": "جزر سوندا الصغرى ، إندونيسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Macau",
        "ko": "마카오",
        "sc": "澳门",
        "es": "Macao",
        "ru": "Макао",
        "ja": "マカオ",
        "fr": "Macao",
        "de": "Macau",
        "it": "Macao",
        "th": "มาเก๊า",
        "id": "Makau",
        "vi": "Ma Cao",
        "nl": "Macau",
        "pl": "Makau",
        "nb": "Macau",
        "fi": "Macao",
        "ar": "ماكاو"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Malaysia",
        "ko": "말레이시아",
        "sc": "马来西亚",
        "es": "Malasia",
        "ru": "Малайзия",
        "ja": "マレーシア",
        "fr": "Malaisie",
        "de": "Malaysia",
        "it": "Malaysia",
        "th": "มาเลเซีย",
        "id": "Malaysia",
        "vi": "Malaysia",
        "nl": "Maleisië",
        "pl": "Malezja",
        "nb": "Malaysia",
        "fi": "Malesia",
        "ar": "ماليزيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Mongolia, most of",
        "ko": "대부분의 몽골",
        "sc": "蒙古，大部分",
        "es": "Mongolia, la mayor parte",
        "ru": "Монголия, большая часть",
        "ja": "モンゴル、ほとんど",
        "fr": "Mongolie, la plupart",
        "de": "Mongolei, die meisten",
        "it": "Mongolia, la maggior parte",
        "th": "มองโกเลีย ส่วนใหญ่",
        "id": "Mongolia, sebagian besar",
        "vi": "Mông Cổ, hầu hết",
        "nl": "Mongolië, de meeste",
        "pl": "Mongolia, większość",
        "nb": "Mongolia, de fleste",
        "fi": "Mongolia, suurin osa",
        "ar": "منغوليا ، معظم"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "North Kalimantan, Indonesia",
        "ko": "인도네시아 북부 칼리만탄",
        "sc": "印度尼西亚北加里曼丹",
        "es": "Kalimantán del Norte, Indonesia",
        "ru": "Северный Калимантан, Индонезия",
        "ja": "北カリマンタン、インドネシア",
        "fr": "Kalimantan du Nord, Indonésie",
        "de": "Nordkalimantan, Indonesien",
        "it": "Kalimantan settentrionale, Indonesia",
        "th": "กาลิมันตันเหนือ อินโดนีเซีย",
        "id": "Kalimantan Utara, Indonesia",
        "vi": "Bắc Kalimantan, Indonesia",
        "nl": "Noord Kalimantan, Indonesië",
        "pl": "Północny Kalimantan, Indonezja",
        "nb": "Nord-Kalimantan, Indonesia",
        "fi": "Pohjois-Kalimantan, Indonesia",
        "ar": "كاليمانتان الشمالية ، إندونيسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Philippines",
        "ko": "필리핀 제도",
        "sc": "菲律宾",
        "es": "Filipinas",
        "ru": "Филиппины",
        "ja": "フィリピン",
        "fr": "Philippines",
        "de": "Philippinen",
        "it": "Filippine",
        "th": "ฟิลิปปินส์",
        "id": "Filipina",
        "vi": "Phi-líp-pin",
        "nl": "Filippijnen",
        "pl": "Filipiny",
        "nb": "Filippinene",
        "fi": "Filippiinit",
        "ar": "فيلبيني"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Singapore",
        "ko": "싱가포르",
        "sc": "新加坡",
        "es": "Singapur",
        "ru": "Сингапур",
        "ja": "シンガポール",
        "fr": "Singapour",
        "de": "Singapur",
        "it": "Singapore",
        "th": "สิงคโปร์",
        "id": "Singapura",
        "vi": "Singapore",
        "nl": "Singapore",
        "pl": "Singapur",
        "nb": "Singapore",
        "fi": "Singapore",
        "ar": "سنغافورة"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "South Kalimantan, Indonesia",
        "ko": "인도네시아 남부 칼리만탄",
        "sc": "印度尼西亚南加里曼丹",
        "es": "Borneo Meridional, Indonesia",
        "ru": "Южный Калимантан, Индонезия",
        "ja": "南カリマンタン、インドネシア",
        "fr": "Kalimantan du Sud, Indonésie",
        "de": "Süd-Kalimantan, Indonesien",
        "it": "Kalimantan meridionale, Indonesia",
        "th": "กาลิมันตันใต้ อินโดนีเซีย",
        "id": "Kalimantan Selatan, Indonesia",
        "vi": "Nam Kalimantan, Indonesia",
        "nl": "Zuid-Kalimantan, Indonesië",
        "pl": "Południowy Kalimantan, Indonezja",
        "nb": "Sør-Kalimantan, Indonesia",
        "fi": "Etelä-Kalimantan, Indonesia",
        "ar": "كاليمانتان الجنوبية ، إندونيسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Sulawesi Island, Indonesia",
        "ko": "인도네시아 술라웨시 섬",
        "sc": "印度尼西亚苏拉威西岛",
        "es": "Isla de Sulawesi, Indonesia",
        "ru": "Остров Сулавеси, Индонезия",
        "ja": "スラウェシ島、インドネシア",
        "fr": "Île de Sulawesi, Indonésie",
        "de": "Insel Sulawesi, Indonesien",
        "it": "Isola di Sulawesi, Indonesia",
        "th": "เกาะสุลาเวสี อินโดนีเซีย",
        "id": "Pulau Sulawesi, Indonesia",
        "vi": "Đảo Sulawesi, Indonesia",
        "nl": "Sulawesi, Indonesië",
        "pl": "Wyspa Sulawesi, Indonezja",
        "nb": "Sulawesi Island, Indonesia",
        "fi": "Sulawesin saari, Indonesia",
        "ar": "جزيرة سولاويزي ، إندونيسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Taiwan",
        "ko": "대만",
        "sc": "台湾",
        "es": "Taiwán",
        "ru": "Тайвань",
        "ja": "台湾",
        "fr": "Taïwan",
        "de": "Taiwan",
        "it": "Taiwan",
        "th": "ไต้หวัน",
        "id": "Taiwan",
        "vi": "Đài loan",
        "nl": "Taiwan",
        "pl": "Tajwan",
        "nb": "Taiwan",
        "fi": "Taiwan",
        "ar": "تايوان"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Ulan-Ude, Russia",
        "ko": "울란우데, 러시아",
        "sc": "俄罗斯乌兰乌德",
        "es": "Ulan-Ude, Rusia",
        "ru": "Улан-Удэ, Россия",
        "ja": "ウランウデ、ロシア",
        "fr": "Oulan-Oude, Russie",
        "de": "Ulan-Ude, Russland",
        "it": "Ulan-Ude, Russia",
        "th": "อูลาน-อูเด รัสเซีย",
        "id": "Ulan-Ude, Rusia",
        "vi": "Ulan-Ude, Nga",
        "nl": "Oelan-Oede, Rusland",
        "pl": "Ułan-Ude, Rosja",
        "nb": "Ulan-Ude, Russland",
        "fi": "Ulan-Ude, Venäjä",
        "ar": "أولان أودي ، روسيا"
    },
    {
        "value": 800,
        "prefix": "(GMT+08:00)",
        "en": "Western Australia, Australia ",
        "ko": "웨스턴 오스트레일리아주, 호주",
        "sc": "澳大利亚西澳大利亚州",
        "es": "Australia Occidental, Australia",
        "ru": "Западная Австралия, Австралия",
        "ja": "西オーストラリア、オーストラリア",
        "fr": "Australie-Occidentale, Australie",
        "de": "Westaustralien, Australien",
        "it": "Australia occidentale, Australia",
        "th": "เวสเทิร์นออสเตรเลีย, ออสเตรเลีย",
        "id": "Australia Barat, Australia",
        "vi": "Tây Úc, Úc",
        "nl": "West-Australië, Australië",
        "pl": "Australia Zachodnia, Australia",
        "nb": "Vest-Australia, Australia",
        "fi": "Länsi-Australia, Australia",
        "ar": "أستراليا الغربية ، أستراليا"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Blagoveshchensk, Russia",
        "ko": "블라고베셴스크, 러시아",
        "sc": "俄罗斯布拉戈维申斯克",
        "es": "Blagovéshchensk, Rusia",
        "ru": "Благовещенск, Россия",
        "ja": "ブラゴヴェシチェンスク、ロシア",
        "fr": "Blagovechtchensk, Russie",
        "de": "Blagoweschtschensk, Russland",
        "it": "Blagoveshchensk, Russia",
        "th": "บลาโกเวชเชนสค์ รัสเซีย",
        "id": "Blagoveshchensk, Rusia",
        "vi": "Blagoveshchensk, Nga",
        "nl": "Blagovesjtsjensk, Rusland",
        "pl": "Błagowieszczeńsk, Rosja",
        "nb": "Blagoveshchensk, Russland",
        "fi": "Blagoveshchensk, Venäjä",
        "ar": "بلاغوفيشتشينسك ، روسيا"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Chita, Russia",
        "ko": "치타, 러시아",
        "sc": "俄罗斯赤塔",
        "es": "Chitá, Rusia",
        "ru": "Чита, Россия",
        "ja": "チタ、ロシア",
        "fr": "Tchita, Russie",
        "de": "Chita, Russland",
        "it": "Chita, Russia",
        "th": "ชิตา รัสเซีย",
        "id": "Chita, Rusia",
        "vi": "Chita, Nga",
        "nl": "Tsjita, Rusland",
        "pl": "Czyta, Rosja",
        "nb": "Chita, Russland",
        "fi": "Chita, Venäjä",
        "ar": "شيتا ، روسيا"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Japan",
        "ko": "일본",
        "sc": "日本",
        "es": "Japón",
        "ru": "Япония",
        "ja": "日本",
        "fr": "Japon",
        "de": "Japan",
        "it": "Giappone",
        "th": "ญี่ปุ่น",
        "id": "Jepang",
        "vi": "Nhật Bản",
        "nl": "Japan",
        "pl": "Japonia",
        "nb": "Japan",
        "fi": "Japani",
        "ar": "اليابان"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Maluku Islands, Indonesia",
        "ko": "말루쿠 제도, 인도네시아",
        "sc": "印度尼西亚马鲁古群岛",
        "es": "Islas Molucas, Indonesia",
        "ru": "Молуккские острова, Индонезия",
        "ja": "マルク諸島、インドネシア",
        "fr": "Îles Moluques, Indonésie",
        "de": "Maluku-Inseln, Indonesien",
        "it": "Isole Maluku, Indonesia",
        "th": "หมู่เกาะมาลูกู อินโดนีเซีย",
        "id": "Kepulauan Maluku, Indonesia",
        "vi": "Quần đảo Maluku, Indonesia",
        "nl": "Molukken, Indonesië",
        "pl": "Moluki, Indonezja",
        "nb": "Maluku-øyene, Indonesia",
        "fi": "Maluku saaret, Indonesia",
        "ar": "جزر مالوكو ، إندونيسيا"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "North Korea",
        "ko": "북한",
        "sc": "北朝鲜",
        "es": "Corea del Norte",
        "ru": "Северная Корея",
        "ja": "北朝鮮",
        "fr": "Corée du Nord",
        "de": "Nord Korea",
        "it": "Corea del nord",
        "th": "เกาหลีเหนือ",
        "id": "Korea Utara",
        "vi": "Bắc Triều Tiên",
        "nl": "Noord Korea",
        "pl": "Korea Północna",
        "nb": "Nord-Korea",
        "fi": "Pohjois-Korea",
        "ar": "كوريا الشمالية"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Palau",
        "ko": "팔라우",
        "sc": "帕劳",
        "es": "palaos",
        "ru": "Палау",
        "ja": "パラオ",
        "fr": "Palaos",
        "de": "Palau",
        "it": "Palau",
        "th": "ปาเลา",
        "id": "Palau",
        "vi": "Palau",
        "nl": "Palau",
        "pl": "Palau",
        "nb": "Palau",
        "fi": "Palau",
        "ar": "بالاو"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Papua, Indonesia",
        "ko": "파푸아, 인도네시아",
        "sc": "印度尼西亚巴布亚",
        "es": "Papúa, Indonesia",
        "ru": "Папуа, Индонезия",
        "ja": "インドネシア、パプア",
        "fr": "Papouasie, Indonésie",
        "de": "Papua, Indonesien",
        "it": "Papua, Indonesia",
        "th": "ปาปัว อินโดนีเซีย",
        "id": "Papua, Indonesia",
        "vi": "Papua, Indonesia",
        "nl": "Papoea, Indonesië",
        "pl": "Papua, Indonezja",
        "nb": "Papua, Indonesia",
        "fi": "Papua, Indonesia",
        "ar": "بابوا ، إندونيسيا"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "South Korea",
        "ko": "대한민국",
        "sc": "韩国",
        "es": "Corea del Sur",
        "ru": "Южная Корея",
        "ja": "韓国",
        "fr": "Corée du Sud",
        "de": "Südkorea",
        "it": "Corea del Sud",
        "th": "เกาหลีใต้",
        "id": "Korea Selatan",
        "vi": "Nam Triều Tiên",
        "nl": "Zuid-Korea",
        "pl": "Korea Południowa",
        "nb": "Sør-Korea",
        "fi": "Etelä-Korea",
        "ar": "كوريا الجنوبية"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Timor-Leste",
        "ko": "동티모르",
        "sc": "东帝汶",
        "es": "Timor Oriental",
        "ru": "Тимор-Лешти",
        "ja": "東ティモール",
        "fr": "Timor oriental",
        "de": "Timor-Leste",
        "it": "Timor Est",
        "th": "ติมอร์-เลสเต",
        "id": "Timor-Leste",
        "vi": "Đông Timor",
        "nl": "Oost-Timor",
        "pl": "Timor Wschodni",
        "nb": "Øst-Timor",
        "fi": "Itä-Timor",
        "ar": "تيمور ليشتي"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "West Papua, Indonesia",
        "ko": "서파푸아, 인도네시아",
        "sc": "印度尼西亚西巴布亚",
        "es": "Papúa Occidental, Indonesia",
        "ru": "Западное Папуа, Индонезия",
        "ja": "インドネシア、西パプア",
        "fr": "Papouasie occidentale, Indonésie",
        "de": "West Papua, Indonesien",
        "it": "Papua occidentale, Indonesia",
        "th": "ปาปัวตะวันตก อินโดนีเซีย",
        "id": "Papua Barat, Indonesia",
        "vi": "Tây Papua, Indonesia",
        "nl": "West Papoea, Indonesië",
        "pl": "Papua Zachodnia, Indonezja",
        "nb": "Vest-Papua, Indonesia",
        "fi": "Länsi-Papua, Indonesia",
        "ar": "بابوا الغربية ، إندونيسيا"
    },
    {
        "value": 900,
        "prefix": "(GMT+09:00)",
        "en": "Yakutsk, Russia",
        "ko": "러시아 야쿠츠크",
        "sc": "俄罗斯雅库茨克",
        "es": "Yakutsk, Rusia",
        "ru": "Якутск, Россия",
        "ja": "ヤクーツク、ロシア",
        "fr": "Iakoutsk, Russie",
        "de": "Jakutsk, Russland",
        "it": "Jakutsk, Russia",
        "th": "ยาคุตสค์ รัสเซีย",
        "id": "Yakutsk, Rusia",
        "vi": "Yakutsk, Nga",
        "nl": "Jakoetsk, Rusland",
        "pl": "Jakuck, Rosja",
        "nb": "Yakutsk, Russland",
        "fi": "Jakutsk, Venäjä",
        "ar": "ياكوتسك ، روسيا"
    },
    {
        "value": 930,
        "prefix": "(GMT+09:30)",
        "en": "Northern Territory, Australia ",
        "ko": "노던 준주, 호주",
        "sc": "澳大利亚北领地",
        "es": "Territorio del Norte, Australia",
        "ru": "Северная территория, Австралия",
        "ja": "オーストラリア、ノーザンテリトリー",
        "fr": "Territoire du Nord, Australie",
        "de": "Northern Territory, Australien",
        "it": "Territorio del Nord, Australia",
        "th": "นอร์เทิร์นเทร์ริทอรี ออสเตรเลีย",
        "id": "Northern Territory, Australia",
        "vi": "Lãnh thổ phía Bắc, Úc",
        "nl": "Noordelijk Territorium, Australië",
        "pl": "Terytorium Północne, Australia",
        "nb": "Northern Territory, Australia",
        "fi": "Northern Territory, Australia",
        "ar": "الإقليم الشمالي ، أستراليا"
    },
    {
        "value": 930,
        "prefix": "(GMT+09:30)",
        "en": "South Australia, Australia ",
        "ko": "사우스 오스트레일리아주, 호주",
        "sc": "南澳大利亚, 澳大利亚",
        "es": "Australia Meridional, Australia",
        "ru": "Южная Австралия, Австралия",
        "ja": "南オーストラリア、オーストラリア",
        "fr": "Australie-Méridionale, Australie",
        "de": "Südaustralien, Australien",
        "it": "Australia Meridionale, Australia",
        "th": "เซาท์ออสเตรเลีย, ออสเตรเลีย",
        "id": "Australia Selatan, Australia",
        "vi": "Nam Úc, Úc",
        "nl": "Zuid-Australië, Australië",
        "pl": "Australia Południowa, Australia",
        "nb": "Sør-Australia, Australia",
        "fi": "Etelä-Australia, Australia",
        "ar": "جنوب أستراليا ، أستراليا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Australian Capital Territory with Canberra capital city, Australia",
        "ko": "호주 수도권과 캔버라 주도 오스트레일리아",
        "sc": "澳大利亚首都领地与澳大利亚堪培拉首都",
        "es": "Territorio de la Capital Australiana con la ciudad capital de Canberra, Australia",
        "ru": "Австралийская столичная территория со столицей Канберра, Австралия",
        "ja": "キャンベラの首都、オーストラリアとオーストラリア首都特別地域",
        "fr": "Territoire de la capitale australienne avec la capitale Canberra, Australie",
        "de": "Australian Capital Territory mit der Hauptstadt Canberra, Australien",
        "it": "Territorio della capitale australiana con la capitale Canberra, Australia",
        "th": "ออสเตรเลียนแคพิทอลเทร์ริทอรี กับเมืองหลวง แคนเบอร์รา ประเทศออสเตรเลีย",
        "id": "Wilayah Ibu Kota Australia dengan ibu kota Canberra, Australia",
        "vi": "Lãnh thổ Thủ đô Úc với thành phố thủ đô Canberra, Úc",
        "nl": "Australisch Hoofdstedelijk Territorium met de hoofdstad van Canberra, Australië",
        "pl": "Australijskie Terytorium Stołeczne ze stolicą Canberry, Australia",
        "nb": "Australian Capital Territory med Canberra hovedstad, Australia",
        "fi": "Australian pääkaupunkialue Canberran pääkaupungin Australian kanssa",
        "ar": "إقليم العاصمة الأسترالية وعاصمة كانبرا ، أستراليا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Birobidzhan, Russia",
        "ko": "비로비잔, 러시아",
        "sc": "俄罗斯比罗比詹",
        "es": "Birobidzhán, Rusia",
        "ru": "Биробиджан, Россия",
        "ja": "ビロビジャン、ロシア",
        "fr": "Birobidjan, Russie",
        "de": "Birobidschan, Russland",
        "it": "Birobidzhan, Russia",
        "th": "Birobidzhan, รัสเซีย",
        "id": "Birobidzhan, Rusia",
        "vi": "Birobidzhan, Nga",
        "nl": "Birobidzhan, Rusland",
        "pl": "Birobidżan, Rosja",
        "nb": "Birobidzhan, Russland",
        "fi": "Birobidzhan, Venäjä",
        "ar": "بيروبيدجان ، روسيا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Guam",
        "ko": "괌",
        "sc": "关岛",
        "es": "Guam",
        "ru": "Гуам",
        "ja": "グアム",
        "fr": "Guam",
        "de": "Guam",
        "it": "Guam",
        "th": "กวม",
        "id": "Guam",
        "vi": "Guam",
        "nl": "Guam",
        "pl": "Guam",
        "nb": "Guam",
        "fi": "Guam",
        "ar": "غوام"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Khabarovsk, Russia",
        "ko": "하바롭스크, 러시아",
        "sc": "俄罗斯哈巴罗夫斯克",
        "es": "Jabárovsk, Rusia",
        "ru": "Хабаровск, Россия",
        "ja": "ハバロフスク、ロシア",
        "fr": "Khabarovsk, Russie",
        "de": "Chabarowsk, Russland",
        "it": "Khabarovsk, Russia",
        "th": "ฮาบารอฟสค์ รัสเซีย",
        "id": "Khabarovsk, Rusia",
        "vi": "Khabarovsk, Nga",
        "nl": "Chabarovsk, Rusland",
        "pl": "Chabarowsk, Rosja",
        "nb": "Khabarovsk, Russland",
        "fi": "Habarovsk, Venäjä",
        "ar": "خاباروفسك ، روسيا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "States of Chuuk and Yap, Micronesia",
        "ko": "추크, 야프, 미크로네시아",
        "sc": "Chuuk 和 Yap 州，密克罗尼西亚",
        "es": "Estados de Chuuk y Yap, Micronesia",
        "ru": "Штаты Чуук и Яп, Микронезия",
        "ja": "ミクロネシア連邦、チュウクとヤップの州",
        "fr": "États de Chuuk et Yap, Micronésie",
        "de": "Bundesstaaten Chuuk und Yap, Mikronesien",
        "it": "Stati di Chuuk e Yap, Micronesia",
        "th": "รัฐชุกและแยป ไมโครนีเซีย",
        "id": "Negara Bagian Chuuk dan Yap, Mikronesia",
        "vi": "Bang Chuuk và Yap, Micronesia",
        "nl": "Staten van Chuuk en Yap, Micronesië",
        "pl": "Stany Chuuk i Yap, Mikronezja",
        "nb": "Statene Chuuk og Yap, Mikronesia",
        "fi": "Chuukin ja Yapin osavaltiot, Mikronesia",
        "ar": "ولايتي تشوك وياب ، ميكرونيزيا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "New South Wales, Australia",
        "ko": "뉴사우스웨일즈, 호주",
        "sc": "澳大利亚新南威尔士州",
        "es": "Nueva Gales del Sur, Australia",
        "ru": "Новый Южный Уэльс, Австралия",
        "ja": "ニューサウスウェールズ、オーストラリア",
        "fr": "Nouvelle-Galles du Sud, Australie",
        "de": "New South Wales, Australien",
        "it": "Nuovo Galles del Sud, Australia",
        "th": "นิวเซาท์เวลส์ ออสเตรเลีย",
        "id": "New South Wales, Australia",
        "vi": "New South Wales, Úc",
        "nl": "Nieuw Zuid-Wales, Australië",
        "pl": "Nowa Południowa Walia, Australia",
        "nb": "New South Wales, Australia",
        "fi": "Uusi Etelä-Wales, Australia",
        "ar": "نيو ساوث ويلز ، أستراليا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Northern Mariana Islands",
        "ko": "북마리아나 제도",
        "sc": "北马里亚纳群岛",
        "es": "Islas Marianas del Norte",
        "ru": "Северные Марианские острова",
        "ja": "北マリアナ諸島",
        "fr": "Îles Mariannes du Nord",
        "de": "Nördliche Marianneninseln",
        "it": "Isole Marianne settentrionali",
        "th": "หมู่เกาะนอร์เทิร์นมาเรียนา",
        "id": "Kepulauan Mariana Utara",
        "vi": "Quần đảo Bắc Mariana",
        "nl": "noordelijke Mariana eilanden",
        "pl": "Mariany Północne",
        "nb": "Nord-Marianene",
        "fi": "Pohjois-Mariaanit",
        "ar": "جزر مريانا الشمالية"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Papua New Guinea",
        "ko": "파푸아 뉴기니",
        "sc": "巴布亚新几内亚",
        "es": "Papúa Nueva Guinea",
        "ru": "Папуа - Новая Гвинея",
        "ja": "パプアニューギニア",
        "fr": "Papouasie Nouvelle Guinée",
        "de": "Papua Neu-Guinea",
        "it": "Papua Nuova Guinea",
        "th": "ปาปัวนิวกินี",
        "id": "Papua Nugini",
        "vi": "Papua New Guinea",
        "nl": "Papoea-Nieuw-Guinea",
        "pl": "Papua Nowa Gwinea",
        "nb": "Papua Ny-Guinea",
        "fi": "Papua-Uusi-Guinea",
        "ar": "بابوا غينيا الجديدة"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Queensland, Australia",
        "ko": "퀸즐랜드, 호주",
        "sc": "澳大利亚昆士兰",
        "es": "Queensland, Australia",
        "ru": "Квинсленд, Австралия",
        "ja": "オーストラリア、クイーンズランド州",
        "fr": "Queensland, Australie",
        "de": "Queensland, Australien",
        "it": "Queensland, Australia",
        "th": "ควีนส์แลนด์ ออสเตรเลีย",
        "id": "Queensland, Australia",
        "vi": "Queensland, Úc",
        "nl": "Queensland, Australië",
        "pl": "Queensland, Australia",
        "nb": "Queensland, Australia",
        "fi": "Queensland, Australia",
        "ar": "كوينزلاند ، أستراليا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Tasmania, Australia",
        "ko": "태즈메이니아, 호주 ",
        "sc": "澳大利亚塔斯马尼亚",
        "es": "Tasmania, Australia",
        "ru": "Тасмания, Австралия",
        "ja": "タスマニア、オーストラリア",
        "fr": "Tasmanie, Australie",
        "de": "Tasmanien, Australien",
        "it": "Tasmania, Australia",
        "th": "แทสมาเนีย ออสเตรเลีย",
        "id": "Tasmania, Australia",
        "vi": "Tasmania, Úc",
        "nl": "Tasmanië, Australië",
        "pl": "Tasmania, Australia",
        "nb": "Tasmania, Australia",
        "fi": "Tasmania, Australia",
        "ar": "تسمانيا ، أستراليا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Victoria, Australia",
        "ko": "빅토리아, 호주",
        "sc": "澳大利亚维多利亚",
        "es": "Victoria, Australia",
        "ru": "Виктория, Австралия",
        "ja": "オーストラリア、ビクトリア",
        "fr": "Victoria, Australie",
        "de": "Viktoria, Australien",
        "it": "Vittoria, Australia",
        "th": "วิกตอเรีย ออสเตรเลีย",
        "id": "Victoria, Australia",
        "vi": "Victoria, Úc",
        "nl": "Victoria, Australië",
        "pl": "Wiktoria, Australia",
        "nb": "Victoria, Australia",
        "fi": "Victoria, Australia",
        "ar": "فيكتوريا ، أستراليا"
    },
    {
        "value": 1000,
        "prefix": "(GMT+10:00)",
        "en": "Vladivostok, Russia",
        "ko": "블라디보스토크, 러시아",
        "sc": "俄罗斯符拉迪沃斯托克",
        "es": "Vladivostok, Rusia",
        "ru": "Владивосток, Россия",
        "ja": "ウラジオストク、ロシア",
        "fr": "Vladivostok, Russie",
        "de": "Wladiwostok, Russland",
        "it": "Vladivostok, Russia",
        "th": "วลาดีวอสตอค รัสเซีย",
        "id": "Vladivostok, Rusia",
        "vi": "Vladivostok, Nga",
        "nl": "Vladivostok, Rusland",
        "pl": "Władywostok, Rosja",
        "nb": "Vladivostok, Russland",
        "fi": "Vladivostok, Venäjä",
        "ar": "فلاديفوستوك ، روسيا"
    },
    {
        "value": 1030,
        "prefix": "(GMT+10:30)",
        "en": "Lord Howe Island, Australia",
        "ko": "로드 하우 아일랜드, 호주",
        "sc": "澳大利亚豪勋爵岛",
        "es": "Isla de Lord Howe, Australia",
        "ru": "Остров Лорд-Хау, Австралия",
        "ja": "ロードハウ島、オーストラリア",
        "fr": "Île Lord Howe, Australie",
        "de": "Lord-Howe-Insel, Australien",
        "it": "Isola di Lord Howe, Australia",
        "th": "เกาะลอร์ดโฮวี ออสเตรเลีย",
        "id": "Pulau Lord Howe, Australia",
        "vi": "Đảo Lord Howe, Úc",
        "nl": "Lord Howe Island, Australië",
        "pl": "Wyspa Lorda Howe, Australia",
        "nb": "Lord Howe Island, Australia",
        "fi": "Lord Howe Island, Australia",
        "ar": "جزيرة لورد هاو ، أستراليا"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Macquarie Island, Australia",
        "ko": "맥쿼리 아일랜드, 호주",
        "sc": "澳大利亚麦格理岛",
        "es": "Isla Macquarie, Australia",
        "ru": "Остров Маккуори, Австралия",
        "ja": "マッコーリー島、オーストラリア",
        "fr": "Île Macquarie, Australie",
        "de": "Macquarie-Insel, Australien",
        "it": "Isola di Macquarie, Australia",
        "th": "Macquarie Island, ออสเตรเลีย",
        "id": "Pulau Macquarie, Australia",
        "vi": "Đảo Macquarie, Úc",
        "nl": "Macquarie Island, Australië",
        "pl": "Wyspa Macquarie, Australia",
        "nb": "Macquarie Island, Australia",
        "fi": "Macquarie Island, Australia",
        "ar": "جزيرة ماكواري ، أستراليا"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Magadan, Russia",
        "ko": "마가단, 러시아",
        "sc": "俄罗斯马加丹",
        "es": "Magadán, Rusia",
        "ru": "Магадан, Россия",
        "ja": "マガダン、ロシア",
        "fr": "Magadan, Russie",
        "de": "Magadan, Russland",
        "it": "Magadan, Russia",
        "th": "มากาดาน รัสเซีย",
        "id": "Magadan, Rusia",
        "vi": "Magadan, Nga",
        "nl": "Magadan, Rusland",
        "pl": "Magadan, Rosja",
        "nb": "Magadan, Russland",
        "fi": "Magadan, Venäjä",
        "ar": "ماجادان ، روسيا"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Micronesia, states of Kosrae and Pohnpei",
        "ko": "미크로네시아, 코스라에 주와 폰페이 주",
        "sc": "密克罗尼西亚、科斯雷州和波纳佩州",
        "es": "Micronesia, estados de Kosrae y Pohnpei",
        "ru": "Микронезия, штаты Косраэ и Понпеи",
        "ja": "ミクロネシア、コスラエ島とポンペイ州",
        "fr": "Micronésie, états de Kosrae et Pohnpei",
        "de": "Mikronesien, Bundesstaaten Kosrae und Pohnpei",
        "it": "Micronesia, stati di Kosrae e Pohnpei",
        "th": "ไมโครนีเซีย รัฐคอสแรและโปนเป",
        "id": "Mikronesia, negara bagian Kosrae dan Pohnpei",
        "vi": "Micronesia, các bang Kosrae và Pohnpei",
        "nl": "Micronesië, staten Kosrae en Pohnpei",
        "pl": "Mikronezja, stany Kosrae i Pohnpei",
        "nb": "Mikronesia, delstatene Kosrae og Pohnpei",
        "fi": "Mikronesia, Kosraen ja Pohnpein osavaltiot",
        "ar": "ولايات ميكرونيزيا كوسراي وبوهنباي"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "New Caledonia",
        "ko": "뉴 칼레도니아",
        "sc": "新喀里多尼亚",
        "es": "Nueva Caledonia",
        "ru": "Новая Каледония",
        "ja": "ニューカレドニア",
        "fr": "Nouvelle Calédonie",
        "de": "Neu-Kaledonien",
        "it": "Nuova Caledonia",
        "th": "นิวแคลิโดเนีย",
        "id": "Kaledonia Baru",
        "vi": "New Caledonia",
        "nl": "Nieuw-Caledonië",
        "pl": "Nowa Kaledonia",
        "nb": "Ny Caledonia",
        "fi": "Uusi-Caledonia",
        "ar": "كاليدونيا الجديدة"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Norfolk Island",
        "ko": "노퍽 섬",
        "sc": "诺福克岛",
        "es": "Isla Norfolk",
        "ru": "Остров Норфолк",
        "ja": "ノーフォーク島",
        "fr": "l'ile de Norfolk",
        "de": "Norfolkinsel",
        "it": "Isola Norfolk",
        "th": "เกาะนอร์ฟอล์ก",
        "id": "Pulau Norfolk",
        "vi": "Đảo Norfolk",
        "nl": "Norfolkeiland",
        "pl": "Wyspa Norfolk",
        "nb": "Norfolkøya",
        "fi": "Norfolkin saari",
        "ar": "جزيرة نورفولك"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Papua New Guinea, Bougainville Island",
        "ko": "파푸아뉴기니, 부겐빌 아일랜드",
        "sc": "巴布亚新几内亚，布干维尔岛",
        "es": "Papua Nueva Guinea, Isla Bougainville",
        "ru": "Папуа-Новая Гвинея, остров Бугенвиль",
        "ja": "パプアニューギニア、ブーゲンビル島",
        "fr": "Papouasie-Nouvelle-Guinée, île de Bougainville",
        "de": "Papua-Neuguinea, Bougainville-Insel",
        "it": "Papua Nuova Guinea, isola di Bougainville",
        "th": "ปาปัวนิวกินี เกาะบูเกนวิลล์",
        "id": "Papua Nugini, Pulau Bougainville",
        "vi": "Papua New Guinea, Đảo Bougainville",
        "nl": "Papoea-Nieuw-Guinea, Bougainville Island",
        "pl": "Papua Nowa Gwinea, wyspa Bougainville",
        "nb": "Papua Ny-Guinea, Bougainville-øya",
        "fi": "Papua-Uusi-Guinea, Bougainville Island",
        "ar": "بابوا غينيا الجديدة ، جزيرة بوغانفيل"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Solomon Islands",
        "ko": "솔로몬 제도",
        "sc": "所罗门群岛",
        "es": "Islas Salomón",
        "ru": "Соломоновы острова",
        "ja": "ソロモン諸島",
        "fr": "îles Salomon",
        "de": "Salomon-Inseln",
        "it": "Isole Salomone",
        "th": "หมู่เกาะโซโลมอน",
        "id": "Pulau Solomon",
        "vi": "Quần đảo Solomon",
        "nl": "Solomon eilanden",
        "pl": "Wyspy Salomona",
        "nb": "Solomon øyene",
        "fi": "Solomonsaaret",
        "ar": "جزر سليمان"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Vanuatu",
        "ko": "바누아투",
        "sc": "瓦努阿图",
        "es": "Vanuatu",
        "ru": "Вануату",
        "ja": "バヌアツ",
        "fr": "Vanuatu",
        "de": "Vanuatu",
        "it": "Vanuatu",
        "th": "วานูอาตู",
        "id": "Vanuatu",
        "vi": "Vanuatu",
        "nl": "Vanuatu",
        "pl": "Vanuatu",
        "nb": "Vanuatu",
        "fi": "Vanuatu",
        "ar": "فانواتو"
    },
    {
        "value": 1100,
        "prefix": "(GMT+11:00)",
        "en": "Yuzhno-Sakhalinsk, Russia",
        "ko": "유즈노사할린스크, 러시아 ",
        "sc": "俄罗斯南萨哈林斯克",
        "es": "Yuzhno-Sakhalinsk, Rusia",
        "ru": "Южно-Сахалинск, Россия",
        "ja": "ユジノサハリンスク、ロシア",
        "fr": "Ioujno-Sakhalinsk, Russie",
        "de": "Juschno-Sachalinsk, Russland",
        "it": "Yuzhno-Sakhalinsk, Russia",
        "th": "Yuzhno-Sakhalinsk, รัสเซีย",
        "id": "Yuzhno-Sakhalinsk, Rusia",
        "vi": "Yuzhno-Sakhalinsk, Nga",
        "nl": "Joezjno-Sachalinsk, Rusland",
        "pl": "Jużno-Sachalińsk, Rosja",
        "nb": "Yuzhno-Sakhalinsk, Russland",
        "fi": "Yuzhno-Sakhalinsk, Venäjä",
        "ar": "يوجنو ساخالينسك ، روسيا"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Anadyr, Russia",
        "ko": "아나디르, 러시아 ",
        "sc": "俄罗斯阿纳德尔",
        "es": "Anádyr, Rusia",
        "ru": "Анадырь, Россия",
        "ja": "アナディル、ロシア",
        "fr": "Anadyr, Russie",
        "de": "Anadyr, Russland",
        "it": "Anadyr, Russia",
        "th": "Anadyr, รัสเซีย",
        "id": "Anadyr, Rusia",
        "vi": "Anadyr, Nga",
        "nl": "Anadyr, Rusland",
        "pl": "Anadyr, Rosja",
        "nb": "Anadyr, Russland",
        "fi": "Anadyr, Venäjä",
        "ar": "أنادير ، روسيا"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Fiji",
        "ko": "피지",
        "sc": "斐济",
        "es": "Fiyi",
        "ru": "Фиджи",
        "ja": "フィジー",
        "fr": "Fidji",
        "de": "Fidschi",
        "it": "Figi",
        "th": "ฟิจิ",
        "id": "Fiji",
        "vi": "Fiji",
        "nl": "Fiji",
        "pl": "Fidżi",
        "nb": "Fiji",
        "fi": "Fidži",
        "ar": "فيجي"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Gilbert Islands, Kiribati",
        "ko": "길버트 제도, 키리바시",
        "sc": "吉尔伯特群岛，基里巴斯",
        "es": "Islas Gilbert, Kiribati",
        "ru": "Острова Гилберта, Кирибати",
        "ja": "キリバスのギルバート諸島",
        "fr": "Îles Gilbert, Kiribati",
        "de": "Gilbert-Inseln, Kiribati",
        "it": "Isole Gilbert, Kiribati",
        "th": "หมู่เกาะกิลเบิร์ต คิริบาส",
        "id": "Kepulauan Gilbert, Kiribati",
        "vi": "Quần đảo Gilbert, Kiribati",
        "nl": "Gilbert-eilanden, Kiribati",
        "pl": "Wyspy Gilberta, Kiribati",
        "nb": "Gilbertøyene, Kiribati",
        "fi": "Gilbertin saaret, Kiribati",
        "ar": "جزر جيلبرت ، كيريباتي"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Marshall Islands",
        "ko": "마셜 제도",
        "sc": "马绍尔群岛",
        "es": "Islas Marshall",
        "ru": "Маршалловы острова",
        "ja": "マーシャル諸島",
        "fr": "Iles Marshall",
        "de": "Marshallinseln",
        "it": "Isole Marshall",
        "th": "หมู่เกาะมาร์แชลล์",
        "id": "Pulau Marshall",
        "vi": "đảo Marshall",
        "nl": "Marshall eilanden",
        "pl": "Wyspy Marshalla",
        "nb": "Marshalløyene",
        "fi": "Marshallsaaret",
        "ar": "جزر مارشال"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Nauru",
        "ko": "나우루",
        "sc": "瑙鲁",
        "es": "Nauru",
        "ru": "Науру",
        "ja": "ナウル",
        "fr": "Nauru",
        "de": "Nauru",
        "it": "Nauru",
        "th": "นาอูรู",
        "id": "Nauru",
        "vi": "Nauru",
        "nl": "Nauru",
        "pl": "Nauru",
        "nb": "Nauru",
        "fi": "Nauru",
        "ar": "ناورو"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "New Zealand",
        "ko": "뉴질랜드",
        "sc": "新西兰",
        "es": "Nueva Zelanda",
        "ru": "Новая Зеландия",
        "ja": "ニュージーランド",
        "fr": "Nouvelle-Zélande",
        "de": "Neuseeland",
        "it": "Nuova Zelanda",
        "th": "นิวซีแลนด์",
        "id": "Selandia Baru",
        "vi": "New Zealand",
        "nl": "Nieuw-Zeeland",
        "pl": "Nowa Zelandia",
        "nb": "New Zealand",
        "fi": "Uusi Seelanti",
        "ar": "نيوزيلاندا"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Petropavlovsk-Kamchatsky, Russia",
        "ko": "페트로파블롭스크-캄차츠키, 러시아 ",
        "sc": "俄罗斯堪察加彼得罗巴甫洛夫斯克",
        "es": "Petropavlovsk-Kamchatsky, Rusia",
        "ru": "Петропавловск-Камчатский, Россия",
        "ja": "ペトロパブロフスク-カムチャツキー、ロシア",
        "fr": "Petropavlovsk-Kamtchatski, Russie",
        "de": "Petropawlowsk-Kamtschatski, Russland",
        "it": "Petropavlovsk-Kamchatsky, Russia",
        "th": "ปิตราปัฟลัฟสค์-คัมชัตสกี รัสเซีย",
        "id": "Petropavlovsk-Kamchatsky, Rusia",
        "vi": "Petropavlovsk-Kamchatsky, Nga",
        "nl": "Petropavlovsk-Kamchatsky, Rusland",
        "pl": "Pietropawłowsk Kamczacki, Rosja",
        "nb": "Petropavlovsk-Kamchatsky, Russland",
        "fi": "Petropavlovsk-Kamchatsky, Venäjä",
        "ar": "بتروبافلوفسك كامتشاتسكي ، روسيا"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Tuvalu",
        "ko": "투발루",
        "sc": "图瓦卢",
        "es": "Tuvalu",
        "ru": "Тувалу",
        "ja": "ツバル",
        "fr": "Tuvalu",
        "de": "Tuvalu",
        "it": "Tuvalù",
        "th": "ตูวาลู",
        "id": "Tuvalu",
        "vi": "Tuvalu",
        "nl": "Tuvalu",
        "pl": "Tuvalu",
        "nb": "Tuvalu",
        "fi": "Tuvalu",
        "ar": "توفالو"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Wake Island ",
        "ko": "웨이크 아일랜드",
        "sc": "威克岛",
        "es": "Isla Wake",
        "ru": "Остров Уэйк",
        "ja": "ウェーク島",
        "fr": "Île Wake",
        "de": "Wake-Insel",
        "it": "Wake Island",
        "th": "เกาะเวก",
        "id": "Pulau Bangun",
        "vi": "Đảo Wake",
        "nl": "Wake Island",
        "pl": "Wyspa Wake",
        "nb": "Wake Island",
        "fi": "Waken saari",
        "ar": "جزيرة ويك"
    },
    {
        "value": 1200,
        "prefix": "(GMT+12:00)",
        "en": "Wallis and Futuna ",
        "ko": "월리스와 푸투나",
        "sc": "瓦利斯和富图纳",
        "es": "Wallis y Futuna",
        "ru": "Уоллис и Футуна",
        "ja": "ウォリス・フツナ",
        "fr": "Wallis et Futuna",
        "de": "Wallis und Futuna",
        "it": "Wallis e Futuna",
        "th": "วาลลิสและฟุตูนา",
        "id": "Wallis dan Futuna",
        "vi": "Wallis và Futuna",
        "nl": "Wallis en Futuna",
        "pl": "Wallis i Futuna",
        "nb": "Wallis og Futuna",
        "fi": "Wallis ja Futuna",
        "ar": "واليس وفوتونا"
    },
    {
        "value": 1300,
        "prefix": "(GMT+13:00)",
        "en": "Phoenix Islands, Kiribati",
        "ko": "피닉스 제도, 키리바시",
        "sc": "菲尼克斯群岛，基里巴斯",
        "es": "Islas Fénix, Kiribati",
        "ru": "Острова Феникс, Кирибати",
        "ja": "フェニックス諸島、キリバス",
        "fr": "Îles Phoenix, Kiribati",
        "de": "Phoenix-Inseln, Kiribati",
        "it": "Isole Phoenix, Kiribati",
        "th": "หมู่เกาะฟีนิกซ์ คิริบาส",
        "id": "Kepulauan Phoenix, Kiribati",
        "vi": "Quần đảo Phoenix, Kiribati",
        "nl": "Phoenix-eilanden, Kiribati",
        "pl": "Wyspy Phoenix, Kiribati",
        "nb": "Phoenix-øyene, Kiribati",
        "fi": "Phoenix-saaret, Kiribati",
        "ar": "جزر فينيكس ، كيريباتي"
    },
    {
        "value": 1300,
        "prefix": "(GMT+13:00)",
        "en": "Samoa",
        "ko": "사모아",
        "sc": "萨摩亚",
        "es": "samoa",
        "ru": "Самоа",
        "ja": "サモア",
        "fr": "Samoa",
        "de": "Samoa",
        "it": "Samoa",
        "th": "ซามัว",
        "id": "Samoa",
        "vi": "Samoa",
        "nl": "Samoa",
        "pl": "Samoa",
        "nb": "Samoa",
        "fi": "Samoa",
        "ar": "ساموا"
    },
    {
        "value": 1300,
        "prefix": "(GMT+13:00)",
        "en": "Tokelau",
        "ko": "토켈라우",
        "sc": "托克劳",
        "es": "Tokelau",
        "ru": "Токелау",
        "ja": "トケラウ",
        "fr": "Tokélaou",
        "de": "Tokelau",
        "it": "Tokelau",
        "th": "โตเกเลา",
        "id": "Tokelau",
        "vi": "Tokelau",
        "nl": "Tokelau",
        "pl": "Tokelau",
        "nb": "Tokelau",
        "fi": "Tokelau",
        "ar": "توكيلاو"
    }
]


export default TimeZoneCoutries;
